// // import React, { useState, useRef, useEffect } from "react";
// // import { Helmet } from "react-helmet";
// // import { Galleria } from "primereact/galleria";
// // import { toast } from "react-toastify";
// // import axios from "axios";
// // import Header from "../components/Header";
// // import Footer from "../components/Footer";
// // import { URLS } from "../Url";
// // import CouponSection from "../components/Coupons";
// // import PopupModal from "../components/PopUpModal";
// // import PaymentSection from "../components/PaymentSection";

// // const C = {
// //   primary: "#5E0E73",
// //   primaryLight: "#6E1A85",
// //   primaryPale: "#F3E5F7",
// //   cream: "#E8E1D6",
// //   beige: "#D6CFC4",
// //   gold: "#C9A84C",
// //   goldLight: "#E8D5A0",
// //   dark: "#1A0030",
// //   dark2: "#120020",
// // };

// // const BIRTHDAY_THEMES = [
// //   { name: "Cosmic Adventure", bookings: "412 bookings", tags: ["Space", "Adventure", "Fun"], img: "https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80" },
// //   { name: "Enchanted Forest", bookings: "356 bookings", tags: ["Magic", "Fantasy", "Enchanted"], img: "/assets/img/enchanted-forest.jpg" },
// //   { name: "Tropical Paradise", bookings: "289 bookings", tags: ["Tropical", "Beach", "Paradise"], img: "https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=600&q=80" },
// //   { name: "Movie Night", bookings: "445 bookings", tags: ["Cinema", "Blockbuster", "Fun"], img: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&q=80" },
// //   { name: "Carnival Fiesta", bookings: "523 bookings", tags: ["Party", "Carnival", "Festive"], img: "https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80" },
// //   { name: "Retro Throwback", bookings: "267 bookings", tags: ["Retro", "Classic", "Nostalgia"], img: "https://images.unsplash.com/photo-1509805735646-2f72b3272a7d?q=80" },
// // ];

// // const BIRTHDAY_PACKAGES = [
// //   {
// //     name: "Mini Celebration",
// //     price: "₹7,999",
// //     duration: "3 hours",
// //     tier: "01",
// //     badge: "Save ₹200",
// //     color: "#C9A84C",
// //     features: ["✓ Basic Decor Setup", "✓ Cake & Snacks", "✓ Simple Games", "✓ Photography"],
// //   },
// //   {
// //     name: "Birthday Bash",
// //     price: "₹12,999",
// //     duration: "5 hours",
// //     tier: "02",
// //     badge: "★ Guests Favourite",
// //     isFeatured: true,
// //     color: "#E85D75",
// //     features: ["✓ Premium Decor", "✓ Multi-course Snacks", "✓ DJ & Music", "✓ Photo + Video", "✓ Games & Activities"],
// //   },
// //   {
// //     name: "Royal Birthday",
// //     price: "₹19,999",
// //     duration: "7 hours",
// //     tier: "03",
// //     badge: "Save ₹300",
// //     color: "#D4AF37",
// //     features: ["✓ Luxury Decor Theme", "✓ Gourmet Catering", "✓ DJ + LED Setup", "✓ Professional Crew", "✓ Customized Programs", "✓ Memory Album"],
// //   },
// // ];

// // const BIRTHDAY_FAQ = [
// //   { q: "Can I customize the celebration?", a: "Yes! Our team can work with you on customized themes, decorations, food, and entertainment options." },
// //   { q: "How far in advance should I book?", a: "We recommend booking 2-3 weeks prior for better theme and slot availability." },
// //   { q: "Can we customize the menu?", a: "Yes! Our team can work with you on customized food options and dietary requirements." },
// //   { q: "Do you provide entertainment?", a: "Yes! We offer DJs, games, activities, and entertainment depending on the package." },
// // ];

// // const BIRTHDAY_TESTIMONIALS = [
// //   { name: "Sakshi's Party", rating: 5, text: "The Enchanted Forest celebration was magical! The decorations were beautiful, the games were so fun, and everyone had an amazing time. Thank you Carnival Castle!", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80" },
// //   { name: "Rahul's Celebration", rating: 5, text: "The Movie Night theme was absolutely perfect! Professional setup, great DJ, awesome activities, and the videographer captured all the fun moments beautifully.", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80" },
// //   { name: "Priya's Birthday Bash", rating: 5, text: "Our celebration was incredible! Carnival Castle created the perfect vibe with amazing decor, great food, and fantastic entertainment. Highly recommended!", img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80" },
// // ];

// // const BIRTHDAY_PROCESS = [
// //   { step: 1, title: "Pick a Theme", desc: "Choose from 6 amazing themes or create your own", icon: "🎨" },
// //   { step: 2, title: "Select Package", desc: "Pick the duration and features that fit your needs", icon: "🎂" },
// //   { step: 3, title: "Customize Everything", desc: "Personalize games, food, music, and decorations", icon: "🎈" },
// //   { step: 4, title: "Celebrate!", desc: "We'll handle setup while you celebrate with loved ones", icon: "🎉" },
// // ];

// // const BIRTHDAY_ADDONS = [
// //   { name: "Professional DJ", price: "₹6,999", icon: "🎵", desc: "Full DJ service with dance floor" },
// //   { name: "Deluxe Cake", price: "₹3,999", icon: "🍰", desc: "Custom designed birthday cake" },
// //   { name: "Photo Booth", price: "₹4,999", icon: "📸", desc: "Instant prints & digital copies" },
// //   { name: "Character Appearance", price: "₹5,999", icon: "🦸", desc: "Popular character meet & greet" },
// //   { name: "Premium Decor", price: "₹4,999", icon: "✨", desc: "Luxury balloons & props setup" },
// //   { name: "Video Highlight", price: "₹3,999", icon: "🎬", desc: "Edited birthday video reel" },
// // ];

// // const BIRTHDAY_WHYCHOOSE = [
// //   { icon: "🎂", title: "Celebration Experts", desc: "We've hosted 4000+ amazing celebrations" },
// //   { icon: "👥", title: "For Everyone", desc: "Customized entertainment for all preferences" },
// //   { icon: "⭐", title: "Premium Quality", desc: "Professional, safe, and memorable experiences" },
// //   { icon: "💰", title: "Best Value", desc: "Premium celebration at great prices" },
// // ];

// // const BIRTHDAY_GALLERY = [
// //   { thumb: "https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80", full: "https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=1200&q=80" },
// //   { thumb: "https://images.unsplash.com/photo-1551892644-51a6e2e8fc65?q=80", full: "https://images.unsplash.com/photo-1551892644-51a6e2e8fc65?q=80" },
// //   { thumb: "https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=600&q=80", full: "https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=1200&q=80" },
// //   { thumb: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&q=80", full: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=1200&q=80" },
// //   { thumb: "https://images.unsplash.com/photo-1560173045-beaf11c65dce?q=80", full: "https://images.unsplash.com/photo-1560173045-beaf11c65dce?q=80" },
// //   { thumb: "https://images.unsplash.com/photo-1482731910308-31e96e5d1d28?q=80", full: "https://images.unsplash.com/photo-1482731910308-31e96e5d1d28?q=80" },
// // ];

// // const BIRTHDAY_REELS = [
// //   { id: 1, name: "Fun Party", event: "Kids Birthday", theme: "Carnival", img: "https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80", video: "/assets/videos/video1.mp4" },
// //   { id: 2, name: "Cake Smash", event: "1st Birthday", theme: "Cute", img: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800&q=80", video: "/assets/videos/video2.mp4" },
// //   { id: 3, name: "DJ Night", event: "Teen Party", theme: "Music", img: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80", video: "/assets/videos/video3.mp4" },
// //   { id: 4, name: "Family Celebration", event: "Classic", theme: "Family", img: "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?w=800&q=80", video: "/assets/videos/video4.mp4" },
// //   { id: 5, name: "Themed Birthday", event: "Adventure Party", theme: "Adventure", img: "https://images.unsplash.com/photo-1759607574688-af5711054087?q=80", video: "/assets/videos/video5.mp4" },
// //   { id: 6, name: "Grand Celebration", event: "Milestone Birthday", theme: "Premium", img: "https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=800&q=80", video: "/assets/videos/video6.mp4" },
// // ];

// // export default function BirthdayCelebrationPage() {
// //   const [activeGal, setActiveGal] = useState(null);
// //   const [form, setForm] = useState({ name: "", email: "", phone: "", date: "", message: "" });
// //   const [visibleThemes, setVisibleThemes] = useState(new Set());
// //   const [themeHover, setThemeHover] = useState(false);
// //   const galleria = useRef(null);
// //   const themeCarouselRef = useRef(null);
// //   const [animatedElements, setAnimatedElements] = useState(new Set());
// //   const containerRef = useRef(null);
// //   const [reelIdx, setReelIdx] = useState(0);
// //   const [reelHover, setReelHover] = useState(false);
// //   const [playingReel, setPlayingReel] = useState(null);
// //   const videoRef = useRef(null);

// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         entries.forEach((entry) => {
// //           if (entry.isIntersecting) {
// //             entry.target.classList.add('animate-visible');
// //             setAnimatedElements((prev) => new Set([...prev, entry.target.id]));
// //             observer.unobserve(entry.target);
// //           }
// //         });
// //       },
// //       { threshold: 0.1 }
// //     );

// //     const container = containerRef.current;
// //     if (container) {
// //       const elements = container.querySelectorAll('[data-animate]');
// //       elements.forEach((el) => observer.observe(el));
// //     }

// //     return () => observer.disconnect();
// //   }, []);

// //   useEffect(() => {
// //   if (!reelHover) {
// //     const interval = setInterval(() => {
// //       setReelIdx((i) => (i + 1) % BIRTHDAY_REELS.length);
// //     }, 4000);

// //     return () => clearInterval(interval);
// //   }
// //   }, [reelHover]);

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     if (!form.name || !form.email || !form.phone) {
// //       toast.error("Please fill all fields");
// //       return;
// //     }
// //     toast.success("Enquiry submitted! We'll contact you soon.");
// //     setForm({ name: "", email: "", phone: "", date: "", message: "" });
// //   };

// //   return (
// //     <>
// //       <Helmet>
// //         <title>Birthday Celebrations | Carnival Castle</title>
// //         <meta name="description" content="Create magical birthday celebrations with 20+ themes, expert planning, and unforgettable memories." />
// //       </Helmet>

// //       <Header />

// //       <style>{`
// //         :root { --p: #5E0E73; --pl: #6E1A85; --pp: #F3E5F7; --c: #E8E1D6; --b: #D6CFC4; --gold: #C9A84C; --gb: #E8D5A0; --dark: #1A0030; --d2: #120020; }
// //         *{font-family:'DM Sans',sans-serif;}
// //         .pf{font-family:'Playfair Display',serif!important;}
// //         .cc-tag{display:block;font-size:11px;font-weight:700;color:var(--gold);text-transform:uppercase;letter-spacing:3px;margin-bottom:10px;text-align:center;}
// //         .cc-tag-light{color:rgba(201,168,76,.8);}
// //         .bc-hero{background:linear-gradient(135deg,rgba(94,14,115,.7),rgba(255,193,7,.6)),url('https://images.unsplash.com/photo-1514728263952-84ea256f9679?w=1200&q=80') center/cover;padding:clamp(60px,12vw,120px) 20px;text-align:center;color:#fff;}
// //         .bc-hero h1{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 4px 24px rgba(0,0,0,.3);}
// //         .bc-hero p{font-size:clamp(16px,2vw,22px);color:rgba(255,255,255,.9);}
// //         .bc-sec{padding:clamp(40px,8vw,80px) 20px;}
// //         .container{max-width:1200px;margin:0 auto;}
// //         .section-title{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;text-align:center;margin-bottom:40px;color:var(--dark);}
// //         .section-title .gold{color:var(--gold)!important;}
// //         .theme-carousel{display:flex;gap:18px;overflow-x:auto;padding:20px 0 10px;scroll-snap-type:x mandatory;-ms-overflow-style:none;scrollbar-width:none;}
// //         .theme-carousel::-webkit-scrollbar{display:none;}
// //         .theme-card{flex-shrink:0;width:240px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s;scroll-snap-align:center;}
// //         .theme-card:hover{transform:translateY(-12px);box-shadow:0 24px 60px rgba(94,14,115,.3);}
// //         .theme-card img{width:100%;height:200px;object-fit:cover;display:block;transition:transform .6s cubic-bezier(.25,1,.5,1);}
// //         .theme-card:hover img{transform:scale(1.08);}
// //         .theme-card-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.98),rgba(26,0,48,.5),transparent);display:flex;flex-direction:column;justify-content:flex-end;padding:18px;}
// //         .theme-card-name{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;color:#fff;margin-bottom:4px;}
// //         .theme-card-bookings{font-size:12px;color:rgba(255,255,255,.7);}
// //         .pkg-grid{display:flex;align-items:center;justify-content:center;gap:28px;flex-wrap:wrap;max-width:1100px;margin:0 auto;}
// //         .pkg-card{border-radius:26px;overflow:hidden;background:#fff;box-shadow:0 6px 24px rgba(94,14,115,.1);transition:all .4s cubic-bezier(.25,1,.5,1);cursor:pointer;position:relative;padding:28px;flex:0 1 320px;display:flex;flex-direction:column;}
// //         .pkg-card.featured{flex:0 1 360px;transform:scale(1.05);box-shadow:0 24px 56px rgba(94,14,115,.25);border:2px solid var(--gold);}
// //         .pkg-card.featured:hover{transform:scale(1.07);}
// //         .pkg-card h3{font-family:'Playfair Display',serif;font-size:clamp(18px,3vw,24px);font-weight:700;margin:0 0 12px;}
// //         .pkg-card:hover{transform:translateY(-12px);box-shadow:0 24px 56px rgba(94,14,115,.2);}
// //         .pkg-card.featured:hover{box-shadow:0 28px 64px rgba(94,14,115,.3);}
// //         .pkg-tier{position:absolute;top:14px;right:16px;font-family:'Playfair Display',serif;font-size:48px;font-weight:700;line-height:1;color:rgba(94,14,115,.08);pointer-events:none;user-select:none;}
// //         .pkg-badge{display:inline-flex;align-items:center;gap:4px;font-size:9.5px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:6px 12px;border-radius:999px;margin-bottom:12px;width:fit-content;background:rgba(94,14,115,.08);border:1px solid rgba(94,14,115,.15);color:#5E0E73;}
// //         .pkg-card.featured .pkg-badge{background:linear-gradient(135deg,#B8860B,var(--gold),#E8D5A0);border:none;color:#fff;box-shadow:0 4px 12px rgba(201,168,76,.3);}
// //         .pkg-price{font-family:'Playfair Display',serif;font-size:clamp(2rem,4vw,2.8rem);font-weight:900;margin:16px 0;}
// //         .pkg-feature{text-align:left;padding:10px 0;font-size:14px;color:#333;font-family:'DM Sans',sans-serif;}
// //         .pkg-btn{background:linear-gradient(135deg,#B8860B,var(--gold),var(--gb),var(--gold),#9A6E10);background-size:200% 200%;animation:_goldBg 3s ease infinite;color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;box-shadow:0 6px 20px rgba(201,168,76,.45);text-decoration:none;display:flex;align-items:center;justify-content:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .3s,box-shadow .3s;width:100%;margin-top:20px;position:relative;overflow:hidden;}
// //         .pkg-btn::before{content:'';position:absolute;top:0;left:-100%;width:55%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:_shine 3s ease infinite;}
// //         .pkg-btn:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(201,168,76,.55);}
// //         @media(max-width:768px){
// //           .bc-hero{padding:50px 16px 30px!important;}
// //           .bc-hero h1{font-size:clamp(24px,5vw,36px)!important;}
// //           .bc-hero p{font-size:clamp(13px,3vw,15px)!important;}
// //           .bc-sec{padding:30px 16px!important;}
// //           .section-title{font-size:clamp(20px,4vw,28px)!important;margin-bottom:20px;}
// //           /* Responsive form layout */
// //           .enq-wrap>div{grid-template-columns:1fr!important;}
// //           .enq-left{padding:20px 16px!important;order:1;}
// //           .enq-right{padding:20px 16px!important;order:2;}
// //           .theme-carousel{gap:10px;padding:10px 0}
// //           .theme-card{width:160px;}
// //           .pkg-grid{gap:12px;flex-direction:column;align-items:stretch;}
// //           .pkg-card{flex:0 1 auto;flex-basis:100%;padding:18px;}
// //           .pkg-card.featured{flex:0 1 auto;transform:scale(1);box-shadow:0 12px 30px rgba(94,14,115,.15);}
// //           .pkg-card.featured:hover{transform:translateY(-6px);box-shadow:0 16px 40px rgba(94,14,115,.2);}
// //           .pkg-price{font-size:clamp(1.6rem,3vw,2rem);}
// //           .pkg-feature{font-size:12px;padding:6px 0;}
// //           .pkg-btn{font-size:12px;padding:10px 16px;}
// //           .testimonial-grid{grid-template-columns:1fr;}
// //           .testimonial-card{padding:16px;}
// //           .addon-grid{grid-template-columns:repeat(2,1fr);gap:10px;}
// //           .addon-card{padding:12px;}
// //           .addon-icon{font-size:28px;}
// //           .addon-name{font-size:11px;}
// //           .addon-price{font-size:13px;}
// //           .gallery-grid{grid-template-columns:repeat(2,1fr);gap:10px;}
// //           .gallery-item img{height:140px;}
// //           .stats-container{grid-template-columns:repeat(2,1fr);gap:12px;}
// //           .stat-number{font-size:clamp(24px,4vw,36px);}
// //           .stat-label{font-size:11px;}
// //           .process-step{margin-bottom:16px;}
// //           .process-icon{width:56px;height:56px;font-size:26px;}
// //           .enq-wrap{display:flex;flex-direction:column!important;}
// //           .enq-left{padding:24px 16px!important;order:2;}
// //           .enq-right{padding:20px 16px!important;order:1;}
// //           .whychoose-grid{grid-template-columns:1fr;}
// //         }
// //         @media(max-width:640px){
// //           .bc-sec{padding:24px 12px!important;}
// //           .bc-hero{padding:40px 12px 24px!important;}
// //           .bc-hero h1{font-size:clamp(20px,5vw,28px)!important;}
// //           .bc-hero p{font-size:12px;}
// //           .container{padding:0 12px;}
// //           .cc-tag{font-size:8.5px;padding:4px 10px;}
// //           .section-title{font-size:clamp(18px,4vw,22px)!important;margin-bottom:14px;}
// //           .theme-carousel{gap:8px;padding:6px 0;}
// //           .theme-card{width:130px;}
// //           .theme-card img{height:110px;}
// //           .pkg-card{padding:14px;flex-basis:100%;}
// //           .pkg-tier{font-size:36px;}
// //           .pkg-price{font-size:clamp(1.3rem,2.5vw,1.6rem);}
// //           .pkg-feature{font-size:11px;padding:4px 0;}
// //           .pkg-btn{font-size:11px;padding:9px 14px;}
// //           .testimonial-card{padding:12px;border-radius:12px;}
// //           .testimonial-avatar{width:38px;height:38px;}
// //           .testimonial-name{font-size:13px;}
// //           .testimonial-text{font-size:11px;line-height:1.5;}
// //           .addon-grid{grid-template-columns:1fr;gap:8px;}
// //           .addon-card{padding:10px;}
// //           .addon-icon{font-size:24px;}
// //           .addon-name{font-size:10px;}
// //           .addon-price{font-size:12px;}
// //           .addon-desc{font-size:9px;}
// //           .whychoose-card{padding:16px;border-radius:14px;}
// //           .whychoose-icon{font-size:32px;margin-bottom:12px;}
// //           .whychoose-title{font-size:14px;}
// //           .whychoose-desc{font-size:12px;line-height:1.4;}
// //           .gallery-grid{grid-template-columns:1fr;gap:8px;}
// //           .gallery-item img{height:120px;}
// //           .stats-container{grid-template-columns:1fr;gap:10px;padding:10px 0;}
// //           .stat-item{padding:10px;margin:0 -12px;}
// //           .stat-number{font-size:clamp(18px,3.5vw,28px);}
// //           .stat-label{font-size:9px;}
// //           .process-timeline::before{display:none;}
// //           .process-step{text-align:center;margin-bottom:12px;}
// //           .process-icon{width:48px;height:48px;font-size:22px;}
// //           .process-title{font-size:13px;margin-bottom:6px;}
// //           .process-desc{font-size:11px;}
// //           .faq-item{padding:12px;margin-bottom:8px;border-radius:10px;}
// //           .faq-q{font-size:13px;}
// //           .faq-a{font-size:11px;}
// //           .enq-wrap{border-radius:16px;padding:0!important;}
// //           .enq-wrap>div{grid-template-columns:1fr!important;}
// //           .enq-left{padding:16px!important;order:1;}
// //           .enq-right{padding:16px!important;order:2;background:#fff;}
// //           .form-group{display:block;margin-bottom:14px;}
// //           .form-group input,.form-group textarea{width:100%;padding:11px 12px;font-size:13px;box-sizing:border-box;}
// //           .form-group select{width:100%;padding:11px 12px;font-size:13px;}
// //           .enq-label{font-size:10px;margin-bottom:6px;display:block;}
// //           .enq-input{width:100%;padding:11px 12px;font-size:13px;box-sizing:border-box;}
// //           .enq-contact-info{margin-bottom:10px;}
// //           .submit-btn{width:100%;padding:12px 16px;}
// //           .form-group input,.form-group textarea{padding:10px 12px;font-size:13px;}
// //           .enq-label{font-size:10px;}
// //           /* Touch-friendly buttons */
// //           button, .pkg-btn, .submit-btn, .magic-arrow-btn {
// //             min-height:44px !important;
// //             min-width:44px !important;
// //             padding:12px 16px !important;
// //           }
// //           /* Improved touch spacing */
// //           a[href], button { margin: 4px; }
// //           .enq-label { margin-bottom: 6px; }
// //           .form-group { margin-bottom: 14px; }
// //           .pkg-card { margin-bottom: 8px; }
// //           .testimonial-card { margin-bottom: 12px; }
// //         }
// //         .faq-item{background:#f5f5f5;border-left:4px solid var(--gold);padding:18px;margin-bottom:12px;border-radius:12px;cursor:pointer;transition:all .3s cubic-bezier(.25,1,.5,1);}
// //         .faq-item:hover{background:#efefef;transform:translateX(4px);}
// //         .faq-q{font-family:'Playfair Display',serif;font-weight:700;color:var(--p);margin-bottom:8px;font-size:16px;}
// //         .faq-a{font-size:14px;color:#555;line-height:1.6;}
// //         .enquiry-form{background:#f9f9f9;padding:28px;border-radius:20px;border:1px solid rgba(94,14,115,.08);}
// //         .form-group{margin-bottom:18px;}
// //         .form-group label{display:block;margin-bottom:8px;font-weight:600;color:var(--p);font-family:'Playfair Display',serif;font-size:15px;}
// //         .form-group input,.form-group textarea{width:100%;padding:12px 16px;border:1px solid #ddd;border-radius:12px;font-family:'DM Sans',sans-serif;font-size:14px;transition:all .3s;box-sizing:border-box;}
// //         .form-group input:focus,.form-group textarea:focus{outline:none;border-color:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.1);}
// //         .form-group textarea{resize:vertical;min-height:120px;}
// //         .submit-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;padding:14px 40px;border-radius:50px;cursor:pointer;font-weight:600;width:100%;transition:all .3s;box-shadow:0 6px 20px rgba(94,14,115,.35);font-family:'DM Sans',sans-serif;font-size:15px;}
// //         .submit-btn:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(94,14,115,.45);}
// //         .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;box-shadow:0 22px 56px rgba(94,14,115,.4);}
// //         .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
// //         .enq-right{background:#fff;padding:40px 36px;}
// //         .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
// //         .enq-input{width:100%;background:var(--c);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s;color:var(--dark);}
// //         .enq-input:focus{border-color:var(--p);box-shadow:0 0 0 3px rgba(94,14,115,.08);}
// //         .enq-input option{background:var(--dark);color:#fff;}
// //         .enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
// //         .enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
// //         .enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
// //         .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}
// //         @media(max-width:991px){.enq-left{padding:28px 20px;}.enq-right{padding:24px 18px;}}
// //         .gallery-item{cursor:pointer;border-radius:16px;overflow:hidden;transition:transform .3s cubic-bezier(.25,1,.5,1),box-shadow .3s;box-shadow:0 4px 16px rgba(0,0,0,.08);}
// //         .gallery-item:hover{transform:scale(1.08);box-shadow:0 12px 32px rgba(94,14,115,.2);}
// //         .gallery-item img{width:100%;height:180px;object-fit:cover;display:block;transition:transform .4s;}
// //         .gallery-item{cursor:pointer;border-radius:16px;overflow:hidden;transition:transform .3s cubic-bezier(.25,1,.5,1),box-shadow .3s;box-shadow:0 4px 16px rgba(0,0,0,.08);}
// //         .gallery-item:hover{transform:scale(1.08);box-shadow:0 12px 32px rgba(94,14,115,.2);}
// //         .gallery-item img{width:100%;height:180px;object-fit:cover;display:block;transition:transform .4s;}
// //         .testimonial-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:26px;}
// //         .testimonial-card{background:#fff;border-radius:18px;padding:28px;box-shadow:0 6px 24px rgba(94,14,115,.1);transition:all .4s cubic-bezier(.25,1,.5,1);border-left:4px solid var(--gold);position:relative;}
// //         .testimonial-card:hover{transform:translateY(-8px);box-shadow:0 16px 40px rgba(94,14,115,.15);}
// //         .testimonial-header{display:flex;gap:12px;align-items:center;margin-bottom:16px;}
// //         .testimonial-avatar{width:50px;height:50px;border-radius:50%;object-fit:cover;border:2px solid var(--gold);}
// //         .testimonial-name{font-family:'Playfair Display',serif;font-weight:700;font-size:16px;color:var(--dark);}
// //         .testimonial-years{font-size:12px;color:#999;}
// //         .testimonial-stars{color:var(--gold);font-size:14px;margin:4px 0 12px;}
// //         .testimonial-text{color:#555;font-size:14px;line-height:1.7;}
// //         .process-timeline{position:relative;display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:30px;padding:20px 0;}
// //         .process-timeline::before{content:'';position:absolute;top:40px;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--gold) 0%,var(--gold) 25%,transparent 25%,transparent 100%);background-size:100% 100%;z-index:0;}
// //         .process-step{position:relative;z-index:1;text-align:center;}
// //         .process-icon{width:80px;height:80px;border-radius:50%;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:40px;margin:0 auto 16px;box-shadow:0 8px 24px rgba(94,14,115,.25);transition:all .3s;}
// //         .process-step:hover .process-icon{transform:scale(1.1);box-shadow:0 12px 36px rgba(94,14,115,.35);}
// //         .process-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--p);margin-bottom:8px;}
// //         .process-desc{font-size:13px;color:#666;line-height:1.5;}
// //         .addon-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:16px;}
// //         .addon-card{background:linear-gradient(135deg,rgba(255,255,255,.95),rgba(248,248,248,.95));border:1.5px solid rgba(94,14,115,.1);border-radius:16px;padding:18px;text-align:center;cursor:pointer;transition:all .3s cubic-bezier(.25,1,.5,1);position:relative;overflow:hidden;}
// //         .addon-card::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--gold) 0%,var(--gb) 100%);opacity:0;transition:opacity .3s;z-index:-1;}
// //         .addon-card:hover{border-color:var(--gold);transform:translateY(-6px);box-shadow:0 12px 28px rgba(94,14,115,.15);}
// //         .addon-icon{font-size:32px;margin-bottom:8px;}
// //         .addon-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:var(--p);margin-bottom:6px;}
// //         .addon-price{color:var(--gold);font-weight:700;font-size:14px;}
// //         .addon-desc{font-size:11px;color:#999;margin-top:6px;}
// //         .whychoose-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:22px;}
// //         .whychoose-card{background:linear-gradient(135deg,var(--pp) 0%,rgba(243,229,247,.5) 100%);border-radius:20px;padding:32px;text-align:center;transition:all .3s;position:relative;border:1px solid rgba(94,14,115,.1);}
// //         .whychoose-card:hover{transform:translateY(-10px);box-shadow:0 20px 50px rgba(94,14,115,.15);}
// //         .whychoose-icon{font-size:48px;margin-bottom:16px;}
// //         .whychoose-title{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;color:var(--p);margin-bottom:12px;}
// //         .whychoose-desc{font-size:14px;color:#666;line-height:1.6;}
// //         .stats-container{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:20px;padding:30px 0;}
// //         .stat-item{text-align:center;padding:20px;}
// //         .stat-number{font-family:'Playfair Display',serif;font-size:clamp(28px,5vw,48px);font-weight:900;color:var(--gold);}
// //         .stat-label{font-size:13px;color:#666;margin-top:8px;text-transform:uppercase;letter-spacing:1px;}
// //         .gallery-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:16px;}
// //         @keyframes _shine{0%{left:-100%}25%{left:130%}100%{left:130%}}
// //         @keyframes _goldBg{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
// //         @keyframes _fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
// //         @keyframes _float{0%, 100%{transform:translateY(0px)}50%{transform:translateY(-15px)}}
// //         @keyframes _slideInUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
// //         @keyframes _slideInLeft{from{opacity:0;transform:translateX(-40px)}to{opacity:1;transform:translateX(0)}}
// //         @keyframes _slideInRight{from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:translateX(0)}}
// //         @keyframes _scaleIn{from{opacity:0;transform:scale(0.9)}to{opacity:1;transform:scale(1)}}
// //         @keyframes _zoomInSoft{from{opacity:0;transform:scale(0.95)}to{opacity:1;transform:scale(1)}}
// //         @keyframes fadeInUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
// //         @keyframes kidsPulse{0%,100%{transform:scale(1);opacity:0.6}50%{transform:scale(1.1);opacity:1}}
// //         @keyframes kidsFloat{0%,100%{transform:translateY(0px)rotate(0deg)}50%{transform:translateY(-15px)rotate(5deg)}}
// //         .animate-visible{animation:_slideInUp 0.8s cubic-bezier(0.25,1,0.5,1) forwards!important;}
// //         [data-animate]{ opacity:0; }
// //         .cc-bubble{position:absolute;background:radial-gradient(circle,rgba(201,168,76,0.15) 0%,rgba(201,168,76,0.05) 100%);border-radius:50%;pointer-events:none;}
// //         @media(max-width:768px){.gallery-grid{grid-template-columns:repeat(auto-fit,minmax(150px,1fr));}.process-timeline::before{display:none;}}
// //         /* ── Magic Reels Carousel — Instagram Reel Size ── */
// //         .magic-reels-wrap{position:relative;overflow:hidden;width:100%;max-width:682px;margin:0 auto;scroll-snap-type:x mandatory;}
// //         .magic-reel-track{display:flex;gap:14px;transition:transform 0.5s cubic-bezier(0.25,1,0.5,1);will-change:transform;}
// //         .magic-reel-card{flex-shrink:0;width:160px;height:240px;border-radius:16px;overflow:hidden;cursor:pointer;position:relative;box-shadow:0 8px 24px rgba(0,0,0,0.15);transition:all 0.3s cubic-bezier(0.25,1,0.5,1);scroll-snap-align:center;}
// //         .magic-reel-card:hover{transform:translateY(-8px);box-shadow:0 16px 40px rgba(94,14,115,0.25);}
// //         .magic-reel-img{width:100%;height:100%;object-fit:cover;display:block;}
// //         .magic-reel-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.4);opacity:0;transition:opacity 0.3s;font-size:32px;cursor:pointer;}
// //         .magic-reel-card:hover .magic-reel-play{opacity:1;}
// //         .magic-reel-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,0.95),rgba(26,0,48,0.4),transparent);display:flex;flex-direction:column;justify-content:flex-end;padding:12px;}
// //         .magic-reel-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:2px;}
// //         .magic-reel-event{font-size:10px;color:rgba(255,255,255,0.7);margin-bottom:4px;}
// //         .magic-reel-theme{display:inline-block;background:rgba(201,168,76,0.9);color:var(--dark);font-size:8px;padding:3px 8px;border-radius:8px;font-weight:700;width:fit-content;}
// //         .magic-nav-arrows{display:flex;gap:12px;justify-content:center;margin-top:28px;}
// //         .magic-arrow-btn{width:44px;height:44px;border-radius:50%;border:2px solid var(--gold);background:transparent;color:var(--gold);font-size:18px;cursor:pointer;transition:all 0.3s;display:flex;align-items:center;justify-content:center;font-weight:700;}
// //         .magic-arrow-btn:hover{background:var(--gold);color:var(--dark);box-shadow:0 8px 20px rgba(201,168,76,0.4);transform:scale(1.1);}
// //         @media(max-width:768px){.magic-reel-card{width:140px;height:210px;}.magic-reel-name{font-size:11px;}.magic-reel-event{font-size:9px;}.magic-reel-theme{font-size:7px;padding:2px 6px;}}
// //         @media(max-width:768px){.gallery-grid{grid-template-columns:repeat(auto-fit,minmax(150px,1fr));}}
// //       `}</style>

// //       <div ref={containerRef}>
// //       {/* Hero Section */}
// //       <section className="bc-hero" id="hero" data-animate style={{ padding: "100px 0 80px", position: "relative", backgroundImage: "url('https://www.paperlesspost.com/blog/wp-content/uploads/00_Blog_HowToPlanABirthdayParty_Hero.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" }}>
// //         <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(94,14,115,0.65) 0%, rgba(94,14,115,0.55) 50%, rgba(147,51,234,0.6) 100%)", zIndex: 1 }} />
// //         {[...Array(8)].map((_, i) => (
// //           <div key={i} style={{
// //             position: "absolute",
// //             background: `radial-gradient(circle, rgba(201,168,76,0.15) 0%, rgba(201,168,76,0.05) 100%)`,
// //             borderRadius: "50%",
// //             pointerEvents: "none",
// //             animation: `_float 6s ease-in-out infinite`,
// //             width: Math.random() * 60 + 20,
// //             height: Math.random() * 60 + 20,
// //             left: `${Math.random() * 100}%`,
// //             top: `${Math.random() * 100}%`,
// //             animationDelay: `${Math.random() * 5}s`,
// //             animationDuration: `${Math.random() * 8 + 4}s`,
// //             zIndex: 3,
// //           }} />
// //         ))}
// //         <div className="container" style={{ position: "relative", zIndex: 2 }}>
// //           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "60px", alignItems: "center" }}>
// //             <div style={{ animation: "_fadeUp 0.8s ease-out" }}>
// //               <div style={{ display: "inline-block", background: `${C.gold}20`, backdropFilter: "blur(10px)", borderRadius: "60px", padding: "8px 20px", marginBottom: 20, border: `1px solid ${C.gold}40` }}>
// //                 <span style={{ fontSize: 13, fontWeight: 600, color: C.goldLight }}>🎂 Create Magic! 🎂</span>
// //               </div>
// //               <h1 className="pf" style={{ fontSize: "clamp(36px, 6vw, 64px)", color: "#fff", lineHeight: 1.2, marginBottom: 20, textShadow: "2px 2px 0 rgba(0,0,0,0.1)" }}>Unforgettable <span style={{ color: C.gold }}>Birthday Celebrations</span></h1>
// //               <p style={{ fontSize: 18, color: `rgba(255,255,255,0.8)`, marginBottom: 30, lineHeight: 1.6 }}>Create magical memories with our 20+ themed celebration packages designed for everyone.</p>
// //               <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 40 }}>
// //                 <button onClick={() => window.scrollTo({ top: document.body.offsetHeight * 0.3, behavior: "smooth" })} style={{ background: `linear-gradient(135deg, ${C.gold}, ${C.goldLight})`, color: C.dark, border: "none", borderRadius: "60px", padding: "14px 32px", fontWeight: 800, fontSize: 14, cursor: "pointer", boxShadow: `0 8px 25px rgba(201,168,76,0.35)`, display: "inline-flex", alignItems: "center", gap: 8 }}>🎈 Explore Packages</button>
// //                 <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" })} style={{ background: "transparent", color: C.gold, border: `2px solid ${C.gold}`, borderRadius: "60px", padding: "12px 30px", fontWeight: 700, fontSize: 14, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8 }}>📞 Book a Callback</button>
// //               </div>
// //               <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
// //                 <div style={{ textAlign: "center" }}><div style={{ fontSize: "28px", fontWeight: 900, color: C.gold }}>4000+</div><div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: 1 }}>Happy Celebrations</div></div>
// //                 <div style={{ textAlign: "center" }}><div style={{ fontSize: "28px", fontWeight: 900, color: C.gold }}>4.9★</div><div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: 1 }}>Rating</div></div>
// //                 <div style={{ textAlign: "center" }}><div style={{ fontSize: "28px", fontWeight: 900, color: C.gold }}>20+</div><div style={{ fontSize: "12px", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: 1 }}>Themes</div></div>
// //               </div>
// //             </div>
// //             <div style={{ textAlign: "center", animation: "_fadeUp 0.8s ease-out 0.2s both" }}>
// //               <div style={{ position: "relative", display: "inline-block" }}>
// //                 <img src="https://cdn.togetherv.com/birthday-surprise-main_1681375822.webp" alt="Birthday Party" style={{ borderRadius: "40px", width: "100%", maxWidth: 400, boxShadow: `0 30px 50px rgba(0,0,0,0.2)`, border: `4px solid ${C.gold}60` }} />
// //                 <div style={{ position: "absolute", bottom: -20, right: -20, background: C.gold, borderRadius: "50%", padding: 15, boxShadow: "0 10px 20px rgba(0,0,0,0.2)", animation: "_pulse 2s ease-in-out infinite" }}><span style={{ fontSize: 40 }}>🎉</span></div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Themes Section */}
// //       <section className="bc-sec" style={{ background: "#fff" }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Dream Themes ✦</span>
// //           <h2 className="section-title">Popular <span className="gold">Themes</span></h2>
// //           <div className="theme-carousel" ref={themeCarouselRef} onMouseEnter={() => setThemeHover(true)} onMouseLeave={() => setThemeHover(false)}>
// //             {BIRTHDAY_THEMES.map((theme, i) => (
// //               <div key={i} className="theme-card" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }} onClick={() => toast.info(`${theme.name} selected!`)}>
// //                 <img src={theme.img} alt={theme.name} />
// //                 <div className="theme-card-ovl">
// //                   <div className="theme-card-name">{theme.name}</div>
// //                   <div className="theme-card-bookings">{theme.bookings}</div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Packages Section */}
// //       <PaymentSection packages={BIRTHDAY_PACKAGES} title="Pick Your Perfect Celebration" subtitle="Every package includes full private theatre access — crafted for unforgettable moments" />

// //       {/* Reels Section */}
// //       <section className="bc-sec" id="reels" data-animate style={{ background: C.dark }}>
// //         <div className="container">
// //           <span className="cc-tag" style={{ color: "rgba(255, 255, 255, 0.7)" }}>✦ Our Reels ✦</span>
// //           <h2 className="section-title" style={{ color: "white" }}>See the <span style={{ color: C.gold }}>Magic</span> Happen</h2>
// //           <p style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.8)", marginBottom: 40, fontSize: 15 }}>Watch real celebrations — the energy, the joy, the unforgettable moments.</p>
          
// //           <div className="magic-reels-wrap" onMouseEnter={() => setReelHover(true)} onMouseLeave={() => setReelHover(false)}>
// //             <div className="magic-reel-track" style={{ transform: `translateX(calc(-${reelIdx * (160 + 14)}px))` }}>
// //               {BIRTHDAY_REELS.map((reel, i) => (
// //                 <div key={i} className="magic-reel-card" onClick={() => setPlayingReel(reel)}>
// //                   <img src={reel.img} alt={reel.name} className="magic-reel-img" />
// //                   <div className="magic-reel-play" onClick={(e) => { e.stopPropagation(); setPlayingReel(reel); }}>▶</div>
// //                   <div className="magic-reel-ovl">
// //                     <div className="magic-reel-name">{reel.name}</div>
// //                     <div className="magic-reel-event">{reel.event}</div>
// //                     <span className="magic-reel-theme">{reel.theme}</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           <div className="magic-nav-arrows">
// //             <button className="magic-arrow-btn" onClick={() => setReelIdx(i => i === 0 ? BIRTHDAY_REELS.length - 1 : i - 1)}>‹</button>
// //             <button className="magic-arrow-btn" onClick={() => setReelIdx(i => (i + 1) % BIRTHDAY_REELS.length)}>›</button>
// //           </div>

// //           <div style={{ display: "flex", gap: 14, justifyContent: "center", marginTop: 24, flexWrap: "wrap" }}>
// //             <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" })} style={{ background: C.gold, color: C.dark, border: "none", borderRadius: 50, padding: "12px 24px", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>🎉 Plan Your Event</button>
// //             <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" style={{ background: "#25D366", color: "#fff", border: "none", borderRadius: 50, padding: "12px 24px", fontWeight: 700, cursor: "pointer", fontSize: 14, display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
// //               💬 Message Us
// //             </a>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Testimonials Section */}
// //       <section className="bc-sec" id="testimonials" data-animate style={{ background: "#f9f9f9" }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Happy Stories ✦</span>
// //           <h2 className="section-title">Happy Birthday <span style={{ color: C.gold }}>Stories</span></h2>
// //           <div className="testimonial-grid">
// //             {BIRTHDAY_TESTIMONIALS.map((testi, i) => (
// //               <div key={i} className="testimonial-card" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }}>
// //                 <div className="testimonial-header">
// //                   <img src={testi.img} alt={testi.name} className="testimonial-avatar" />
// //                   <div>
// //                     <div className="testimonial-name">{testi.name}</div>
// //                   </div>
// //                 </div>
// //                 <div className="testimonial-stars">{'⭐'.repeat(testi.rating)}</div>
// //                 <p className="testimonial-text">"{testi.text}"</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Why Choose Us Section */}
// //       <section className="bc-sec" id="whychoose" data-animate style={{ background: "#fff" }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Why Choose Us ✦</span>
// //           <h2 className="section-title">Why Choose <span style={{ color: C.gold }}>Us?</span></h2>
// //           <div className="whychoose-grid">
// //             {BIRTHDAY_WHYCHOOSE.map((item, i) => (
// //               <div key={i} className="whychoose-card" data-animate style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.12}s both` }}>
// //                 <div className="whychoose-icon">{item.icon}</div>
// //                 <h4 className="whychoose-title">{item.title}</h4>
// //                 <p className="whychoose-desc">{item.desc}</p>
// //               </div>
// //             ))}
// //           </div>
// //           <div className="stats-container" style={{ marginTop: 60 }}>
// //             <div className="stat-item" data-animate style={{ animation: `fadeInUp 0.6s ease-out 0s both` }}>
// //               <div className="stat-number">4000+</div>
// //               <div className="stat-label">Happy Birthdays</div>
// //             </div>
// //             <div className="stat-item" data-animate style={{ animation: `fadeInUp 0.6s ease-out 0.12s both` }}>
// //               <div className="stat-number">50K+</div>
// //               <div className="stat-label">Smiling Faces</div>
// //             </div>
// //             <div className="stat-item" data-animate style={{ animation: `fadeInUp 0.6s ease-out 0.24s both` }}>
// //               <div className="stat-number">24/7</div>
// //               <div className="stat-label">Birthday Support</div>
// //             </div>
// //             <div className="stat-item" data-animate style={{ animation: `fadeInUp 0.6s ease-out 0.36s both` }}>
// //               <div className="stat-number">100%</div>
// //               <div className="stat-label">Joy Guaranteed</div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Process Section */}
// //       <section className="bc-sec" id="process" data-animate style={{ background: C.goldLight }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Our Process ✦</span>
// //           <h2 className="section-title">How It <span style={{ color: C.gold }}>Works</span></h2>
// //           <div className="process-timeline">
// //             {BIRTHDAY_PROCESS.map((proc, i) => (
// //               <div key={i} className="process-step" data-animate style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.12}s both` }}>
// //                 <div className="process-icon">{proc.icon}</div>
// //                 <h4 className="process-title">{proc.step}. {proc.title}</h4>
// //                 <p className="process-desc">{proc.desc}</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Add-ons Section */}
// //       <section className="bc-sec" id="addons" data-animate style={{ background: C.cream }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Premium Add-ons ✦</span>
// //           <h2 className="section-title">Make It More <span style={{ color: C.gold }}>Special</span></h2>
// //           <p style={{ textAlign: "center", fontSize: 15, color: "#666", marginBottom: 40 }}>Add these amazing services to enhance the birthday celebration</p>
// //           <div className="addon-grid">
// //             {BIRTHDAY_ADDONS.map((addon, i) => (
// //               <div key={i} className="addon-card" data-animate style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }}>
// //                 <div className="addon-icon">{addon.icon}</div>
// //                 <div className="addon-name">{addon.name}</div>
// //                 <div className="addon-price">{addon.price}</div>
// //                 <div className="addon-desc">{addon.desc}</div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Gallery Section */}
// //       <section className="bc-sec" id="gallery" data-animate style={{ background: "#f9f9f9" }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Birthday Moments ✦</span>
// //           <h2 className="section-title">Birthday <span className="gold">Gallery</span></h2>
// //           <div className="gallery-grid">
// //             {BIRTHDAY_GALLERY.map((img, i) => (
// //               <div key={i} className="gallery-item" data-animate style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.08}s both` }} onClick={() => setActiveGal(i)}>
// //                 <img src={img.thumb} alt={`Gallery ${i + 1}`} />
// //               </div>
// //             ))}
// //           </div>
// //           {activeGal !== null && (
// //             <Galleria value={BIRTHDAY_GALLERY} activeIndex={activeGal} onItemChange={(e) => setActiveGal(e.index)} item={(item) => <img src={item.full} alt="" style={{ width: "100%", height: "auto" }} />} thumbnail={(item) => <img src={item.thumb} alt="" style={{ width: "100%", height: "80px", objectFit: "cover" }} />} style={{ maxWidth: "800px", margin: "30px auto" }} />
// //           )}
// //         </div>
// //       </section>

// //       {/* Coupon Section */}
// //       <CouponSection />

// //       {/* Enquiry Section */}
// //       <section className="bc-sec" id="enquiry" data-animate style={{ background: C.beige }}>
// //         <div className="container">
// //           <div style={{ marginBottom: 44, textAlign: "center" }}>
// //             <span style={{ color: C.gold, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: 1 }}>✦ Plan The Birthday ✦</span>
// //             <h2 className="section-title">Plan the <span className="gold">Perfect Birthday</span></h2>
// //             <p style={{ fontSize: 15, color: "#666", marginTop: 12 }}>Fill in the details and our specialist will call you within 2 hours.</p>
// //           </div>
// //           <div className="enq-wrap" style={{ maxWidth: 980, margin: "0 auto" }}>
// //             <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr" }}>
// //               <div className="enq-left">
// //                 <div>
// //                   <h3 className="pf" style={{ color: "#fff", fontSize: 23, fontWeight: 700, marginBottom: 8 }}>Let's Create <span style={{ color: C.goldLight }}>Magic</span></h3>
// //                   <p style={{ color: "rgba(255,255,255,.58)", fontSize: 13, lineHeight: 1.7, marginBottom: 24 }}>Share your birthday details and we'll craft an unforgettable celebration experience.</p>
// //                 </div>
// //                 <div>
// //                   {[
// //                     { icon: "⚡", label: "2-Hour Callback", val: "We call within 2 hours" },
// //                     { icon: "🎂", label: "Free Theme Consult", val: "Expert advice included" },
// //                     { icon: "💰", label: "Price Match", val: "Best price guaranteed" },
// //                     { icon: "💬", label: "WhatsApp Us", val: "+91 8374777834", href: "https://wa.me/918374777834" },
// //                   ].map((it, i) => (
// //                     <div key={i} className="enq-contact-info">
// //                       <div className="enq-ci-icon">{it.icon}</div>
// //                       <div>
// //                         <div className="enq-ci-label">{it.label}</div>
// //                         {it.href ? (
// //                           <a href={it.href} style={{ color: "#fff", fontWeight: 500, fontSize: 13, textDecoration: "none" }}>{it.val}</a>
// //                         ) : (
// //                           <span style={{ color: "#fff", fontWeight: 500, fontSize: 13 }}>{it.val}</span>
// //                         )}
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //               <div className="enq-right">
// //                 <h3 className="pf" style={{ fontSize: 21, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Book Your <span style={{ color: C.primary }}>Birthday!</span></h3>
// //                 <p style={{ color: "#aaa", fontSize: 13, marginBottom: 22 }}>Free callback within 2 hours • No obligation</p>
// //                 <form onSubmit={handleSubmit}>
// //                   <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
// //                     <div>
// //                       <label className="enq-label">Your Name *</label>
// //                       <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="enq-input" placeholder="e.g. Priya Sharma" required />
// //                     </div>
// //                     <div>
// //                       <label className="enq-label">Phone Number *</label>
// //                       <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="enq-input" placeholder="+91 98765 43210" required />
// //                     </div>
// //                     <div>
// //                       <label className="enq-label">Email Address</label>
// //                       <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="enq-input" placeholder="you@email.com" />
// //                     </div>
// //                     <div>
// //                       <label className="enq-label">Birthday Date *</label>
// //                       <input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="enq-input" required />
// //                     </div>
// //                     <div style={{ gridColumn: "1 / -1" }}>
// //                       <label className="enq-label">Preferred Theme *</label>
// //                       <select className="enq-input" required style={{ marginBottom: 12 }}>
// //                         <option value="">Choose a theme…</option>
// //                         {BIRTHDAY_THEMES.map((t, i) => <option key={i} value={t.name}>{t.name}</option>)}
// //                       </select>
// //                     </div>
// //                     <div style={{ gridColumn: "1 / -1" }}>
// //                       <label className="enq-label">Message</label>
// //                       <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="enq-input" placeholder="Tell us about your birthday..." style={{ minHeight: 80 }} />
// //                     </div>
// //                     <div style={{ gridColumn: "1 / -1", marginTop: 4 }}>
// //                       <button type="submit" style={{ width: "100%", justifyContent: "center", padding: "15px", fontSize: 15, background: `linear-gradient(135deg,#B8860B,${C.gold},${C.goldLight},${C.gold},#9A6E10)`, backgroundSize: "200% 200%", animation: "_goldBg 3s ease infinite", color: C.dark, border: "none", borderRadius: 50, cursor: "pointer", fontWeight: 800, boxShadow: "0 6px 20px rgba(201,168,76,.45)", position: "relative", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
// //                         🎉 Request a Free Callback 🎉
// //                       </button>
// //                       <p style={{ textAlign: "center", fontSize: 11, color: "#aaa", marginTop: 10 }}>No spam. We'll call to discuss your birthday and that's it.</p>
// //                     </div>
// //                   </div>
// //                 </form>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* FAQ Section */}
// //       <section className="bc-sec" id="faq" data-animate style={{ background: C.primaryPale }}>
// //         <div className="container">
// //           <span className="cc-tag">✦ Common Questions ✦</span>
// //           <h2 className="section-title">Got Questions? We've Got Answers</h2>
// //           {BIRTHDAY_FAQ.map((faq, i) => (
// //             <div key={i} className="faq-item" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }}>
// //               <div className="faq-q">{faq.q}</div>
// //               <div className="faq-a">{faq.a}</div>
// //             </div>
// //           ))}
// //         </div>
// //       </section>

// //       <Footer />
// //       </div>
// //     </>
// //   );
// // }


// import React, { useState, useEffect, useRef, useMemo } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Helmet } from "react-helmet";
// import { Galleria } from "primereact/galleria";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import { URLS } from "../Url";
// import CouponSection from "../components/Coupons";
// import PopupModal from "../components/PopUpModal";

// /* ─── EXACT Brand Palette — matches Home.jsx & KidsPage.jsx ─────────────── */
// const C = {
//   primary:      "#5E0E73",
//   primaryLight: "#6E1A85",
//   primaryDeep:  "#3A0847",
//   primaryPale:  "#F3E5F7",
//   cream:        "#E8E1D6",
//   beige:        "#D6CFC4",
//   gold:         "#C9A84C",
//   goldLight:    "#E8D5A0",
//   goldBright:   "#F5D87A",
//   dark:         "#1A0030",
//   dark2:        "#120020",
// };

// /* ─── Static Birthday Data ──────────────────────────────────────────────── */
// const BIRTHDAY_THEMES = [
//   { name:"Cosmic Adventure",  bookings:"412", tags:["Space","Adventure"],  img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80", emoji:"🚀", color:"#6366F1" },
//   { name:"Enchanted Forest",  bookings:"356", tags:["Magic","Fantasy"],    img:"https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80", emoji:"🌲", color:"#22C55E" },
//   { name:"Tropical Paradise", bookings:"289", tags:["Tropical","Beach"],   img:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=600&q=80", emoji:"🌴", color:"#F59E0B" },
//   { name:"Movie Night",       bookings:"445", tags:["Cinema","Fun"],       img:"https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&q=80", emoji:"🎬", color:"#EF4444" },
//   { name:"Carnival Fiesta",   bookings:"523", tags:["Party","Festive"],    img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",           emoji:"🎪", color:C.gold },
//   { name:"Retro Throwback",   bookings:"267", tags:["Retro","Classic"],    img:"https://images.unsplash.com/photo-1509805735646-2f72b3272a7d?q=80",        emoji:"🕹️", color:"#A855F7" },
// ];

// const BIRTHDAY_PACKAGES = [
//   {
//     name:"Mini Celebration",
//     price:"₹7,999",
//     dur:"3 Hours",
//     guests:"Up to 15",
//     features:["Basic Decor Setup","Cake & Snacks","Simple Games","Photography"],
//     popular:false, emoji:"🎈", color:C.gold,
//     img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80",
//   },
//   {
//     name:"Birthday Bash",
//     price:"₹12,999",
//     dur:"5 Hours",
//     guests:"Up to 30",
//     features:["Premium Decor","Multi-course Snacks","DJ & Music","Photo + Video","Games & Activities"],
//     popular:true, emoji:"⭐", color:"#E85D75",
//     img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",
//   },
//   {
//     name:"Royal Birthday",
//     price:"₹19,999",
//     dur:"7 Hours",
//     guests:"Up to 50",
//     features:["Luxury Decor Theme","Gourmet Catering","DJ + LED Setup","Professional Crew","Customized Programs","Memory Album"],
//     popular:false, emoji:"👑", color:"#D4AF37",
//     img:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=500&q=80",
//   },
// ];

// const WHY_US = [
//   { icon:"🎂", title:"Celebration Experts",  desc:"We've hosted 4000+ amazing birthday celebrations across Hyderabad." },
//   { icon:"👥", title:"For Everyone",         desc:"Customized entertainment and themes for all ages and preferences." },
//   { icon:"⭐", title:"Premium Quality",      desc:"Professional, safe, and memorable experiences every single time." },
//   { icon:"💰", title:"Best Value",           desc:"Premium birthday celebration at prices that make everyone happy." },
// ];

// const BIRTHDAY_ACTIVITIES = [
//   { name:"Professional DJ",       dur:"Full event", age:"All ages",  img:"https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&q=80" },
//   { name:"Photo Booth",           dur:"Full event", age:"All ages",  img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80" },
//   { name:"Games & Activities",    dur:"2 hours",    age:"Customized",img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80" },
//   { name:"Character Appearance",  dur:"45 mins",    age:"All ages",  img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80" },
// ];

// const SERVICE_CARDS = [
//   { label:"Themed Decor",   img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",        desc:"Full themed decor — balloons, backdrops, props and custom installations." },
//   { label:"Custom Cakes",   img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", desc:"Personalized birthday cakes designed and crafted by our in-house bakers." },
//   { label:"Food & Snacks",  img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80",   desc:"Kid-friendly and adult menus with vegetarian & non-veg catering options." },
//   { label:"Photography",    img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80", desc:"Professional candid photography & 4K videography — memories for life." },
// ];

// const BIRTHDAY_FAQ = [
//   { q:"Can I customize the celebration?",      a:"Yes! Our team can work with you on customized themes, decorations, food, and entertainment options tailored to your vision." },
//   { q:"How far in advance should I book?",     a:"We recommend booking 2–3 weeks prior for better theme and slot availability, especially for weekends." },
//   { q:"Can we customize the menu?",            a:"Absolutely! Our team can work with you on customized food options and accommodate all dietary requirements." },
//   { q:"Do you provide entertainment?",         a:"Yes! We offer DJs, games, activities, character appearances, and more depending on the package selected." },
//   { q:"Is photography included in all packages?", a:"Photography is included in all packages. Video coverage is available in Birthday Bash and Royal Birthday packages." },
// ];

// const BIRTHDAY_GALLERY = [
//   "https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80",
//   "https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",
//   "https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=600&q=80",
//   "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&q=80",
//   "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80",
//   "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80",
// ];

// const MAGIC_REELS = [
//   { id:1, name:"Fun Party",           event:"Kids Birthday",      theme:"Carnival",  img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",           video:"/assets/videos/video1.mp4" },
//   { id:2, name:"Cake Smash",          event:"1st Birthday",       theme:"Cute",      img:"https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800&q=80",  video:"/assets/videos/video2.mp4" },
//   { id:3, name:"DJ Night",            event:"Teen Party",         theme:"Music",     img:"https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&q=80",  video:"/assets/videos/video3.mp4" },
//   { id:4, name:"Family Celebration",  event:"Classic Party",      theme:"Family",    img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=800&q=80",  video:"/assets/videos/video4.mp4" },
//   { id:5, name:"Themed Birthday",     event:"Adventure Party",    theme:"Adventure", img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=800&q=80",  video:"/assets/videos/video5.mp4" },
//   { id:6, name:"Grand Celebration",   event:"Milestone Birthday", theme:"Premium",   img:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=800&q=80",  video:"/assets/videos/video6.mp4" },
// ];

// const FALLBACK_VIDEOS = [
//   { videoId:"dQw4w9WgXcQ", name:"Sakshi's Party",   role:"Birthday Celebration", profileImage:"" },
//   { videoId:"dQw4w9WgXcQ", name:"Rahul's Bash",     role:"Birthday Celebration", profileImage:"" },
//   { videoId:"dQw4w9WgXcQ", name:"Priya's Birthday", role:"Birthday Celebration", profileImage:"" },
// ];

// const FALLBACK_TEXT = [
//   { name:"Sakshi Reddy",   role:"Birthday Celebrant", rating:5, description:"The Enchanted Forest celebration was magical! The decorations were beautiful, the games were so fun, and everyone had an amazing time.", avatar:"SR", image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80", occasion:"Enchanted Forest Theme" },
//   { name:"Rahul Sharma",   role:"Birthday Celebrant", rating:5, description:"The Movie Night theme was absolutely perfect! Professional setup, great DJ, awesome activities — the videographer captured everything beautifully.", avatar:"RS", image:"https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=500&q=80", occasion:"Movie Night Theme" },
//   { name:"Priya Kumar",    role:"Birthday Celebrant", rating:5, description:"Our celebration was incredible! Carnival Castle created the perfect vibe with amazing decor, great food, and fantastic entertainment.", avatar:"PK", image:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80", occasion:"Carnival Fiesta" },
//   { name:"Arjun Mehta",    role:"Birthday Celebrant", rating:5, description:"Booked the Royal Birthday package for my 30th and it was beyond expectations. The DJ, the cake, and the whole ambiance was absolutely stunning.", avatar:"AM", image:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=500&q=80", occasion:"Royal Birthday" },
//   { name:"Deepika Rao",    role:"Birthday Celebrant", rating:5, description:"Cosmic Adventure theme for my son's 10th birthday was out of this world! Every kid was completely blown away by the setup.", avatar:"DR", image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80", occasion:"Cosmic Adventure" },
//   { name:"Kiran Patel",    role:"Birthday Celebrant", rating:5, description:"Tropical Paradise theme was perfect for my daughter's sweet 16. The photo booth, the music, the food — every single detail was perfect.", avatar:"KP", image:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=500&q=80", occasion:"Tropical Paradise" },
// ];

// /* ══════════════════════════════════════════════════════════════════════════ */
// export default function BirthdayCelebrationPage() {
//   const [isLoading,   setIsLoading]   = useState(true);
//   const [themeIdx,    setThemeIdx]    = useState(0);
//   const [activeFaq,   setActiveFaq]   = useState(null);
//   const [showPopup,   setShowPopup]   = useState(false);
//   const [popupImage,  setPopupImage]  = useState("");
//   const [activeGal,   setActiveGal]   = useState(0);
//   const [reelIdx,     setReelIdx]     = useState(0);
//   const [reelHover,   setReelHover]   = useState(false);
//   const [playingReel, setPlayingReel] = useState(null);
//   const [videoPage,   setVideoPage]   = useState(0);
//   const [reviewPage,  setReviewPage]  = useState(0);
//   const [videoTesti,  setVideoTesti]  = useState([]);
//   const [textTesti,   setTextTesti]   = useState([]);
//   const galleria = useRef(null);
//   const videoRef = useRef(null);
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ name:"", email:"", mobileNumber:"", age:"", theme:"", date:"", guests:"" });

//   useEffect(() => {
//     axios.post("https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle")
//       .then(r => {
//         if (r.data?.success && Array.isArray(r.data.testimoni)) {
//           const active = r.data.testimoni.filter(t => t.status === "active");
//           const videos = active.filter(t => t.videoId?.trim());
//           setVideoTesti(videos.length ? videos : FALLBACK_VIDEOS);
//           const reviews = active.map(t => ({
//             name:t.name, role:t.role||"Birthday Celebrant", rating:Number(t.rating)||5,
//             description:t.description||"",
//             image:`https://api.carnivalcastle.com/${t.image}`,
//             avatar:`https://api.carnivalcastle.com/${t.profileImage}`,
//             occasion:t.type==="Yes"?"Special Celebration":"",
//           }));
//           setTextTesti(reviews.length ? reviews : FALLBACK_TEXT);
//         } else { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); }
//       })
//       .catch(() => { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); });

//     const t = setTimeout(() => setIsLoading(false), 700);
//     return () => clearTimeout(t);
//   }, []);

//   useEffect(() => {
//     const t = setInterval(() => setThemeIdx(i => (i + 1) % BIRTHDAY_THEMES.length), 3500);
//     return () => clearInterval(t);
//   }, []);

//   useEffect(() => {
//     const t = setInterval(() => {
//       if (!reelHover) setReelIdx(i => (i + 1) % MAGIC_REELS.length);
//     }, 4000);
//     return () => clearInterval(t);
//   }, [reelHover]);

//   const extendedReels = useMemo(() => [...MAGIC_REELS, ...MAGIC_REELS.slice(0, 3)], []);

//   const W = typeof window !== "undefined" ? window.innerWidth : 1200;
//   const VIDS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
//   const REVS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
//   const totalVP  = Math.max(1, Math.ceil(videoTesti.length / VIDS_PER));
//   const totalRP  = Math.max(1, Math.ceil(textTesti.length  / REVS_PER));
//   const visVids  = videoTesti.slice(videoPage  * VIDS_PER, (videoPage  + 1) * VIDS_PER);
//   const visRevs  = textTesti.slice( reviewPage * REVS_PER, (reviewPage + 1) * REVS_PER);

//   const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
//   const handleSubmit = e => {
//     e.preventDefault();
//     toast.success("🎉 Awesome! We'll call you within 2 hours to plan the perfect birthday!");
//     setForm({ name:"", email:"", mobileNumber:"", age:"", theme:"", date:"", guests:"" });
//   };

//   const galItem  = src => <img src={src} alt="" style={{ width:"100%", display:"block", borderRadius:14 }} />;
//   const galThumb = src => <img src={src} alt="" style={{ width:58, height:58, objectFit:"cover", display:"block", borderRadius:8 }} />;

//   if (isLoading) return (
//     <div style={{ background:C.dark, height:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:18 }}>
//       <div style={{ width:68, height:68, border:`4px solid ${C.primaryPale}`, borderTop:`4px solid ${C.gold}`, borderRadius:"50%", animation:"_spin 1s linear infinite" }} />
//       <p style={{ color:C.gold, fontWeight:600, letterSpacing:2, fontSize:14 }}>Loading Magic…</p>
//       <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
//     </div>
//   );

//   return (
//     <>
//       <Helmet>
//         <title>Carnival Castle | Unforgettable Birthday Celebrations in Hyderabad</title>
//         <meta name="description" content="Themed birthday celebrations — Cosmic, Carnival, Movie Night & 20+ themes. Premium packages from ₹7,999." />
//       </Helmet>

//       {/* ════════════ GLOBAL STYLES — identical to KidsPage ════════════ */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');

//         :root{
//           --p:${C.primary};--pl:${C.primaryLight};--pd:${C.primaryDeep};
//           --pp:${C.primaryPale};--cream:${C.cream};--beige:${C.beige};
//           --gold:${C.gold};--gl:${C.goldLight};--gb:${C.goldBright};
//           --dark:${C.dark};--dark2:${C.dark2};
//         }
//         *,*::before,*::after{box-sizing:border-box;}
//         .bp-root,.bp-root *{font-family:'DM Sans',sans-serif;}
//         .pf{font-family:'Playfair Display',serif!important;}

//         @keyframes _fadeUp  {from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
//         @keyframes _float   {0%,100%{transform:translateY(0) rotate(0)}50%{transform:translateY(-14px) rotate(3deg)}}
//         @keyframes _shine   {0%{left:-100%}25%{left:130%}100%{left:130%}}
//         @keyframes _goldBg  {0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
//         @keyframes _ticker  {from{transform:translateX(0)}to{transform:translateX(-50%)}}
//         @keyframes _pulse   {0%,100%{transform:scale(1)}50%{transform:scale(1.03)}}

//         .rv{opacity:0;transform:translateY(32px);transition:opacity .7s ease,transform .7s cubic-bezier(.16,1,.3,1);}
//         .rv.in{opacity:1;transform:translateY(0);}
//         .rv.d1{transition-delay:.1s}.rv.d2{transition-delay:.2s}.rv.d3{transition-delay:.3s}.rv.d4{transition-delay:.4s}

//         .bp-sec{padding:72px 0;}
//         .bp-sec-sm{padding:44px 0;}

//         .cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
//         .cc-tag-light{color:var(--gl)!important;}
//         .cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
//         .cc-h-white{color:#fff!important;}
//         .cc-h span{color:var(--p);}
//         .cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
//         .cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
//         .cc-sub-light{color:rgba(255,255,255,.55)!important;}

//         .cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;box-shadow:0 6px 20px rgba(94,14,115,.35);text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
//         .cc-btn:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(94,14,115,.45);color:#fff;}
//         .cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
//         .cc-btn-outline:hover{background:var(--p);color:#fff;}
//         .cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,var(--gold),var(--gb),var(--gold),#9A6E10);background-size:200% 200%;animation:_goldBg 3s ease infinite;color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;box-shadow:0 6px 20px rgba(201,168,76,.45);text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .3s,box-shadow .3s;}
//         .cc-btn-gold::before{content:'';position:absolute;top:0;left:-100%;width:55%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:_shine 3s ease infinite;}
//         .cc-btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(201,168,76,.55);color:var(--dark);}
//         .wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;box-shadow:0 6px 20px rgba(37,211,102,.3);font-family:'DM Sans',sans-serif;}
//         .wa-btn:hover{background:#1ebe5d;transform:translateY(-2px);color:#fff;}

//         .bp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
//         .bp-ticker-track{display:flex;width:max-content;animation:_ticker 22s linear infinite;}
//         .bp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

//         .bp-hero{position:relative;min-height:88vh;overflow:hidden;background:linear-gradient(135deg,rgba(26,0,48,.7) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.8) 100%),url('https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80') center/cover no-repeat;background-attachment:fixed;display:flex;align-items:center;}
//         .bp-hero-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
//         .bp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
//         .bp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.1);border:1px solid rgba(201,168,76,.32);backdrop-filter:blur(12px);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
//         .bp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 4px 24px rgba(0,0,0,.3);}
//         .bp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
//         .bp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
//         .bp-hero-img{width:100%;border-radius:32px;border:3px solid rgba(201,168,76,.35);box-shadow:0 40px 80px rgba(0,0,0,.45);display:block;object-fit:cover;aspect-ratio:4/5;}
//         .bp-hero-float{position:absolute;background:#fff;border-radius:16px;padding:12px 16px;box-shadow:0 14px 36px rgba(0,0,0,.2);animation:_float 4s ease-in-out infinite;white-space:nowrap;}
//         .bp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
//         .bp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
//         .bp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}
//         @media(max-width:768px){
//           .bp-hero{min-height:auto;padding:50px 16px 30px!important;}
//           .bp-hero-cnt{padding:40px 0 30px;display:flex;flex-direction:column;}
//           .bp-hero-title{font-size:clamp(24px,5vw,36px)!important;}
//           .bp-hero-sub{font-size:clamp(13px,3vw,15px)!important;margin-bottom:20px;}
//           .bp-hero-img{max-width:100%;border-radius:20px;}
//           .bp-trust-row{gap:14px;margin-top:20px;}
//           .theme-card{width:160px;}
//           .theme-card img{height:120px;}
//           .pkg-card{flex:0 1 calc(50% - 6px)!important;}
//           .activity-grid{grid-template-columns:repeat(2,1fr);gap:10px;}
//         }
//         @media(max-width:640px){
//           .bp-hero{padding:40px 12px 24px!important;}
//           .bp-hero-cnt{padding:30px 0 20px;}
//           .bp-hero-title{font-size:clamp(20px,5vw,28px)!important;}
//           .container{padding:0 12px;}
//           .theme-card{width:130px;}
//           .theme-card img{height:110px;}
//           .pkg-card{flex:0 1 100%!important;}
//           .activity-grid{grid-template-columns:1fr;gap:8px;}
//           .magic-reel-card{width:100px;height:180px;}
//           .magic-reel-name{font-size:10px;}
//           .magic-video-container{width:95%;height:60vh;border-radius:14px;}
//           button,.cc-btn-gold,.wa-btn,.magic-arrow-btn{min-height:44px!important;}
//         }

//         .why-card-lt{background:#fff;border-radius:24px;padding:28px 20px;text-align:center;border:1px solid rgba(94,14,115,.07);box-shadow:0 6px 24px rgba(94,14,115,.08);transition:all .4s cubic-bezier(.25,1,.5,1);}
//         .why-card-lt:hover{transform:translateY(-10px);box-shadow:0 22px 52px rgba(94,14,115,.14);border-color:rgba(201,168,76,.32);}
//         .why-icon-wrap{width:74px;height:74px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:32px;margin:0 auto 16px;background:linear-gradient(135deg,rgba(94,14,115,.1),rgba(94,14,115,.03));border:2px solid rgba(94,14,115,.09);animation:_float 5s ease-in-out infinite;}

//         .theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
//         .theme-card:hover{transform:translateY(-6px);}
//         .theme-img{width:100%;height:320px;object-fit:cover;transition:transform .5s;display:block;}
//         .theme-card:hover .theme-img{transform:scale(1.06);}
//         .theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.92) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
//         .theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
//         .theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
//         .theme-tag{background:rgba(255,255,255,.12);backdrop-filter:blur(4px);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
//         .bp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);backdrop-filter:blur(8px);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

//         .svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
//         @media(max-width:1024px){.svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
//         @media(max-width:540px) {.svc-grid{grid-template-columns:1fr 1fr;gap:12px;}}
//         .svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);box-shadow:0 4px 22px rgba(94,14,115,.07);transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s;cursor:pointer;position:relative;}
//         .svc-card:hover{transform:translateY(-12px);box-shadow:0 26px 62px rgba(94,14,115,.18);}
//         .svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .4s cubic-bezier(.25,1,.5,1),left .4s cubic-bezier(.25,1,.5,1);}
//         .svc-card:hover::after{width:100%;left:0;}
//         .svc-img-wrap{position:relative;height:200px;overflow:hidden;}
//         .svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .55s;}
//         .svc-card:hover .svc-img{transform:scale(1.09);}
//         .svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.5) 0%,transparent 60%);opacity:0;transition:opacity .35s;}
//         .svc-card:hover .svc-glow{opacity:1;}
//         .svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);backdrop-filter:blur(8px);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
//         .svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .35s,opacity .35s;}
//         .svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
//         .svc-body{padding:22px 14px 18px;position:relative;}
//         .svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 5px 14px rgba(94,14,115,.35);transition:transform .3s;}
//         .svc-card:hover .svc-float-icon{transform:rotate(-8deg) scale(1.1);}
//         .svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .25s;}
//         .svc-card:hover .svc-title{color:var(--p);}
//         .svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .4s cubic-bezier(.25,1,.5,1);}
//         .svc-card:hover .svc-line{width:42px;}
//         .svc-desc{font-size:12px;color:#888;line-height:1.6;}

//         .pkg-card{border-radius:26px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);transition:all .4s cubic-bezier(.25,1,.5,1);cursor:pointer;position:relative;}
//         .pkg-card:hover{transform:translateY(-12px);box-shadow:0 30px 70px rgba(0,0,0,.4);}
//         .pkg-card.featured{border-color:rgba(201,168,76,.5);box-shadow:0 0 40px rgba(201,168,76,.12);}
//         .pkg-pop-chip{position:absolute;top:16px;right:16px;z-index:3;background:linear-gradient(135deg,var(--gold),var(--gb));color:var(--dark);padding:5px 13px;border-radius:60px;font-size:10px;font-weight:800;letter-spacing:1px;text-transform:uppercase;}
//         .pkg-feat{display:flex;align-items:center;gap:10px;font-size:13px;color:rgba(255,255,255,.75);padding:5px 0;}
//         .pkg-feat-dot{width:18px;height:18px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:9px;}

//         .act-card{border-radius:18px;overflow:hidden;background:#fff;box-shadow:0 5px 18px rgba(94,14,115,.08);transition:all .4s;cursor:pointer;border:1px solid rgba(94,14,115,.07);}
//         .act-card:hover{transform:translateY(-8px) scale(1.02);box-shadow:0 20px 44px rgba(94,14,115,.17);}

//         .testi-sec{padding:80px 0;background:linear-gradient(160deg,var(--dark) 0%,#2A0040 40%,var(--dark) 100%);position:relative;overflow:hidden;}
//         .testi-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 50% at 50% 50%,rgba(94,14,115,.2) 0%,transparent 70%);pointer-events:none;}
//         .vtesti-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-bottom:26px;}
//         @media(max-width:1024px){.vtesti-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
//         @media(max-width:640px) {.vtesti-grid{grid-template-columns:1fr;gap:14px;}}
//         .vtesti-card{border-radius:20px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.2);transition:transform .35s,box-shadow .35s,border-color .35s;}
//         .vtesti-card:hover{transform:translateY(-8px);box-shadow:0 24px 60px rgba(0,0,0,.4);border-color:rgba(201,168,76,.4);}
//         .vtesti-iframe-wrap{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;}
//         .vtesti-iframe-wrap iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;display:block;}
//         .vtesti-footer{padding:14px 16px;display:flex;align-items:center;gap:10px;}
//         .vtesti-name{font-weight:700;font-size:14px;color:var(--gl);margin-bottom:2px;}
//         .vtesti-role{font-size:11px;color:rgba(255,255,255,.4);}
//         .rtesti-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
//         @media(max-width:1024px){.rtesti-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
//         @media(max-width:640px) {.rtesti-grid{grid-template-columns:1fr;gap:14px;}}
//         .rtesti-card{border-radius:20px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.15);transition:transform .35s,box-shadow .35s,border-color .35s;}
//         .rtesti-card:hover{transform:translateY(-6px);box-shadow:0 20px 50px rgba(0,0,0,.3);border-color:rgba(201,168,76,.35);}
//         .rtesti-photo{position:relative;height:150px;overflow:hidden;}
//         .rtesti-photo img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .4s;}
//         .rtesti-card:hover .rtesti-photo img{transform:scale(1.05);}
//         .rtesti-photo-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
//         .rtesti-body{padding:18px;}
//         .rtesti-header{display:flex;align-items:center;gap:12px;margin-bottom:12px;}
//         .rtesti-av-img{width:48px;height:48px;border-radius:50%;object-fit:cover;border:2px solid var(--gold);flex-shrink:0;}
//         .rtesti-av-fb{width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:17px;font-weight:800;color:#fff;flex-shrink:0;border:2px solid var(--gold);}
//         .rtesti-name{font-weight:700;font-size:15px;color:#fff;margin-bottom:2px;}
//         .rtesti-role{font-size:11px;color:rgba(255,255,255,.4);}
//         .rtesti-stars{color:var(--gold);font-size:14px;letter-spacing:2px;margin-bottom:10px;}
//         .rtesti-text{font-size:13px;color:rgba(255,255,255,.68);line-height:1.75;font-style:italic;}
//         .rtesti-occ{font-size:11px;color:var(--gold);font-weight:600;margin-top:10px;}
//         .testi-page-dots{display:flex;justify-content:center;gap:8px;margin-top:22px;}
//         .testi-pd{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .3s;}
//         .testi-pd.on{width:28px;border-radius:4px;background:linear-gradient(90deg,var(--gold),var(--gl));}
//         .testi-nav{display:flex;gap:10px;justify-content:flex-end;align-items:center;margin-bottom:18px;}
//         .testi-nav-btn{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.18);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;}
//         .testi-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}

//         .gal-bento{display:grid;grid-template-columns:repeat(12,1fr);gap:14px;margin-bottom:8px;}
//         .gbi-1{grid-column:span 5;grid-row:span 2;min-height:370px;}
//         .gbi-2{grid-column:span 4;min-height:178px;}
//         .gbi-3{grid-column:span 3;min-height:178px;}
//         .gbi-4{grid-column:span 4;min-height:178px;}
//         .gbi-5{grid-column:span 3;min-height:178px;}
//         .gbi-6{grid-column:span 7;min-height:215px;}
//         .gal-bento-item{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;background:var(--dark);opacity:0;transform:translateY(28px) scale(.97);transition:opacity .6s ease,transform .6s cubic-bezier(.25,1,.5,1),box-shadow .35s;}
//         .gal-bento-item.in{opacity:1;transform:translateY(0) scale(1);}
//         .gal-bento-item:hover{box-shadow:0 22px 60px rgba(94,14,115,.26);z-index:2;}
//         .gal-bento-item img{width:100%;height:100%;object-fit:cover;display:block;position:absolute;inset:0;transition:transform .6s cubic-bezier(.25,1,.5,1);}
//         .gal-bento-item:hover img{transform:scale(1.05);}
//         .gal-bento-ovl{position:absolute;inset:0;background:rgba(94,14,115,.35);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;font-size:28px;color:#fff;}
//         .gal-bento-item:hover .gal-bento-ovl{opacity:1;}
//         @media(max-width:1024px){
//           .gal-bento{grid-template-columns:repeat(6,1fr);gap:12px;}
//           .gbi-1{grid-column:span 3;grid-row:span 2;min-height:290px;}
//           .gbi-2{grid-column:span 3;min-height:140px;}
//           .gbi-3{grid-column:span 3;min-height:140px;}
//           .gbi-4,.gbi-5{grid-column:span 2;min-height:155px;}
//           .gbi-6{grid-column:span 2;min-height:155px;}
//         }
//         @media(max-width:640px){
//           .gal-bento{grid-template-columns:1fr 1fr;gap:10px;}
//           .gbi-1{grid-column:span 2;min-height:195px;grid-row:span 1;}
//           .gbi-2,.gbi-3,.gbi-4,.gbi-5{grid-column:span 1;min-height:145px;}
//           .gbi-6{grid-column:span 2;min-height:155px;}
//         }

//         .magic-reels-wrap{position:relative;overflow:hidden;width:100%;max-width:682px;margin:0 auto;}
//         .magic-reel-track{display:flex;gap:14px;transition:transform 0.6s cubic-bezier(.25,1,.5,1);width:fit-content;will-change:transform;transform:translateZ(0);}
//         .magic-reel-card{flex-shrink:0;width:160px;height:305px;border-radius:20px;overflow:hidden;position:relative;cursor:pointer;background:#000;transition:transform .35s,box-shadow .35s;aspect-ratio:9/16;}
//         .magic-reel-card:hover{transform:translateY(-8px) scale(1.03);box-shadow:0 20px 50px rgba(94,14,115,.3);}
//         .magic-reel-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
//         .magic-reel-card:hover .magic-reel-img{transform:scale(1.08);}
//         .magic-reel-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.95) 0%,rgba(26,0,48,.4) 50%,transparent 100%);display:flex;flex-direction:column;justify-content:flex-end;padding:14px;}
//         .magic-reel-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:50px;height:50px;border-radius:50%;background:rgba(201,168,76,.92);display:flex;align-items:center;justify-content:center;font-size:20px;transition:all .3s;box-shadow:0 8px 25px rgba(201,168,76,.5);z-index:2;cursor:pointer;}
//         .magic-reel-card:hover .magic-reel-play{background:var(--gold);transform:translate(-50%,-50%) scale(1.12);}
//         .magic-reel-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:2px;line-height:1.2;}
//         .magic-reel-event{font-size:8px;color:rgba(255,255,255,.65);margin-bottom:4px;}
//         .magic-reel-theme{display:inline-block;background:rgba(201,168,76,.25);color:var(--gold);font-size:8px;font-weight:700;padding:2px 8px;border-radius:50px;border:1px solid rgba(201,168,76,.5);}
//         .magic-nav-arrows{display:flex;gap:12px;justify-content:center;margin-top:20px;}
//         .magic-arrow-btn{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.1);border:1.5px solid rgba(255,255,255,.2);color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;font-weight:bold;}
//         .magic-arrow-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.05);}
//         .magic-video-modal{position:fixed;inset:0;background:rgba(0,0,0,.92);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;z-index:9999;animation:_fadeUp .3s ease-out;}
//         .magic-video-close{position:absolute;top:20px;right:20px;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:#fff;font-size:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .2s;z-index:10000;}
//         .magic-video-close:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}
//         .magic-video-container{width:90%;max-width:1100px;height:85vh;background:#000;border-radius:20px;overflow:hidden;box-shadow:0 40px 80px rgba(0,0,0,.8);display:flex;flex-direction:column;}
//         .magic-video-player{width:100%;height:100%;display:block;object-fit:contain;}
//         .magic-video-info{padding:20px 24px;background:var(--dark);color:#fff;}
//         .magic-video-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;margin-bottom:6px;}
//         .magic-video-event{font-size:14px;color:rgba(255,255,255,.6);margin-bottom:8px;}
//         .magic-video-theme{display:inline-block;background:rgba(201,168,76,.2);color:var(--gold);font-size:11px;font-weight:700;padding:5px 12px;border-radius:50px;border:1px solid rgba(201,168,76,.4);}

//         .bp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:all .3s;margin-bottom:12px;}
//         .bp-faq-item:hover{border-color:rgba(201,168,76,.4);box-shadow:0 7px 18px rgba(94,14,115,.09);}
//         .bp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
//         .bp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
//         .bp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .3s,background .3s;font-size:15px;color:var(--p);}
//         .bp-faq-item.open .bp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

//         .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;box-shadow:0 22px 56px rgba(94,14,115,.4);}
//         .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
//         .enq-right{background:#fff;padding:40px 36px;}
//         .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
//         .enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s;color:var(--dark);}
//         .enq-input:focus{border-color:var(--p);box-shadow:0 0 0 3px rgba(94,14,115,.08);}
//         .enq-input option{background:var(--dark);color:#fff;}
//         .enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
//         .enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
//         .enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
//         .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}
//         @media(max-width:991px){.enq-left{padding:28px 20px;}.enq-right{padding:24px 18px;}}

//         .cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;}
//         .cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}

//         .bp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);background-size:300% 300%;animation:_goldBg 6s ease infinite;}
//         .bp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.08) 0%,transparent 70%);pointer-events:none;}

//         .bp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
//         .bp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
//         .bp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

//         @media(max-width:576px){
//           .bp-sec{padding:48px 0;}
//           .bp-sec-sm{padding:30px 0;}
//           .container{padding-left:16px;padding-right:16px;}
//           .cc-h{font-size:clamp(23px,7vw,32px);}
//         }
//       `}</style>

//       <ScrollRevealWatcher />

//       <div className="bp-root">
//         <Header />

//         {/* ══ TICKER ══════════════════════════════════════════════════ */}
//         <div className="bp-ticker">
//           <div className="bp-ticker-track">
//             {[...Array(4)].map((_, k) =>
//               ["🎂 20+ Stunning Themes","⭐ 4000+ Celebrations","🎈 Professional Photography","🎵 DJ & Live Music","⚡ Book in 2 Minutes","🎉 Custom Cakes Available"].map((item, i) => (
//                 <span key={`${k}-${i}`} className="bp-ticker-item">{item}</span>
//               ))
//             )}
//           </div>
//         </div>

//         {/* ══ HERO ════════════════════════════════════════════════════ */}
//         <section className="bp-hero">
//           <div className="bp-hero-orb" style={{ width:500, height:500, background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`, top:-100, right:-80 }} />
//           <div className="bp-hero-orb" style={{ width:300, height:300, background:`radial-gradient(circle,rgba(245,158,11,.16) 0%,transparent 70%)`, bottom:80, left:-60 }} />

//           <div className="container bp-hero-cnt">
//             <div className="row align-items-center g-5">
//               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both" }}>
//                 <div className="bp-hero-badge">🎉 Hyderabad's #1 Birthday Venue</div>
//                 <h1 className="bp-hero-title pf">
//                   Celebrate Your <span>Big Day</span><br />in Unforgettable Style
//                 </h1>
//                 <p className="bp-hero-sub">
//                   From cosmic adventures to carnival fiestas — 20+ incredible themes, professional setups, and memories you'll relive for years to come.
//                 </p>
//                 <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
//                   <button onClick={() => document.getElementById("packages")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎈 Explore Packages</button>
//                   <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-outline" style={{ borderColor:"rgba(255,255,255,.4)", color:"#fff" }}>📞 Get a Callback</button>
//                 </div>
//                 <div className="bp-trust-row">
//                   {[["4000+","Celebrations"],["4.9★","Rating"],["20+","Themes"]].map(([n, l]) => (
//                     <div key={l} className="bp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
//                   ))}
//                 </div>
//               </div>
//               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both" }}>
//                 <div style={{ position:"relative" }}>
//                   <img
//                     src="https://cdn.togetherv.com/birthday-surprise-main_1681375822.webp"
//                     alt="Birthday Celebration"
//                     className="bp-hero-img"
//                     style={{ height:500 }}
//                   />
//                   <div className="bp-hero-float d-none d-md-block" style={{ bottom:32, left:-28, animationDelay:"0s" }}>
//                     <div style={{ fontSize:10, color:"#888", marginBottom:4, textTransform:"uppercase", letterSpacing:1 }}>Just Booked!</div>
//                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
//                       <span style={{ fontSize:18 }}>🎪</span>
//                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>Carnival Fiesta</div><div style={{ fontSize:11, color:C.primary }}>Rahul's 25th Birthday</div></div>
//                     </div>
//                   </div>
//                   <div className="bp-hero-float d-none d-md-block" style={{ top:32, right:-28, animationDelay:"1.5s" }}>
//                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
//                       <span style={{ fontSize:18 }}>⭐</span>
//                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>4.9 / 5.0</div><div style={{ fontSize:11, color:"#888" }}>4000+ Celebrations</div></div>
//                     </div>
//                   </div>
//                   <div style={{ position:"absolute", inset:-14, borderRadius:40, border:`2px solid rgba(201,168,76,.17)`, pointerEvents:"none", animation:"_pulse 3s ease-in-out infinite" }} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ THEMES CAROUSEL ═════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:C.dark, overflow:"hidden" }}>
//           <div className="container">
//             <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:44, flexWrap:"wrap", gap:20 }}>
//               <div>
//                 <span className="cc-tag cc-tag-light">✦ 20+ Dream Themes ✦</span>
//                 <h2 className="cc-h cc-h-white">Your Birthday, Your <span className="gold">Perfect Theme</span></h2>
//               </div>
//               <div style={{ display:"flex", gap:10 }}>
//                 <button className="cc-nav-btn" onClick={() => setThemeIdx(i => (i - 1 + BIRTHDAY_THEMES.length) % BIRTHDAY_THEMES.length)}>‹</button>
//                 <button className="cc-nav-btn" onClick={() => setThemeIdx(i => (i + 1) % BIRTHDAY_THEMES.length)}>›</button>
//               </div>
//             </div>
//             <div style={{ overflow:"hidden" }}>
//               <div style={{ display:"flex", gap:18, transition:"transform .7s cubic-bezier(.25,1,.5,1)", transform:`translateX(calc(-${themeIdx * (280 + 18)}px))` }}>
//                 {[...BIRTHDAY_THEMES, ...BIRTHDAY_THEMES].map((t, i) => (
//                   <div key={i} className="theme-card" onClick={() => navigate("/locations")}>
//                     <div className="bp-emoji-badge">{t.emoji}</div>
//                     <img src={t.img} alt={t.name} className="theme-img" />
//                     <div className="theme-ovl">
//                       <div className="theme-name">{t.name}</div>
//                       <div className="theme-booked">🔥 {t.bookings} booked</div>
//                       <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginTop:8 }}>
//                         {t.tags.map((tg, j) => <span key={j} className="theme-tag">{tg}</span>)}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div style={{ display:"flex", gap:8, justifyContent:"center", marginTop:26 }}>
//               {BIRTHDAY_THEMES.map((_, i) => (
//                 <button key={i} onClick={() => setThemeIdx(i)} style={{ width:i === themeIdx ? 26 : 8, height:8, borderRadius:8, background:i === themeIdx ? C.gold : "rgba(255,255,255,.2)", border:"none", cursor:"pointer", transition:"all .4s" }} />
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ SERVICES ════════════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:"#fff", overflow:"hidden" }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:44 }}>
//               <span className="cc-tag">✦ Party Services ✦</span>
//               <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Birthday</h2>
//               <p className="cc-sub">Decor, cakes, food, photography — every detail handled so you can enjoy every moment.</p>
//             </div>
//             <div className="bp-divider"><div className="bp-dl" /><div className="bp-dg" /><div className="bp-dl" /></div>
//             <div className="svc-grid rv">
//               {SERVICE_CARDS.map((s, i) => (
//                 <div key={i} className="svc-card">
//                   <div className="svc-img-wrap">
//                     <img src={s.img} alt={s.label} className="svc-img" />
//                     <div className="svc-glow" />
//                     <div className="svc-num">0{i + 1}</div>
//                     <div className="svc-pill">{["✨ Custom","🎂 Bespoke","🍽️ Fresh","📸 Pro"][i]}</div>
//                   </div>
//                   <div className="svc-body">
//                     <div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div>
//                     <div className="svc-title pf">{s.label}</div>
//                     <span className="svc-line" />
//                     <p className="svc-desc">{s.desc}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ ACTIVITIES ══════════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:C.cream }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:44 }}>
//               <span className="cc-tag">✦ Fun Experiences ✦</span>
//               <h2 className="cc-h">Keep the Energy <span>Going All Night</span></h2>
//             </div>
//             <div className="row g-4">
//               {BIRTHDAY_ACTIVITIES.map((act, i) => (
//                 <div key={i} className={`col-md-3 col-6 rv d${i + 1}`}>
//                   <div className="act-card">
//                     <div style={{ overflow:"hidden", height:185 }}>
//                       <img src={act.img} alt={act.name} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", transition:"transform .45s" }}
//                         onMouseOver={e => e.target.style.transform = "scale(1.07)"}
//                         onMouseOut={e => e.target.style.transform = "scale(1)"} />
//                     </div>
//                     <div style={{ padding:"14px" }}>
//                       <h3 style={{ fontSize:15, fontWeight:700, marginBottom:5, color:C.dark }}>{act.name}</h3>
//                       <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"#888" }}>
//                         <span>⏱️ {act.dur}</span><span>🎂 {act.age}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ PACKAGES ════════════════════════════════════════════════ */}
//         <section id="packages" className="bp-sec" style={{ background:C.dark2 }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:52 }}>
//               <span className="cc-tag cc-tag-light">✦ Birthday Packages ✦</span>
//               <h2 className="cc-h cc-h-white">Pick Your Perfect <span className="gold">Celebration</span></h2>
//               <p className="cc-sub cc-sub-light">Every package is fully customizable. Our team handles setup, decor, and cleanup.</p>
//             </div>
//             <div className="row g-4 justify-content-center">
//               {BIRTHDAY_PACKAGES.map((pkg, i) => (
//                 <div key={i} className={`col-lg-4 col-md-6 rv d${i + 1}`}>
//                   <div className={`pkg-card h-100${pkg.popular ? " featured" : ""}`}>
//                     {pkg.popular && <div className="pkg-pop-chip">⭐ Most Popular</div>}
//                     <div style={{ position:"relative", overflow:"hidden" }}>
//                       <img src={pkg.img} alt={pkg.name}
//                         style={{ width:"100%", height:210, objectFit:"cover", display:"block", transition:"transform .5s" }}
//                         onMouseOver={e => e.target.style.transform = "scale(1.06)"}
//                         onMouseOut={e => e.target.style.transform = "scale(1)"} />
//                       <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(13,0,24,.85),transparent)" }} />
//                       <div style={{ position:"absolute", bottom:12, left:12, display:"flex", gap:8 }}>
//                         <span style={{ background:"rgba(0,0,0,.5)", backdropFilter:"blur(8px)", color:"#fff", padding:"4px 10px", borderRadius:60, fontSize:10 }}>⏱️ {pkg.dur}</span>
//                         <span style={{ background:"rgba(0,0,0,.5)", backdropFilter:"blur(8px)", color:"#fff", padding:"4px 10px", borderRadius:60, fontSize:10 }}>👥 {pkg.guests}</span>
//                       </div>
//                     </div>
//                     <div style={{ padding:"20px" }}>
//                       <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
//                         <div>
//                           <div style={{ fontSize:10, color:"rgba(255,255,255,.3)", fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginBottom:3 }}>{pkg.emoji} Package</div>
//                           <h3 className="pf" style={{ fontSize:21, fontWeight:700, color:"#fff", margin:0 }}>{pkg.name}</h3>
//                         </div>
//                         <div style={{ textAlign:"right" }}>
//                           <div className="pf" style={{ fontSize:24, fontWeight:900, color:pkg.color, lineHeight:1 }}>{pkg.price}</div>
//                           <div style={{ fontSize:9, color:"rgba(255,255,255,.3)", textTransform:"uppercase", letterSpacing:1 }}>Starting from</div>
//                         </div>
//                       </div>
//                       <div style={{ borderTop:"1px solid rgba(255,255,255,.06)", paddingTop:12, marginBottom:16 }}>
//                         {pkg.features.map((f, j) => (
//                           <div key={j} className="pkg-feat">
//                             <div className="pkg-feat-dot" style={{ background:`${pkg.color}20` }}><span style={{ color:pkg.color, fontSize:11 }}>✓</span></div>
//                             {f}
//                           </div>
//                         ))}
//                       </div>
//                       <button className="cc-btn-gold" style={{ width:"100%", justifyContent:"center", padding:"13px" }}
//                         onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
//                         Book This Package →
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ WHY US ══════════════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:C.cream }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:52 }}>
//               <span className="cc-tag">✦ Why Choose Us ✦</span>
//               <h2 className="cc-h">Celebrations That Are <span>Premium</span> & Stress-Free</h2>
//               <p className="cc-sub">We handle every detail so you're fully present in your most special moments.</p>
//             </div>
//             <div className="row g-4">
//               {WHY_US.map((item, i) => (
//                 <div key={i} className={`col-md-3 col-6 rv d${i + 1}`}>
//                   <div className="why-card-lt">
//                     <div className="why-icon-wrap" style={{ animationDelay:`${i * 0.5}s` }}>{item.icon}</div>
//                     <h3 className="pf" style={{ fontSize:16, fontWeight:700, color:C.dark, marginBottom:7 }}>{item.title}</h3>
//                     <p style={{ fontSize:12, color:"#888", lineHeight:1.6, margin:0 }}>{item.desc}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* ══ MAGIC REELS CAROUSEL ════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:C.dark, overflow:"hidden", padding:"48px 0" }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:32 }}>
//               <span className="cc-tag cc-tag-light">✦ Our Reels ✦</span>
//               <h2 className="cc-h cc-h-white">See the <span className="gold">Magic</span> Happen</h2>
//               <p className="cc-sub cc-sub-light">Watch real birthday celebrations — the energy, the joy, the unforgettable moments.</p>
//             </div>

//             <div className="magic-reels-wrap"
//               onMouseEnter={() => setReelHover(true)}
//               onMouseLeave={() => setReelHover(false)}>
//               <div className="magic-reel-track" style={{ transform:`translateX(calc(-${reelIdx * (160 + 14)}px))` }}>
//                 {extendedReels.map((reel, i) => (
//                   <div key={i} className="magic-reel-card" onClick={() => setPlayingReel(reel)}>
//                     <img src={reel.img} alt={reel.name} className="magic-reel-img" />
//                     <div className="magic-reel-play" onClick={e => { e.stopPropagation(); setPlayingReel(reel); }}>▶</div>
//                     <div className="magic-reel-ovl">
//                       <div className="magic-reel-name">{reel.name}</div>
//                       <div className="magic-reel-event">{reel.event}</div>
//                       <span className="magic-reel-theme">{reel.theme}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="magic-nav-arrows">
//               <button className="magic-arrow-btn" onClick={() => setReelIdx(i => i === 0 ? MAGIC_REELS.length - 1 : i - 1)}>‹</button>
//               <button className="magic-arrow-btn" onClick={() => setReelIdx(i => (i + 1) % MAGIC_REELS.length)}>›</button>
//             </div>

//             <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:24, flexWrap:"wrap" }}>
//               <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎉 Plan Your Birthday</button>
//               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn">
//                 <i className="bi bi-whatsapp" /> Message Us
//               </a>
//             </div>
//           </div>
//         </section>

//         {/* ══ VIDEO MODAL ═════════════════════════════════════════════ */}
//         {playingReel && (
//           <div className="magic-video-modal" onClick={() => setPlayingReel(null)}>
//             <button className="magic-video-close" onClick={() => setPlayingReel(null)}>✕</button>
//             <div className="magic-video-container" onClick={e => e.stopPropagation()}>
//               <video ref={videoRef} className="magic-video-player" controls autoPlay>
//                 <source src={playingReel.video} type="video/mp4" />
//                 Your browser does not support the video tag.
//               </video>
//               <div className="magic-video-info">
//                 <div className="magic-video-title">{playingReel.name}</div>
//                 <div className="magic-video-event">{playingReel.event}</div>
//                 <span className="magic-video-theme">{playingReel.theme}</span>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ══ GALLERY ═════════════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:C.primaryPale, overflow:"hidden" }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:50 }}>
//               <span className="cc-tag">✦ Birthday Gallery ✦</span>
//               <h2 className="cc-h">Real Memories from <span>Real Celebrations</span></h2>
//               <p className="cc-sub">Captured highlights from birthdays we've had the pleasure of making unforgettable.</p>
//             </div>
//             <div className="gal-bento rv">
//               {BIRTHDAY_GALLERY.map((img, i) => (
//                 <div key={i} className={`gal-bento-item gbi-${i + 1}`} style={{ animationDelay:`${i * 0.08}s` }}
//                   onClick={() => { setActiveGal(i); galleria.current?.show(); }}>
//                   <img src={img} alt={`Celebration ${i + 1}`} />
//                   <div className="gal-bento-ovl">🔍</div>
//                 </div>
//               ))}
//             </div>
//             <Galleria ref={galleria} value={BIRTHDAY_GALLERY} numVisible={5} activeIndex={activeGal}
//               onItemChange={e => setActiveGal(e.index)} circular fullScreen showItemNavigators showThumbnails={false}
//               item={galItem} thumbnail={galThumb} />
//             <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:34, flexWrap:"wrap" }}>
//               <a href="/locations" className="cc-btn">Book Your Birthday →</a>
//               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn">
//                 <i className="bi bi-whatsapp" /> Chat With Us
//               </a>
//             </div>
//           </div>
//           <GalleryEntranceObserver />
//         </section>

//         {/* ══ TESTIMONIALS ════════════════════════════════════════════ */}
//         <section className="testi-sec">
//           <div className="container" style={{ position:"relative", zIndex:1 }}>

//             <div style={{ marginBottom:64 }}>
//               <div className="text-center rv" style={{ marginBottom:38 }}>
//                 <span className="cc-tag cc-tag-light">✦ Video Reviews ✦</span>
//                 <h2 className="cc-h cc-h-white">Real Stories, <span className="gold">Real Joy</span></h2>
//                 <p className="cc-sub cc-sub-light">Watch what birthday celebrants experienced at their parties — in their own words.</p>
//               </div>

//               {videoTesti.length > VIDS_PER && (
//                 <div className="testi-nav">
//                   <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{videoPage + 1} / {totalVP}</span>
//                   <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.max(0, p - 1))}>‹</button>
//                   <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.min(totalVP - 1, p + 1))}>›</button>
//                 </div>
//               )}

//               <div className="vtesti-grid rv">
//                 {visVids.map((item, idx) => (
//                   <div key={idx} className="vtesti-card">
//                     <div className="vtesti-iframe-wrap">
//                       <iframe src={`https://www.youtube.com/embed/${item.videoId}?rel=0&modestbranding=1`}
//                         title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
//                     </div>
//                     <div className="vtesti-footer">
//                       {item.profileImage
//                         ? <img src={`https://api.carnivalcastle.com/${item.profileImage?.replace(/\\/g, "/")}`} alt={item.name}
//                             style={{ width:34, height:34, borderRadius:"50%", objectFit:"cover", border:`2px solid ${C.gold}`, flexShrink:0 }}
//                             onError={e => { e.target.style.display = "none"; }} />
//                         : <div style={{ width:34, height:34, borderRadius:"50%", background:`linear-gradient(135deg,${C.primary},${C.primaryLight})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:800, color:"#fff", border:`2px solid ${C.gold}`, flexShrink:0 }}>{item.name?.charAt(0) || "G"}</div>
//                       }
//                       <div>
//                         <div className="vtesti-name">{item.name}</div>
//                         <div className="vtesti-role">{item.role || "Birthday Celebrant"}</div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {videoTesti.length > VIDS_PER && (
//                 <div className="testi-page-dots">
//                   {Array.from({ length:totalVP }).map((_, i) => (
//                     <button key={i} className={`testi-pd${i === videoPage ? " on" : ""}`} onClick={() => setVideoPage(i)} />
//                   ))}
//                 </div>
//               )}
//             </div>

//             <div style={{ display:"flex", alignItems:"center", gap:20, marginBottom:52 }}>
//               <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(201,168,76,.3))" }} />
//               <span style={{ color:C.gold, fontSize:20 }}>✦</span>
//               <div style={{ flex:1, height:1, background:"linear-gradient(90deg,rgba(201,168,76,.3),transparent)" }} />
//             </div>

//             <div>
//               <div className="text-center rv" style={{ marginBottom:38 }}>
//                 <span className="cc-tag cc-tag-light">✦ Guest Reviews ✦</span>
//                 <h2 className="cc-h cc-h-white">What <span className="gold">Happy Guests</span> Say</h2>
//                 <p className="cc-sub cc-sub-light">Hundreds of 5-star reviews from real birthday celebrations across Hyderabad.</p>
//               </div>

//               {textTesti.length > REVS_PER && (
//                 <div className="testi-nav">
//                   <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{reviewPage + 1} / {totalRP}</span>
//                   <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.max(0, p - 1))}>‹</button>
//                   <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.min(totalRP - 1, p + 1))}>›</button>
//                 </div>
//               )}

//               <div className="rtesti-grid rv">
//                 {visRevs.map((rv, i) => (
//                   <div key={i} className="rtesti-card">
//                     <div className="rtesti-photo">
//                       <img src={rv.image} alt={rv.name} onError={e => { e.target.parentElement.style.display = "none"; }} />
//                       <div className="rtesti-photo-ovl" />
//                     </div>
//                     <div className="rtesti-body">
//                       <div className="rtesti-header">
//                         {rv.avatar && !rv.avatar.endsWith("undefined")
//                           ? <img src={rv.avatar} alt={rv.name} className="rtesti-av-img" onError={e => { e.target.style.display="none"; }} />
//                           : <div className="rtesti-av-fb">{rv.name?.charAt(0) || "G"}</div>
//                         }
//                         <div>
//                           <div className="rtesti-name">{rv.name}</div>
//                           <div className="rtesti-role">{rv.role}</div>
//                         </div>
//                       </div>
//                       <div className="rtesti-stars">{"★".repeat(rv.rating)}{"☆".repeat(5 - rv.rating)}</div>
//                       <p className="rtesti-text">"{rv.description}"</p>
//                       {rv.occasion && <div className="rtesti-occ">🎉 {rv.occasion}</div>}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {textTesti.length > REVS_PER && (
//                 <div className="testi-page-dots">
//                   {Array.from({ length:totalRP }).map((_, i) => (
//                     <button key={i} className={`testi-pd${i === reviewPage ? " on" : ""}`} onClick={() => setReviewPage(i)} />
//                   ))}
//                 </div>
//               )}

//               <div style={{ background:"rgba(255,255,255,.04)", border:"1px solid rgba(201,168,76,.2)", borderRadius:20, padding:"26px 24px", marginTop:40, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:18 }} className="rv">
//                 <div>
//                   <div className="pf" style={{ fontSize:"clamp(42px,7vw,62px)", fontWeight:900, color:C.gold, lineHeight:1 }}>4.9</div>
//                   <div style={{ color:C.gold, fontSize:18, letterSpacing:3, marginTop:4 }}>★★★★★</div>
//                   <div style={{ color:"rgba(255,255,255,.4)", fontSize:12, marginTop:4 }}>Average from {textTesti.length}+ reviews</div>
//                 </div>
//                 <div style={{ display:"flex", gap:22, flexWrap:"wrap" }}>
//                   {[["🎂","Decor","98%"],["🎵","Music","97%"],["💰","Value","95%"],["📞","Support","99%"]].map(([icon, label, pct]) => (
//                     <div key={label} style={{ textAlign:"center" }}>
//                       <div style={{ fontSize:22 }}>{icon}</div>
//                       <div style={{ color:"#fff", fontWeight:700, fontSize:14, margin:"3px 0 2px" }}>{pct}</div>
//                       <div style={{ color:"rgba(255,255,255,.4)", fontSize:11 }}>{label}</div>
//                     </div>
//                   ))}
//                 </div>
//                 <button className="cc-btn-gold" style={{ padding:"13px 28px", fontSize:14 }}
//                   onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
//                   🎉 Book & Experience
//                 </button>
//               </div>
//             </div>
//           </div>
//         </section>

//         <CouponSection />

//         {/* ══ ENQUIRY FORM ═════════════════════════════════════════════ */}
//         <section id="enquiry" className="bp-sec" style={{ background:C.beige }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:44 }}>
//               <span className="cc-tag">✦ Book Your Birthday ✦</span>
//               <h2 className="cc-h">Plan the Celebration <span>of Your Dreams</span></h2>
//               <p className="cc-sub">Fill in the details and our birthday specialist will call you within 2 hours.</p>
//             </div>
//             <div className="enq-wrap rv" style={{ maxWidth:980, margin:"0 auto" }}>
//               <div className="row g-0">
//                 <div className="col-lg-4">
//                   <div className="enq-left h-100">
//                     <div>
//                       <h3 className="pf" style={{ color:"#fff", fontSize:23, fontWeight:700, marginBottom:8 }}>Let's Create <span style={{ color:C.goldLight }}>Magic</span> Together</h3>
//                       <p style={{ color:"rgba(255,255,255,.58)", fontSize:13, lineHeight:1.7, marginBottom:24 }}>Share your birthday details and we'll craft an unforgettable celebration experience.</p>
//                     </div>
//                     <div>
//                       {[
//                         { icon:"⚡", label:"2-Hour Callback",    val:"We call within 2 hours" },
//                         { icon:"🎨", label:"Free Theme Consult", val:"Expert advice included" },
//                         { icon:"💰", label:"Price Match",        val:"Best price guaranteed" },
//                         { icon:"💬", label:"WhatsApp Us",        val:"+91 8374777834", href:"https://wa.me/918374777834" },
//                       ].map((it, i) => (
//                         <div key={i} className="enq-contact-info">
//                           <div className="enq-ci-icon">{it.icon}</div>
//                           <div>
//                             <div className="enq-ci-label">{it.label}</div>
//                             {it.href
//                               ? <a href={it.href} style={{ color:"#fff", fontWeight:500, fontSize:13, textDecoration:"none" }}>{it.val}</a>
//                               : <span style={{ color:"#fff", fontWeight:500, fontSize:13 }}>{it.val}</span>
//                             }
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-8">
//                   <div className="enq-right">
//                     <h3 className="pf" style={{ fontSize:21, fontWeight:700, color:C.dark, marginBottom:4 }}>Book Your <span style={{ color:C.primary }}>Birthday!</span></h3>
//                     <p style={{ color:"#aaa", fontSize:13, marginBottom:22 }}>Free callback within 2 hours • No obligation</p>
//                     <form onSubmit={handleSubmit}>
//                       <div className="row g-3">
//                         <div className="col-md-6">
//                           <label className="enq-label">Your Name *</label>
//                           <input type="text" name="name" className="enq-input" placeholder="e.g. Rahul Sharma" value={form.name} onChange={handleChange} required />
//                         </div>
//                         <div className="col-md-6">
//                           <label className="enq-label">Phone Number *</label>
//                           <input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={handleChange} required />
//                         </div>
//                         <div className="col-md-6">
//                           <label className="enq-label">Email Address</label>
//                           <input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={handleChange} />
//                         </div>
//                         <div className="col-md-6">
//                           <label className="enq-label">Birthday Person's Age</label>
//                           <input type="text" name="age" className="enq-input" placeholder="e.g. Turning 25" value={form.age} onChange={handleChange} />
//                         </div>
//                         <div className="col-md-6">
//                           <label className="enq-label">Preferred Theme *</label>
//                           <select name="theme" className="enq-input" value={form.theme} onChange={handleChange} required>
//                             <option value="">Choose a theme…</option>
//                             {BIRTHDAY_THEMES.map((t, i) => <option key={i} value={t.name}>{t.emoji} {t.name}</option>)}
//                           </select>
//                         </div>
//                         <div className="col-md-6">
//                           <label className="enq-label">Party Date *</label>
//                           <input type="date" name="date" className="enq-input" value={form.date} onChange={handleChange} required />
//                         </div>
//                         <div className="col-12">
//                           <label className="enq-label">Number of Guests *</label>
//                           <select name="guests" className="enq-input" value={form.guests} onChange={handleChange} required>
//                             <option value="">How many guests are coming?</option>
//                             <option>Up to 15 guests</option>
//                             <option>16–30 guests</option>
//                             <option>31–50 guests</option>
//                             <option>50+ guests</option>
//                           </select>
//                         </div>
//                         <div className="col-12" style={{ marginTop:4 }}>
//                           <button type="submit" className="cc-btn-gold" style={{ width:"100%", justifyContent:"center", padding:"15px", fontSize:15 }}>
//                             🎉 Request a Free Callback 🎉
//                           </button>
//                           <p style={{ textAlign:"center", fontSize:11, color:"#aaa", marginTop:10 }}>No spam. We'll call to discuss your birthday and that's it.</p>
//                         </div>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ FAQ ══════════════════════════════════════════════════════ */}
//         <section className="bp-sec" style={{ background:"#fff" }}>
//           <div className="container">
//             <div className="text-center rv" style={{ marginBottom:44 }}>
//               <span className="cc-tag">✦ FAQ ✦</span>
//               <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
//             </div>
//             <div className="row justify-content-center">
//               <div className="col-lg-8">
//                 {BIRTHDAY_FAQ.map((faq, i) => (
//                   <div key={i} className={`bp-faq-item${activeFaq === i ? " open" : ""}`}
//                     onClick={() => setActiveFaq(activeFaq === i ? null : i)}>
//                     <div className="bp-faq-q">
//                       <span>{faq.q}</span>
//                       <div className="bp-faq-arrow">▾</div>
//                     </div>
//                     {activeFaq === i && <div className="bp-faq-a">{faq.a}</div>}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══ CTA BANNER ═══════════════════════════════════════════════ */}
//         <section className="bp-cta-sec bp-sec-sm">
//           <div className="container text-center" style={{ position:"relative", zIndex:1 }}>
//             <span style={{ fontSize:50 }}>🎂</span>
//             <h2 className="pf" style={{ fontSize:"clamp(24px,4vw,42px)", color:"#fff", fontWeight:900, marginTop:12, marginBottom:12 }}>
//               Ready to Make It <span style={{ background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Unforgettable?</span>
//             </h2>
//             <p style={{ color:"rgba(255,255,255,.63)", fontSize:15, marginBottom:26, maxWidth:460, margin:"0 auto 26px" }}>
//               Book your birthday celebration today. We handle everything so you just celebrate.
//             </p>
//             <button className="cc-btn-gold" style={{ fontSize:15, padding:"15px 40px", animation:"_pulse 2.5s ease-in-out infinite" }}
//               onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
//               🎈 Book Your Birthday Now
//             </button>
//             <p style={{ color:"rgba(255,255,255,.32)", fontSize:12, marginTop:12 }}>Join 4000+ happy guests who celebrated with us</p>
//           </div>
//         </section>

//         <Footer />
//         <ToastContainer position="top-center" autoClose={4000} theme="dark" />
//         <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />
//       </div>
//     </>
//   );
// }

// /* ─── Helpers — identical to KidsPage ───────────────────────────────────── */
// function ScrollRevealWatcher() {
//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
//       { threshold:0.08 }
//     );
//     document.querySelectorAll(".rv").forEach(el => obs.observe(el));
//     return () => obs.disconnect();
//   }, []);
//   return null;
// }

// function GalleryEntranceObserver() {
//   useEffect(() => {
//     const items = document.querySelectorAll(".gal-bento-item");
//     const obs = new IntersectionObserver(entries => {
//       entries.forEach(e => {
//         if (e.isIntersecting) {
//           const idx = Array.from(items).indexOf(e.target);
//           e.target.style.transitionDelay = `${idx * 0.08}s`;
//           e.target.classList.add("in");
//           obs.unobserve(e.target);
//         }
//       });
//     }, { threshold:0.1 });
//     items.forEach(el => obs.observe(el));
//     return () => obs.disconnect();
//   }, []);
//   return null;
// }

import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import { Galleria } from "primereact/galleria";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import Header from "../components/Header";
import CouponSection from "../components/Coupons";
import PopupModal from "../components/PopUpModal";
import TestimonialsSection from "../components/TestimonialsSection";

const C = {
  primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
  primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
  gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
  dark:"#1A0030", dark2:"#120020",
};

// const GLOBAL_CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
// :root{--p:#5E0E73;--pl:#6E1A85;--pd:#3A0847;--pp:#F3E5F7;--cream:#E8E1D6;--beige:#D6CFC4;--gold:#C9A84C;--gl:#E8D5A0;--gb:#F5D87A;--dark:#1A0030;--dark2:#120020;}
// *,*::before,*::after{box-sizing:border-box;}
// .kp-root,.kp-root *{font-family:'DM Sans',sans-serif;}
// .pf{font-family:'Playfair Display',serif!important;}

// @keyframes _fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
// @keyframes _ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes _spin{to{transform:rotate(360deg)}}
// @keyframes _float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
// @keyframes _pulse{0%,100%{opacity:.7}50%{opacity:1}}
// @keyframes _shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
// @keyframes kr-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
// @keyframes kr-fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-pulse{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.2);opacity:.85}}
// @keyframes kvt-quoteIn{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:translateX(0)}}
// @keyframes kvt-nameIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-ctrlIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-eqBar{0%,100%{height:5px}50%{height:18px}}
// @keyframes kvt-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}

// .rv{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s cubic-bezier(.16,1,.3,1);}
// .rv.in{opacity:1;transform:translateY(0);}
// .rv.d1{transition-delay:.08s}.rv.d2{transition-delay:.16s}.rv.d3{transition-delay:.24s}.rv.d4{transition-delay:.32s}

// .kp-sec{padding:72px 0;}.kp-sec-sm{padding:44px 0;}

// .cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
// .cc-tag-light{color:var(--gl)!important;}
// .cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
// .cc-h-white{color:#fff!important;}
// .cc-h span{color:var(--p);}
// .cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
// .cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
// .cc-sub-light{color:rgba(255,255,255,.55)!important;}

// .cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;position:relative;}
// .cc-btn:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
// .cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,background .25s,color .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// .cc-btn-outline:hover{background:var(--p);color:#fff;transform:translateY(-2px);}
// .cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B 0%,var(--gold) 50%,#9A6E10 100%);color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .25s,opacity .25s;box-shadow:0 4px 18px rgba(201,168,76,.35);}
// .cc-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:_shine 3.5s ease infinite;pointer-events:none;}
// .cc-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:var(--dark);}
// .wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// .wa-btn:hover{transform:translateY(-2px);opacity:.88;color:#fff;}
// .cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;}
// .cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.08);}

// .kp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
// .kp-ticker-track{display:flex;width:max-content;animation:_ticker 26s linear infinite;will-change:transform;}
// .kp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

// .kp-hero{position:relative;min-height:88vh;background:linear-gradient(135deg,rgba(26,0,48,.75) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.82) 100%),url('https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=1200&q=80') center/cover no-repeat;display:flex;align-items:center;overflow-x:clip;}
// .kp-hero-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none;}
// .kp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
// .kp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.38);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
// .kp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 2px 12px rgba(0,0,0,.3);}
// .kp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
// .kp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
// .kp-hero-vid-wrap{position:relative;border-radius:28px;border:2px solid rgba(201,168,76,.3);overflow:hidden;aspect-ratio:9/16;max-height:500px;background:#000;}
// .kp-hero-vid-wrap video{width:100%;height:100%;object-fit:cover;display:block;}
// .kp-hero-vid-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.55) 0%,transparent 55%);pointer-events:none;}
// .kp-hero-vid-badge{position:absolute;bottom:14px;left:14px;right:14px;display:flex;align-items:center;gap:10px;background:rgba(0,0,0,.55);border-radius:10px;padding:9px 12px;border:1px solid rgba(201,168,76,.2);}
// .kp-hero-vid-pulse{width:8px;height:8px;border-radius:50%;background:#EF4444;flex-shrink:0;animation:_pulse 1.8s ease-in-out infinite;}
// .kp-hero-vid-label{font-size:11px;color:rgba(255,255,255,.8);font-weight:600;letter-spacing:.5px;}
// .kp-hero-float{position:absolute;background:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 8px 24px rgba(0,0,0,.18);animation:_float 5s ease-in-out infinite;white-space:nowrap;will-change:transform;}
// .kp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
// .kp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
// .kp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}

// .theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
// .theme-card:hover{transform:translateY(-6px);}
// .theme-img{width:100%;height:320px;object-fit:cover;transition:transform .45s;display:block;}
// .theme-card:hover .theme-img{transform:scale(1.05);}
// .theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.9) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
// .theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
// .theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
// .theme-tag{background:rgba(255,255,255,.12);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
// .kp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

// .svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
// .svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);transition:transform .35s;cursor:pointer;position:relative;}
// .svc-card:hover{transform:translateY(-10px);}
// .svc-card::before{content:'';position:absolute;inset:0;border-radius:22px;box-shadow:0 24px 56px rgba(94,14,115,.18);opacity:0;transition:opacity .35s;z-index:-1;}
// .svc-card:hover::before{opacity:1;}
// .svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .35s,left .35s;}
// .svc-card:hover::after{width:100%;left:0;}
// .svc-img-wrap{position:relative;height:200px;overflow:hidden;}
// .svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .45s;}
// .svc-card:hover .svc-img{transform:scale(1.07);}
// .svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.45) 0%,transparent 60%);opacity:0;transition:opacity .3s;}
// .svc-card:hover .svc-glow{opacity:1;}
// .svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
// .svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .3s,opacity .3s;}
// .svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
// .svc-body{padding:22px 14px 18px;position:relative;}
// .svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;transition:transform .3s;}
// .svc-card:hover .svc-float-icon{transform:rotate(-6deg) scale(1.1);}
// .svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .2s;}
// .svc-card:hover .svc-title{color:var(--p);}
// .svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .35s;}
// .svc-card:hover .svc-line{width:42px;}
// .svc-desc{font-size:12px;color:#888;line-height:1.6;}

// .act-card{border-radius:18px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.07);transition:transform .3s;cursor:pointer;position:relative;}
// .act-card::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 16px 40px rgba(94,14,115,.15);opacity:0;transition:opacity .3s;z-index:-1;}
// .act-card:hover{transform:translateY(-6px) scale(1.01);}
// .act-card:hover::before{opacity:1;}

// .gal-bento{display:grid;grid-template-columns:repeat(12,1fr);gap:14px;margin-bottom:8px;}
// .gbi-1{grid-column:span 5;grid-row:span 2;min-height:370px;}.gbi-2{grid-column:span 4;min-height:178px;}.gbi-3{grid-column:span 3;min-height:178px;}.gbi-4{grid-column:span 4;min-height:178px;}.gbi-5{grid-column:span 3;min-height:178px;}.gbi-6{grid-column:span 7;min-height:215px;}
// .gal-bento-item{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;background:var(--dark);opacity:0;transform:translateY(24px) scale(.98);transition:opacity .55s ease,transform .55s cubic-bezier(.25,1,.5,1);}
// .gal-bento-item.in{opacity:1;transform:translateY(0) scale(1);}
// .gal-bento-item::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 20px 56px rgba(94,14,115,.25);opacity:0;transition:opacity .3s;z-index:1;pointer-events:none;}
// .gal-bento-item:hover::before{opacity:1;}
// .gal-bento-item img{width:100%;height:100%;object-fit:cover;display:block;position:absolute;inset:0;transition:transform .5s;}
// .gal-bento-item:hover img{transform:scale(1.05);}
// .gal-bento-ovl{position:absolute;inset:0;background:rgba(94,14,115,.32);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;font-size:28px;color:#fff;z-index:2;}
// .gal-bento-item:hover .gal-bento-ovl{opacity:1;}

// .kp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:border-color .25s;margin-bottom:12px;}
// .kp-faq-item:hover{border-color:rgba(201,168,76,.4);}
// .kp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
// .kp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
// .kp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .25s,background .25s;font-size:15px;color:var(--p);}
// .kp-faq-item.open .kp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

// .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;}
// .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
// .enq-right{background:#fff;padding:40px 36px;}
// .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
// .enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s;color:var(--dark);}
// .enq-input:focus{border-color:var(--p);}
// .enq-input option{background:var(--dark);color:#fff;}
// .enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
// .enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
// .enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
// .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}

// .kp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);}
// .kp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.07) 0%,transparent 70%);pointer-events:none;}
// .kp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
// .kp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
// .kp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

// /* ── Reels ── */
// .kr-sec{padding:100px 0 110px;background:#120020;overflow:hidden;position:relative;font-family:'DM Sans',sans-serif;}
// .kr-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
// .kr-container{width:min(1320px,92%);margin:auto;position:relative;z-index:2;}
// .kr-header{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:52px;flex-wrap:wrap;gap:20px;animation:kr-fadeUp .8s cubic-bezier(.16,1,.3,1) both;}
// .kr-eyebrow{display:inline-flex;align-items:center;gap:8px;color:#E8D5A0;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin-bottom:14px;}
// .kr-eyebrow-line{width:32px;height:1px;background:#C9A84C;opacity:.6;}
// .kr-title{font-family:'Playfair Display',serif;font-size:clamp(32px,5vw,54px);font-weight:900;color:#fff;line-height:1.08;margin:0 0 10px;letter-spacing:-.5px;}
// .kr-title em{font-style:italic;color:#C9A84C;}
// .kr-sub{color:rgba(255,255,255,.5);font-size:15px;line-height:1.6;max-width:400px;}
// .kr-nav{display:flex;gap:12px;align-items:center;}
// .kr-nav-btn{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1.5px solid rgba(255,255,255,.14);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;font-weight:700;flex-shrink:0;}
// .kr-nav-btn:hover{background:#C9A84C;color:#120020;border-color:#C9A84C;transform:scale(1.08);}
// .kr-wrap{overflow:hidden;width:100%;}
// .kr-track{display:flex;gap:20px;transition:transform .65s cubic-bezier(.25,1,.5,1);will-change:transform;}
// .kr-card{position:relative;width:260px;min-width:260px;height:470px;border-radius:26px;overflow:hidden;background:#000;border:1px solid rgba(255,255,255,.07);transition:transform .4s cubic-bezier(.25,1,.5,1);flex-shrink:0;cursor:pointer;}
// .kr-card:hover{transform:translateY(-10px) scale(1.02);border-color:rgba(201,168,76,.5);}
// .kr-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
// .kr-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.95) 0%,rgba(13,0,24,.4) 45%,rgba(13,0,24,.08) 100%);pointer-events:none;}
// .kr-views{position:absolute;top:14px;left:14px;z-index:5;padding:5px 11px;border-radius:999px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.12);color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;gap:5px;}
// .kr-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.85);z-index:5;width:52px;height:52px;border-radius:50%;background:rgba(201,168,76,.9);display:flex;align-items:center;justify-content:center;font-size:18px;opacity:0;transition:opacity .3s,transform .3s;}
// .kr-card:hover .kr-play{opacity:1;transform:translate(-50%,-50%) scale(1);}
// .kr-info{position:absolute;left:0;right:0;bottom:0;z-index:5;padding:20px 18px 22px;}
// .kr-tag-pill{display:inline-block;background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.45);color:#C9A84C;font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:3px 10px;border-radius:50px;margin-bottom:8px;}
// .kr-info h3{margin:0;color:#fff;font-family:'Playfair Display',serif;font-size:17px;font-weight:700;line-height:1.3;}
// .kr-dots{display:flex;gap:8px;justify-content:center;margin-top:36px;}
// .kr-dot{height:8px;border-radius:4px;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .4s;}
// .kr-dot.active{width:28px!important;background:linear-gradient(90deg,#C9A84C,#E8D5A0);}
// .kr-cta{margin-top:52px;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;}
// .kr-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#120020;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
// .kr-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kr-shine 3.5s ease infinite;pointer-events:none;}
// .kr-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#120020;}
// .kr-btn-ig{display:inline-flex;align-items:center;gap:9px;border:1.5px solid rgba(255,255,255,.2);background:rgba(255,255,255,.05);color:#fff;border-radius:50px;padding:12px 28px;font-weight:700;font-size:14px;cursor:pointer;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
// .kr-btn-ig:hover{border-color:rgba(201,168,76,.5);color:#C9A84C;transform:translateY(-2px);}

// /* ── Video Testimonials ── */
// .kvt-sec{background:#120020;font-family:'DM Sans',sans-serif;position:relative;overflow:hidden;}
// .kvt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 65% 50% at 20% 10%,rgba(94,14,115,.28) 0%,transparent 65%),radial-gradient(ellipse 50% 40% at 80% 90%,rgba(201,168,76,.08) 0%,transparent 65%);pointer-events:none;z-index:0;}
// .kvt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:180px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kvt-header{padding:72px clamp(20px,5vw,60px) 52px;display:flex;align-items:flex-end;justify-content:space-between;flex-wrap:wrap;gap:20px;position:relative;z-index:2;}
// .kvt-header::after{content:'';position:absolute;bottom:0;left:clamp(20px,5vw,60px);right:clamp(20px,5vw,60px);height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.25),transparent);}
// .kvt-eyebrow{display:flex;align-items:center;gap:10px;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:14px;}
// .kvt-eyebrow-line{width:26px;height:1px;background:#C9A84C;opacity:.55;}
// .kvt-h{font-family:'Playfair Display',serif;font-size:clamp(28px,4vw,46px);font-weight:700;color:#fff;line-height:1.1;margin:0;}
// .kvt-h em{font-style:italic;color:#C9A84C;}
// .kvt-counter{font-family:'Playfair Display',serif;font-size:14px;color:rgba(255,255,255,.3);flex-shrink:0;align-self:flex-end;}
// .kvt-counter span{color:#fff;font-size:18px;font-weight:700;}
// .kvt-stage{display:grid;grid-template-columns:1fr 340px;min-height:580px;position:relative;z-index:1;}
// .kvt-pane{position:relative;display:flex;align-items:center;justify-content:center;padding:40px 0 40px clamp(20px,5vw,60px);overflow:hidden;}
// .kvt-glow{position:absolute;width:420px;height:420px;border-radius:50%;background:radial-gradient(circle,rgba(94,14,115,.22) 0%,transparent 70%);top:50%;left:45%;transform:translate(-50%,-50%);pointer-events:none;z-index:0;transition:background .5s;}
// .kvt-glow.active{background:radial-gradient(circle,rgba(201,168,76,.1) 0%,rgba(94,14,115,.15) 50%,transparent 70%);}
// .kvt-reel{position:relative;width:min(300px,82%);aspect-ratio:9/16;border-radius:32px;overflow:hidden;background:#000;border:2px solid rgba(255,255,255,.1);box-shadow:0 40px 100px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.08);cursor:pointer;transition:border-color .35s;z-index:1;flex-shrink:0;-webkit-tap-highlight-color:transparent;user-select:none;}
// .kvt-reel:hover,.kvt-reel.playing{border-color:rgba(201,168,76,.5);}
// .kvt-notch{position:absolute;top:14px;left:50%;transform:translateX(-50%);width:80px;height:5px;background:rgba(255,255,255,.1);border-radius:3px;z-index:8;pointer-events:none;}
// .kvt-prog{position:absolute;top:0;left:0;right:0;height:3px;background:rgba(255,255,255,.08);z-index:6;}
// .kvt-prog-fill{height:100%;background:linear-gradient(90deg,#5E0E73,#C9A84C);border-radius:0 2px 2px 0;transition:width .1s linear;}
// .kvt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
// .kvt-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.96) 0%,rgba(13,0,24,.22) 45%,transparent 100%),linear-gradient(to bottom,rgba(13,0,24,.5) 0%,transparent 25%);pointer-events:none;z-index:2;}
// .kvt-pulse-ring{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:68px;height:68px;border-radius:50%;border:1.5px solid rgba(201,168,76,.5);z-index:4;pointer-events:none;animation:kvt-pulse 2.4s ease-in-out infinite;}
// .kvt-reel.playing .kvt-pulse-ring{display:none;}
// .kvt-play-area{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5;pointer-events:none;}
// .kvt-play-btn{width:68px;height:68px;border-radius:50%;background:rgba(255,255,255,.12);border:2px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;transition:all .3s cubic-bezier(.25,1,.5,1);opacity:0;transform:scale(.8);pointer-events:all;cursor:pointer;}
// .kvt-play-btn.show{opacity:1;transform:scale(1);animation:kvt-ctrlIn .22s ease-out;}
// .kvt-play-btn:hover{background:#C9A84C;border-color:#C9A84C;transform:scale(1.08);}
// .kvt-play-btn:hover svg{fill:#1A0030;}
// .kvt-play-btn svg{fill:#fff;transition:fill .2s;}
// @media(hover:none) and (pointer:coarse){
//   .kvt-play-btn{opacity:1!important;transform:scale(1)!important;background:rgba(201,168,76,.85);}
//   .kvt-play-btn svg{fill:#1A0030;}
//   .kvt-hint{display:none!important;}
// }
// .kvt-top-ctrl{position:absolute;top:24px;right:14px;z-index:7;display:flex;flex-direction:column;align-items:center;gap:8px;opacity:0;pointer-events:none;transition:opacity .22s;}
// .kvt-top-ctrl.show{opacity:1;pointer-events:all;}
// .kvt-ctrl-btn{width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,.55);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:13px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
// .kvt-ctrl-btn:hover{background:rgba(201,168,76,.35);border-color:#C9A84C;}
// .kvt-hint{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:.5px;text-transform:uppercase;background:rgba(0,0,0,.45);padding:3px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.08);white-space:nowrap;}
// .kvt-info{position:absolute;bottom:0;left:0;right:0;padding:18px 16px 22px;z-index:4;}
// .kvt-stars{display:flex;gap:3px;margin-bottom:9px;}
// .kvt-quote{font-family:'Playfair Display',serif;font-size:13px;font-style:italic;font-weight:600;color:#fff;line-height:1.55;margin:0 0 14px;animation:kvt-quoteIn .4s cubic-bezier(.25,1,.5,1) both;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
// .kvt-quote::before{content:'"';font-size:1.5em;line-height:0;vertical-align:-.35em;color:#C9A84C;margin-right:3px;opacity:.8;}
// .kvt-identity{display:flex;align-items:center;gap:10px;animation:kvt-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;}
// .kvt-avatar{width:38px;height:38px;border-radius:50%;border:2px solid rgba(201,168,76,.55);background:linear-gradient(135deg,#5E0E73,#6E1A85);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:#E8D5A0;flex-shrink:0;}
// .kvt-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:3px;}
// .kvt-meta{display:flex;align-items:center;gap:5px;flex-wrap:wrap;}
// .kvt-pill{background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:8px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:2px 8px;border-radius:50px;}
// .kvt-loc{font-size:10px;color:rgba(255,255,255,.4);}
// .kvt-transition{position:absolute;inset:0;background:#120020;z-index:10;opacity:0;pointer-events:none;transition:opacity .28s;}
// .kvt-transition.show{opacity:1;pointer-events:all;}
// .kvt-queue{background:rgba(255,255,255,.025);border-left:1px solid rgba(255,255,255,.06);display:flex;flex-direction:column;overflow:hidden;}
// .kvt-queue-header{padding:24px 24px 18px;border-bottom:1px solid rgba(255,255,255,.06);flex-shrink:0;}
// .kvt-queue-title{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.3);}
// .kvt-queue-list{flex:1;overflow-y:auto;padding:12px 0;scrollbar-width:thin;scrollbar-color:rgba(201,168,76,.2) transparent;}
// .kvt-queue-list::-webkit-scrollbar{width:4px;}.kvt-queue-list::-webkit-scrollbar-thumb{background:rgba(201,168,76,.2);border-radius:2px;}
// .kvt-q-item{display:flex;align-items:center;gap:14px;padding:12px 20px;cursor:pointer;transition:background .2s;border-left:3px solid transparent;}
// .kvt-q-item:hover{background:rgba(255,255,255,.04);}
// .kvt-q-item.active{background:rgba(201,168,76,.07);border-left-color:#C9A84C;}
// .kvt-q-thumb{width:50px;height:74px;border-radius:10px;overflow:hidden;flex-shrink:0;position:relative;border:1px solid rgba(255,255,255,.07);display:flex;align-items:center;justify-content:center;transition:border-color .2s;}
// .kvt-q-item.active .kvt-q-thumb{border-color:rgba(201,168,76,.4);}
// .kvt-q-bg{position:absolute;inset:0;background:linear-gradient(155deg,#3A0847 0%,#5E0E73 60%,rgba(201,168,76,.25) 100%);}
// .kvt-q-init{position:relative;z-index:1;font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:rgba(255,255,255,.75);}
// .kvt-q-item.active .kvt-q-init{color:#E8D5A0;}
// .kvt-q-eq-wrap{position:absolute;inset:0;background:rgba(13,0,24,.65);display:flex;align-items:center;justify-content:center;border-radius:9px;z-index:2;}
// .kvt-q-eq{display:flex;align-items:flex-end;gap:2.5px;height:18px;}
// .kvt-q-bar{width:3px;background:#C9A84C;border-radius:2px;animation:kvt-eqBar 1s ease-in-out infinite;}
// .kvt-q-bar:nth-child(2){animation-delay:.18s;}.kvt-q-bar:nth-child(3){animation-delay:.36s;}
// .kvt-q-info{flex:1;min-width:0;}
// .kvt-q-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:3px;}
// .kvt-q-item.active .kvt-q-name{color:#E8D5A0;}
// .kvt-q-event{font-size:11px;color:rgba(255,255,255,.35);}
// .kvt-q-num{font-size:11px;color:rgba(255,255,255,.2);flex-shrink:0;font-family:'Playfair Display',serif;}
// .kvt-q-item.active .kvt-q-num{color:#C9A84C;font-weight:700;}
// .kvt-queue-nav{padding:16px 20px;border-top:1px solid rgba(255,255,255,.06);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
// .kvt-nav-label{font-size:11px;color:rgba(255,255,255,.25);letter-spacing:1px;text-transform:uppercase;}
// .kvt-nav-arrows{display:flex;gap:8px;}
// .kvt-nav-btn{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.55);font-size:17px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
// .kvt-nav-btn:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
// .kvt-strip{padding:28px clamp(20px,5vw,60px) 56px;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;border-top:1px solid rgba(255,255,255,.05);position:relative;z-index:2;}
// .kvt-ratings{display:flex;align-items:center;gap:28px;flex-wrap:wrap;}
// .kvt-r-item{text-align:center;}
// .kvt-r-num{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#C9A84C;line-height:1;}
// .kvt-r-label{font-size:10px;color:rgba(255,255,255,.28);text-transform:uppercase;letter-spacing:1px;margin-top:4px;}
// .kvt-r-sep{width:1px;height:36px;background:rgba(255,255,255,.06);}
// .kvt-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#1A0030;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;flex-shrink:0;transition:transform .25s,opacity .25s;}
// .kvt-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kvt-shine 3.5s ease infinite;pointer-events:none;}
// .kvt-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#1A0030;}

// /* ── Written Reviews ── */
// .kt-sec{padding:100px 0 88px;background:#1A0030;position:relative;overflow:hidden;font-family:'DM Sans',sans-serif;}
// .kt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 55% at 15% 5%,rgba(94,14,115,.32) 0%,transparent 65%),radial-gradient(ellipse 55% 45% at 85% 95%,rgba(201,168,76,.09) 0%,transparent 65%);pointer-events:none;}
// .kt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:200px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:10px;}
// .kt-h{font-family:'Playfair Display',serif;font-size:clamp(30px,4.5vw,52px);font-weight:700;line-height:1.15;color:#fff;margin:0;}
// .kt-h span{color:#C9A84C;}
// .kt-sub{color:rgba(255,255,255,.5);font-size:14px;line-height:1.75;margin:12px auto 0;max-width:500px;}
// .kt-stats{display:flex;align-items:center;justify-content:center;gap:40px;margin-top:40px;flex-wrap:wrap;}
// .kt-stat{text-align:center;}
// .kt-sn{font-family:'Playfair Display',serif;font-size:34px;font-weight:700;color:#C9A84C;line-height:1;}
// .kt-sl{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:1.5px;text-transform:uppercase;margin-top:5px;}
// .kt-ssep{width:1px;height:44px;background:rgba(255,255,255,.08);}
// .kt-feat{border-radius:28px;overflow:hidden;width:100%;height:100%;background:rgba(255,255,255,.04);border:1px solid rgba(201,168,76,.22);position:relative;}
// .kt-feat::before{content:'';display:block;width:100%;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-feat-in{padding:30px 28px 26px;}
// .kt-big-q{font-family:'Playfair Display',serif;font-size:130px;font-weight:900;line-height:.8;color:rgba(201,168,76,.055);position:absolute;top:20px;right:16px;user-select:none;pointer-events:none;}
// .kt-fi-wrap{position:relative;width:100%;height:240px;overflow:hidden;border-radius:18px;margin-bottom:22px;}
// .kt-fi{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
// .kt-feat:hover .kt-fi{transform:scale(1.04);}
// .kt-fi-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
// .kt-fi-badge{position:absolute;bottom:14px;left:14px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;}
// .kt-review{font-size:15px;color:rgba(255,255,255,.82);line-height:1.8;font-style:italic;margin:0 0 22px;}
// .kt-div{height:1px;margin-bottom:18px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent);}
// .kt-author{display:flex;align-items:center;gap:14px;}
// .kt-avatar{width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2.5px solid rgba(201,168,76,.45);}
// .kt-aname{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:#fff;}
// .kt-aloc{font-size:11px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:.5px;margin-top:2px;}
// .kt-v{margin-left:auto;flex-shrink:0;width:30px;height:30px;border-radius:50%;background:linear-gradient(135deg,#5E0E73,#C9A84C);display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;font-weight:700;}
// .kt-prev{background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.08);border-radius:20px;overflow:hidden;cursor:pointer;transition:transform .3s;display:flex;flex-direction:column;flex:1;}
// .kt-prev:hover{transform:translateY(-5px);background:rgba(255,255,255,.06);border-color:rgba(201,168,76,.28);}
// .kt-pi{width:100%;height:155px;object-fit:cover;display:block;transition:transform .4s;filter:brightness(.8);}
// .kt-prev:hover .kt-pi{transform:scale(1.04);filter:brightness(1);}
// .kt-pb{padding:15px 17px;flex:1;display:flex;flex-direction:column;}
// .kt-pt{font-size:12px;color:rgba(255,255,255,.55);line-height:1.65;font-style:italic;margin:8px 0 10px;flex:1;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
// .kt-pn{font-size:13px;font-weight:700;color:rgba(255,255,255,.85);font-family:'Playfair Display',serif;}
// .kt-pl{font-size:10px;color:rgba(255,255,255,.3);margin-top:2px;}
// .kt-pr{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;color:#C9A84C;letter-spacing:1px;text-transform:uppercase;padding:4px 12px;border:1px solid rgba(201,168,76,.25);border-radius:50px;background:transparent;width:fit-content;transition:background .2s;}
// .kt-prev:hover .kt-pr{background:rgba(201,168,76,.12);border-color:rgba(201,168,76,.5);}
// .kt-nav{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:36px;}
// .kt-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.15);border:none;cursor:pointer;transition:width .35s,background .35s;}
// .kt-dot.on{width:34px;border-radius:4px;background:linear-gradient(90deg,#5E0E73,#C9A84C);}
// .kt-arr{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:rgba(255,255,255,.6);font-size:20px;cursor:pointer;transition:transform .2s,background .2s;display:flex;align-items:center;justify-content:center;}
// .kt-arr:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
// .kt-plat{display:flex;justify-content:center;align-items:center;gap:32px;flex-wrap:wrap;margin-top:60px;padding:26px 44px;background:rgba(255,255,255,.025);border:1px solid rgba(255,255,255,.055);border-radius:22px;}
// .kt-plat-item{text-align:center;}
// .kt-plat-name{font-size:10px;color:rgba(255,255,255,.3);letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;}
// .kt-plat-row{display:flex;align-items:center;gap:7px;}
// .kt-plat-sc{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#fff;}
// .kt-plat-cnt{font-size:10px;color:rgba(255,255,255,.25);margin-top:3px;}
// .kt-psep{width:1px;height:40px;background:rgba(255,255,255,.07);}
// .kt-cta{text-align:center;margin-top:60px;padding:52px 40px;background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5));border:1px solid rgba(201,168,76,.1);border-radius:28px;position:relative;overflow:hidden;}
// .kt-cta::before{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:120px;height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-cta-h{font-family:'Playfair Display',serif;font-size:clamp(22px,3vw,32px);font-weight:700;color:#fff;margin:0 0 8px;}
// .kt-cta-h span{color:#C9A84C;}
// .kt-cta-sub{font-size:14px;color:rgba(255,255,255,.4);margin-bottom:28px;}
// .kt-cta-row{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
// .kt-btn-bk{background:linear-gradient(135deg,#5E0E73,#6E1A85);color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-block;transition:transform .25s,opacity .25s;}
// .kt-btn-bk:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
// .kt-btn-wa{background:#25D366;color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;transition:transform .25s,opacity .25s;}
// .kt-btn-wa:hover{transform:translateY(-2px);opacity:.9;color:#fff;}

// /* ── Responsive ── */
// @media(max-width:1024px){
//   .kvt-stage{grid-template-columns:1fr 280px;}
//   .kvt-header,.kvt-strip{padding-left:32px;padding-right:32px;}
//   .kvt-pane{padding-left:40px;}
//   .svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}
// }
// /* ══ MOBILE HERO — video-first, full-screen ══════════════════════ */
// @media(max-width:768px){

//   /* Hero: stack video on top, text below — video is the star */
//   .kp-hero{min-height:100svh;align-items:flex-start;overflow-x:clip;}
//   .kp-hero-cnt{padding:0!important;width:100%;overflow:hidden;}

//   /* Neutralize Bootstrap row negative margins that cause left-clip */
//   .kp-hero .row{flex-direction:column-reverse!important;gap:0!important;margin-left:0!important;margin-right:0!important;}

//   /* VIDEO COL — full width, tall */
//   .kp-hero .col-lg-6:last-child{
//     padding:0!important;
//     width:100%!important;
//     max-width:100%!important;
//     flex:none!important;
//   }
//   .kp-hero-vid-wrap{
//     width:100%!important;
//     max-height:none!important;
//     height:72svh!important;
//     border-radius:0!important;
//     border:none!important;
//     border-bottom:2px solid rgba(201,168,76,.3)!important;
//     aspect-ratio:unset!important;
//   }

//   /* TEXT COL — compact strip below video */
//   .kp-hero .col-lg-6:first-child{
//     width:100%!important;
//     max-width:100%!important;
//     flex:none!important;
//     padding:20px 20px 24px!important;
//     box-sizing:border-box!important;
//   }
//   .kp-hero-badge{font-size:10px;padding:6px 14px;margin-bottom:10px;}
//   .kp-hero-title{font-size:clamp(24px,6.5vw,34px)!important;margin-bottom:10px;line-height:1.1;}
//   .kp-hero-sub{display:none!important;}           /* hide subtitle — video shows it */
//   .kp-trust-row{display:none!important;}           /* hide stats — cleaner on mobile */
//   .kp-hero-float{display:none!important;}

//   /* Buttons — side by side, compact */
//   .kp-hero .col-lg-6:first-child>div[style]{flex-wrap:nowrap!important;gap:10px!important;}
//   .kp-hero-cnt .cc-btn-gold{flex:1;justify-content:center;padding:12px 14px!important;font-size:13px!important;}
//   .kp-hero-cnt .cc-btn-outline{flex:1;justify-content:center;padding:11px 14px!important;font-size:13px!important;}

//   /* Section spacing */
//   .kp-sec{padding:52px 0;}
//   .kp-sec-sm{padding:28px 0;}

//   /* Themes */
//   .theme-card{width:200px;}.theme-img{height:240px;}

//   /* Gallery */
//   .gal-bento{grid-template-columns:repeat(6,1fr);gap:10px;}
//   .gbi-1{grid-column:span 3;grid-row:span 2;min-height:250px;}
//   .gbi-2,.gbi-3{grid-column:span 3;min-height:120px;}
//   .gbi-4,.gbi-5,.gbi-6{grid-column:span 2;min-height:135px;}

//   /* Enquiry form */
//   .enq-wrap .row{flex-direction:column;}
//   .enq-left{order:2;padding:26px 22px;}
//   .enq-right{order:1;padding:26px 22px;}

//   /* Reels section */
//   .kr-sec{padding:70px 0 80px;}
//   .kr-header{margin-bottom:36px;}
//   .kr-title{font-size:clamp(28px,7vw,38px);}

//   /* Video testimonials */
//   .kvt-stage{grid-template-columns:1fr;grid-template-rows:auto auto;}
//   .kvt-pane{padding:32px 20px;min-height:480px;}
//   .kvt-reel{width:min(250px,74%);}
//   .kvt-queue{border-left:none;border-top:1px solid rgba(255,255,255,.06);max-height:none;}
//   .kvt-queue-header{padding:14px 20px 10px;}
//   .kvt-queue-list{display:flex;flex-direction:row;overflow-x:auto;overflow-y:hidden;padding:10px 16px 14px;gap:10px;-webkit-overflow-scrolling:touch;}
//   .kvt-queue-list::-webkit-scrollbar{display:none;}
//   .kvt-queue-nav{padding:12px 20px;}
//   .kvt-q-item{flex-direction:column;align-items:center;text-align:center;min-width:84px;border-left:none;border-bottom:3px solid transparent;padding:8px;border-radius:12px;}
//   .kvt-q-item.active{border-bottom-color:#C9A84C;border-left-color:transparent;}
//   .kvt-q-thumb{width:50px;height:76px;}
//   .kvt-q-num{display:none;}
//   .kvt-header{padding:40px 20px 32px;}
//   .kvt-header::after{left:20px;right:20px;}
//   .kvt-strip{padding:20px 20px 36px;flex-direction:column;align-items:flex-start;}
//   .kvt-r-sep{display:none;}

//   /* Written reviews */
//   .kt-sec{padding:64px 0 56px;}
//   .kt-fi-wrap{height:200px;}
//   .kt-ssep{display:none;}
//   .kt-plat{gap:20px;padding:20px 24px;}
//   .kt-psep{display:none;}
// }

// /* ══ 640px — phones ══════════════════════════════════════════════ */
// @media(max-width:640px){
//   .kp-hero-vid-wrap{height:75svh!important;}
//   .kp-hero .col-lg-6:first-child{padding:16px 16px 20px!important;}
//   .kp-hero-title{font-size:clamp(22px,6.5vw,28px)!important;}

//   .kp-sec{padding:44px 0;}
//   .container{padding-left:16px;padding-right:16px;}
//   .cc-h{font-size:clamp(22px,6.5vw,30px);}
//   .cc-btn,.cc-btn-gold,.cc-btn-outline,.wa-btn{min-height:46px;font-size:13px;}
//   .theme-card{width:170px;}.theme-img{height:210px;}
//   .svc-grid{grid-template-columns:1fr 1fr;gap:10px;}
//   .svc-img-wrap{height:130px;}
//   .kr-card{height:420px;}.kr-info h3{font-size:15px;}.kr-nav-btn{width:40px;height:40px;font-size:17px;}
//   .gal-bento{grid-template-columns:1fr 1fr;gap:8px;}
//   .gbi-1{grid-column:span 2;min-height:175px;grid-row:span 1;}
//   .gbi-2,.gbi-3,.gbi-4,.gbi-5{grid-column:span 1;min-height:125px;}
//   .gbi-6{grid-column:span 2;min-height:145px;}
//   .enq-left,.enq-right{padding:18px 14px;}
//   .enq-input{padding:11px 13px;font-size:13px;}
//   .kp-faq-q{font-size:13px;padding:12px 16px;}
//   .kp-faq-a{font-size:12px;padding:0 16px 12px;}
//   .kvt-h{font-size:clamp(24px,7vw,32px);}
//   .kt-feat-in{padding:20px 18px;}
//   .kt-fi-wrap{height:170px;}
//   .kt-review{font-size:13px;}
//   .kt-cta{padding:32px 18px;}
//   .kt-plat{padding:18px 16px;gap:16px;}

//   /* Reel cards on small phones */
//   .kvt-reel{width:min(220px,80%);}
// }

// /* ══ 400px — small/older phones ═════════════════════════════════ */
// @media(max-width:400px){
//   .kp-hero-vid-wrap{height:78svh!important;}
//   .kp-hero-title{font-size:clamp(20px,6.5vw,24px)!important;}
//   .cc-h{font-size:clamp(20px,7vw,26px);}
//   .svc-grid{grid-template-columns:1fr;}
//   .theme-card{width:150px;}
// }
// @media(hover:none) and (pointer:coarse){
//   .theme-card:hover,.svc-card:hover,.act-card:hover,.kr-card:hover,.kt-prev:hover,.gal-bento-item:hover{transform:none!important;}
//   .svc-card:hover::before,.act-card:hover::before,.gal-bento-item:hover::before{opacity:0!important;}
//   .svc-card:hover .svc-img,.theme-card:hover .theme-img,.gal-bento-item:hover img{transform:none!important;}
//   .svc-card:hover .svc-glow,.gal-bento-item:hover .gal-bento-ovl{opacity:0!important;}
//   .kp-hero-float{animation:none!important;display:none!important;}
//   .kp-ticker-track{animation-duration:40s!important;}
// }
// `;
const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
:root{--p:#5E0E73;--pl:#6E1A85;--pd:#3A0847;--pp:#F3E5F7;--cream:#E8E1D6;--beige:#D6CFC4;--gold:#C9A84C;--gl:#E8D5A0;--gb:#F5D87A;--dark:#1A0030;--dark2:#120020;}
*,*::before,*::after{box-sizing:border-box;}
.kp-root,.kp-root *{font-family:'DM Sans',sans-serif;}
.pf{font-family:'Playfair Display',serif!important;}

@keyframes _fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
@keyframes _ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes _spin{to{transform:rotate(360deg)}}
@keyframes _float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
@keyframes _pulse{0%,100%{opacity:.7}50%{opacity:1}}
@keyframes _shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
@keyframes kr-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
@keyframes kr-fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-pulse{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.2);opacity:.85}}
@keyframes kvt-quoteIn{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:translateX(0)}}
@keyframes kvt-nameIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-ctrlIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-eqBar{0%,100%{height:5px}50%{height:18px}}
@keyframes kvt-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}

.rv{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s cubic-bezier(.16,1,.3,1);}
.rv.in{opacity:1;transform:translateY(0);}
.rv.d1{transition-delay:.08s}.rv.d2{transition-delay:.16s}.rv.d3{transition-delay:.24s}.rv.d4{transition-delay:.32s}

.kp-sec{padding:72px 0;}.kp-sec-sm{padding:44px 0;}

.cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
.cc-tag-light{color:var(--gl)!important;}
.cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
.cc-h-white{color:#fff!important;}
.cc-h span{color:var(--p);}
.cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
.cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
.cc-sub-light{color:rgba(255,255,255,.55)!important;}

.cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;position:relative;}
.cc-btn:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
.cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,background .25s,color .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
.cc-btn-outline:hover{background:var(--p);color:#fff;transform:translateY(-2px);}
.cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B 0%,var(--gold) 50%,#9A6E10 100%);color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .25s,opacity .25s;box-shadow:0 4px 18px rgba(201,168,76,.35);}
.cc-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:_shine 3.5s ease infinite;pointer-events:none;}
.cc-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:var(--dark);}
.wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
.wa-btn:hover{transform:translateY(-2px);opacity:.88;color:#fff;}
.cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;}
.cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.08);}

.kp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
.kp-ticker-track{display:flex;width:max-content;animation:_ticker 26s linear infinite;will-change:transform;}
.kp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

.kp-hero{position:relative;min-height:88vh;background:linear-gradient(135deg,rgba(26,0,48,.75) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.82) 100%),url('https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.25_PM_4_diawmo.jpg') center/cover no-repeat;display:flex;align-items:center;overflow-x:clip;}
.kp-hero-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none;}
.kp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
.kp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.38);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
.kp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 2px 12px rgba(0,0,0,.3);}
.kp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
.kp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
.kp-hero-vid-wrap{position:relative;border-radius:28px;border:2px solid rgba(201,168,76,.3);overflow:hidden;aspect-ratio:9/16;max-height:500px;background:#000;}
.kp-hero-vid-wrap video{width:100%;height:100%;object-fit:cover;display:block;}
.kp-hero-vid-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.55) 0%,transparent 55%);pointer-events:none;}
.kp-hero-vid-badge{position:absolute;bottom:14px;left:14px;right:14px;display:flex;align-items:center;gap:10px;background:rgba(0,0,0,.55);border-radius:10px;padding:9px 12px;border:1px solid rgba(201,168,76,.2);}
.kp-hero-vid-pulse{width:8px;height:8px;border-radius:50%;background:#EF4444;flex-shrink:0;animation:_pulse 1.8s ease-in-out infinite;}
.kp-hero-vid-label{font-size:11px;color:rgba(255,255,255,.8);font-weight:600;letter-spacing:.5px;}
.kp-hero-float{position:absolute;background:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 8px 24px rgba(0,0,0,.18);animation:_float 5s ease-in-out infinite;white-space:nowrap;will-change:transform;}
.kp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
.kp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
.kp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}

.theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
.theme-card:hover{transform:translateY(-6px);}
.theme-img{width:100%;height:320px;object-fit:cover;transition:transform .45s;display:block;}
.theme-card:hover .theme-img{transform:scale(1.05);}
.theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.9) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
.theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
.theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
.theme-tag{background:rgba(255,255,255,.12);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
.kp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

.svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
.svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);transition:transform .35s;cursor:pointer;position:relative;}
.svc-card:hover{transform:translateY(-10px);}
.svc-card::before{content:'';position:absolute;inset:0;border-radius:22px;box-shadow:0 24px 56px rgba(94,14,115,.18);opacity:0;transition:opacity .35s;z-index:-1;}
.svc-card:hover::before{opacity:1;}
.svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .35s,left .35s;}
.svc-card:hover::after{width:100%;left:0;}
.svc-img-wrap{position:relative;height:200px;overflow:hidden;}
.svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .45s;}
.svc-card:hover .svc-img{transform:scale(1.07);}
.svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.45) 0%,transparent 60%);opacity:0;transition:opacity .3s;}
.svc-card:hover .svc-glow{opacity:1;}
.svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
.svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .3s,opacity .3s;}
.svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
.svc-body{padding:22px 14px 18px;position:relative;}
.svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;transition:transform .3s;}
.svc-card:hover .svc-float-icon{transform:rotate(-6deg) scale(1.1);}
.svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .2s;}
.svc-card:hover .svc-title{color:var(--p);}
.svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .35s;}
.svc-card:hover .svc-line{width:42px;}
.svc-desc{font-size:12px;color:#888;line-height:1.6;}

.act-card{border-radius:18px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.07);transition:transform .3s;cursor:pointer;position:relative;}
.act-card::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 16px 40px rgba(94,14,115,.15);opacity:0;transition:opacity .3s;z-index:-1;}
.act-card:hover{transform:translateY(-6px) scale(1.01);}
.act-card:hover::before{opacity:1;}

/* ── Gallery Grid - Square Shape Responsive ── */
.gal-bento {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 8px;
}

.gal-bento-item {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  background: var(--dark);
  opacity: 0;
  transform: translateY(24px) scale(.98);
  transition: opacity .55s ease, transform .55s cubic-bezier(.25,1,.5,1);
  aspect-ratio: 1 / 1;
}

.gal-bento-item.in {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.gal-bento-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 18px;
  box-shadow: 0 20px 56px rgba(94, 14, 115, .25);
  opacity: 0;
  transition: opacity .3s;
  z-index: 1;
  pointer-events: none;
}

.gal-bento-item:hover::before {
  opacity: 1;
}

.gal-bento-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .5s;
}

.gal-bento-item:hover img {
  transform: scale(1.05);
}

.gal-bento-ovl {
  position: absolute;
  inset: 0;
  background: rgba(94, 14, 115, .32);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .3s;
  font-size: 28px;
  color: #fff;
  z-index: 2;
  backdrop-filter: blur(4px);
}

.gal-bento-item:hover .gal-bento-ovl {
  opacity: 1;
}

/* Remove old bento classes */
.gbi-1, .gbi-2, .gbi-3, .gbi-4, .gbi-5, .gbi-6 {
  grid-column: auto !important;
  grid-row: auto !important;
  min-height: auto !important;
}

/* Mobile responsive gallery */
@media(max-width: 992px) {
  .gal-bento {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

@media(max-width: 768px) {
  .gal-bento {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }
}

@media(max-width: 640px) {
  .gal-bento {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media(max-width: 480px) {
  .gal-bento {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}

/* Touch-friendly gallery items */
@media(hover:none) and (pointer:coarse) {
  .gal-bento-item:hover {
    transform: none !important;
  }
  
  .gal-bento-item:hover::before {
    opacity: 0 !important;
  }
  
  .gal-bento-item:hover img {
    transform: none !important;
  }
  
  .gal-bento-item:hover .gal-bento-ovl {
    opacity: 0 !important;
  }
  
  .gal-bento-item:active {
    transform: scale(0.98) !important;
    transition: transform 0.1s ease;
  }
}

.kp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:border-color .25s;margin-bottom:12px;}
.kp-faq-item:hover{border-color:rgba(201,168,76,.4);}
.kp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
.kp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
.kp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .25s,background .25s;font-size:15px;color:var(--p);}
.kp-faq-item.open .kp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

.enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;}
.enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
.enq-right{background:#fff;padding:40px 36px;}
.enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
.enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s;color:var(--dark);}
.enq-input:focus{border-color:var(--p);}
.enq-input option{background:var(--dark);color:#fff;}
.enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
.enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
.enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
.enq-ci-val{font-size:13px;color:#fff;font-weight:500;}

.kp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);}
.kp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.07) 0%,transparent 70%);pointer-events:none;}
.kp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
.kp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
.kp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

/* ── Reels ── */
.kr-sec{padding:100px 0 110px;background:#120020;overflow:hidden;position:relative;font-family:'DM Sans',sans-serif;}
.kr-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
.kr-container{width:min(1320px,92%);margin:auto;position:relative;z-index:2;}
.kr-header{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:52px;flex-wrap:wrap;gap:20px;animation:kr-fadeUp .8s cubic-bezier(.16,1,.3,1) both;}
.kr-eyebrow{display:inline-flex;align-items:center;gap:8px;color:#E8D5A0;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin-bottom:14px;}
.kr-eyebrow-line{width:32px;height:1px;background:#C9A84C;opacity:.6;}
.kr-title{font-family:'Playfair Display',serif;font-size:clamp(32px,5vw,54px);font-weight:900;color:#fff;line-height:1.08;margin:0 0 10px;letter-spacing:-.5px;}
.kr-title em{font-style:italic;color:#C9A84C;}
.kr-sub{color:rgba(255,255,255,.5);font-size:15px;line-height:1.6;max-width:400px;}
.kr-nav{display:flex;gap:12px;align-items:center;}
.kr-nav-btn{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1.5px solid rgba(255,255,255,.14);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;font-weight:700;flex-shrink:0;}
.kr-nav-btn:hover{background:#C9A84C;color:#120020;border-color:#C9A84C;transform:scale(1.08);}
.kr-wrap{overflow:hidden;width:100%;}
.kr-track{display:flex;gap:20px;transition:transform .65s cubic-bezier(.25,1,.5,1);will-change:transform;}
.kr-card{position:relative;width:260px;min-width:260px;height:470px;border-radius:26px;overflow:hidden;background:#000;border:1px solid rgba(255,255,255,.07);transition:transform .4s cubic-bezier(.25,1,.5,1);flex-shrink:0;cursor:pointer;}
.kr-card:hover{transform:translateY(-10px) scale(1.02);border-color:rgba(201,168,76,.5);}
.kr-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
.kr-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.95) 0%,rgba(13,0,24,.4) 45%,rgba(13,0,24,.08) 100%);pointer-events:none;}
.kr-views{position:absolute;top:14px;left:14px;z-index:5;padding:5px 11px;border-radius:999px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.12);color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;gap:5px;}
.kr-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.85);z-index:5;width:52px;height:52px;border-radius:50%;background:rgba(201,168,76,.9);display:flex;align-items:center;justify-content:center;font-size:18px;opacity:0;transition:opacity .3s,transform .3s;}
.kr-card:hover .kr-play{opacity:1;transform:translate(-50%,-50%) scale(1);}
.kr-info{position:absolute;left:0;right:0;bottom:0;z-index:5;padding:20px 18px 22px;}
.kr-tag-pill{display:inline-block;background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.45);color:#C9A84C;font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:3px 10px;border-radius:50px;margin-bottom:8px;}
.kr-info h3{margin:0;color:#fff;font-family:'Playfair Display',serif;font-size:17px;font-weight:700;line-height:1.3;}
.kr-dots{display:flex;gap:8px;justify-content:center;margin-top:36px;}
.kr-dot{height:8px;border-radius:4px;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .4s;}
.kr-dot.active{width:28px!important;background:linear-gradient(90deg,#C9A84C,#E8D5A0);}
.kr-cta{margin-top:52px;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;}
.kr-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#120020;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
.kr-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kr-shine 3.5s ease infinite;pointer-events:none;}
.kr-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#120020;}
.kr-btn-ig{display:inline-flex;align-items:center;gap:9px;border:1.5px solid rgba(255,255,255,.2);background:rgba(255,255,255,.05);color:#fff;border-radius:50px;padding:12px 28px;font-weight:700;font-size:14px;cursor:pointer;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
.kr-btn-ig:hover{border-color:rgba(201,168,76,.5);color:#C9A84C;transform:translateY(-2px);}

/* ── Video Testimonials ── */
.kvt-sec{background:#120020;font-family:'DM Sans',sans-serif;position:relative;overflow:hidden;}
.kvt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 65% 50% at 20% 10%,rgba(94,14,115,.28) 0%,transparent 65%),radial-gradient(ellipse 50% 40% at 80% 90%,rgba(201,168,76,.08) 0%,transparent 65%);pointer-events:none;z-index:0;}
.kvt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:180px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kvt-header{padding:72px clamp(20px,5vw,60px) 52px;display:flex;align-items:flex-end;justify-content:space-between;flex-wrap:wrap;gap:20px;position:relative;z-index:2;}
.kvt-header::after{content:'';position:absolute;bottom:0;left:clamp(20px,5vw,60px);right:clamp(20px,5vw,60px);height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.25),transparent);}
.kvt-eyebrow{display:flex;align-items:center;gap:10px;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:14px;}
.kvt-eyebrow-line{width:26px;height:1px;background:#C9A84C;opacity:.55;}
.kvt-h{font-family:'Playfair Display',serif;font-size:clamp(28px,4vw,46px);font-weight:700;color:#fff;line-height:1.1;margin:0;}
.kvt-h em{font-style:italic;color:#C9A84C;}
.kvt-counter{font-family:'Playfair Display',serif;font-size:14px;color:rgba(255,255,255,.3);flex-shrink:0;align-self:flex-end;}
.kvt-counter span{color:#fff;font-size:18px;font-weight:700;}
.kvt-stage{display:grid;grid-template-columns:1fr 340px;min-height:580px;position:relative;z-index:1;}
.kvt-pane{position:relative;display:flex;align-items:center;justify-content:center;padding:40px 0 40px clamp(20px,5vw,60px);overflow:hidden;}
.kvt-glow{position:absolute;width:420px;height:420px;border-radius:50%;background:radial-gradient(circle,rgba(94,14,115,.22) 0%,transparent 70%);top:50%;left:45%;transform:translate(-50%,-50%);pointer-events:none;z-index:0;transition:background .5s;}
.kvt-glow.active{background:radial-gradient(circle,rgba(201,168,76,.1) 0%,rgba(94,14,115,.15) 50%,transparent 70%);}
.kvt-reel{position:relative;width:min(300px,82%);aspect-ratio:9/16;border-radius:32px;overflow:hidden;background:#000;border:2px solid rgba(255,255,255,.1);box-shadow:0 40px 100px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.08);cursor:pointer;transition:border-color .35s;z-index:1;flex-shrink:0;-webkit-tap-highlight-color:transparent;user-select:none;}
.kvt-reel:hover,.kvt-reel.playing{border-color:rgba(201,168,76,.5);}
.kvt-notch{position:absolute;top:14px;left:50%;transform:translateX(-50%);width:80px;height:5px;background:rgba(255,255,255,.1);border-radius:3px;z-index:8;pointer-events:none;}
.kvt-prog{position:absolute;top:0;left:0;right:0;height:3px;background:rgba(255,255,255,.08);z-index:6;}
.kvt-prog-fill{height:100%;background:linear-gradient(90deg,#5E0E73,#C9A84C);border-radius:0 2px 2px 0;transition:width .1s linear;}
.kvt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
.kvt-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.96) 0%,rgba(13,0,24,.22) 45%,transparent 100%),linear-gradient(to bottom,rgba(13,0,24,.5) 0%,transparent 25%);pointer-events:none;z-index:2;}
.kvt-pulse-ring{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:68px;height:68px;border-radius:50%;border:1.5px solid rgba(201,168,76,.5);z-index:4;pointer-events:none;animation:kvt-pulse 2.4s ease-in-out infinite;}
.kvt-reel.playing .kvt-pulse-ring{display:none;}
.kvt-play-area{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5;pointer-events:none;}
.kvt-play-btn{width:68px;height:68px;border-radius:50%;background:rgba(255,255,255,.12);border:2px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;transition:all .3s cubic-bezier(.25,1,.5,1);opacity:0;transform:scale(.8);pointer-events:all;cursor:pointer;}
.kvt-play-btn.show{opacity:1;transform:scale(1);animation:kvt-ctrlIn .22s ease-out;}
.kvt-play-btn:hover{background:#C9A84C;border-color:#C9A84C;transform:scale(1.08);}
.kvt-play-btn:hover svg{fill:#1A0030;}
.kvt-play-btn svg{fill:#fff;transition:fill .2s;}
@media(hover:none) and (pointer:coarse){
  .kvt-play-btn{opacity:1!important;transform:scale(1)!important;background:rgba(201,168,76,.85);}
  .kvt-play-btn svg{fill:#1A0030;}
  .kvt-hint{display:none!important;}
}
.kvt-top-ctrl{position:absolute;top:24px;right:14px;z-index:7;display:flex;flex-direction:column;align-items:center;gap:8px;opacity:0;pointer-events:none;transition:opacity .22s;}
.kvt-top-ctrl.show{opacity:1;pointer-events:all;}
.kvt-ctrl-btn{width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,.55);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:13px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
.kvt-ctrl-btn:hover{background:rgba(201,168,76,.35);border-color:#C9A84C;}
.kvt-hint{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:.5px;text-transform:uppercase;background:rgba(0,0,0,.45);padding:3px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.08);white-space:nowrap;}
.kvt-info{position:absolute;bottom:0;left:0;right:0;padding:18px 16px 22px;z-index:4;}
.kvt-stars{display:flex;gap:3px;margin-bottom:9px;}
.kvt-quote{font-family:'Playfair Display',serif;font-size:13px;font-style:italic;font-weight:600;color:#fff;line-height:1.55;margin:0 0 14px;animation:kvt-quoteIn .4s cubic-bezier(.25,1,.5,1) both;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
.kvt-quote::before{content:'"';font-size:1.5em;line-height:0;vertical-align:-.35em;color:#C9A84C;margin-right:3px;opacity:.8;}
.kvt-identity{display:flex;align-items:center;gap:10px;animation:kvt-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;}
.kvt-avatar{width:38px;height:38px;border-radius:50%;border:2px solid rgba(201,168,76,.55);background:linear-gradient(135deg,#5E0E73,#6E1A85);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:#E8D5A0;flex-shrink:0;}
.kvt-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:3px;}
.kvt-meta{display:flex;align-items:center;gap:5px;flex-wrap:wrap;}
.kvt-pill{background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:8px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:2px 8px;border-radius:50px;}
.kvt-loc{font-size:10px;color:rgba(255,255,255,.4);}
.kvt-transition{position:absolute;inset:0;background:#120020;z-index:10;opacity:0;pointer-events:none;transition:opacity .28s;}
.kvt-transition.show{opacity:1;pointer-events:all;}
.kvt-queue{background:rgba(255,255,255,.025);border-left:1px solid rgba(255,255,255,.06);display:flex;flex-direction:column;overflow:hidden;}
.kvt-queue-header{padding:24px 24px 18px;border-bottom:1px solid rgba(255,255,255,.06);flex-shrink:0;}
.kvt-queue-title{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.3);}
.kvt-queue-list{flex:1;overflow-y:auto;padding:12px 0;scrollbar-width:thin;scrollbar-color:rgba(201,168,76,.2) transparent;}
.kvt-queue-list::-webkit-scrollbar{width:4px;}.kvt-queue-list::-webkit-scrollbar-thumb{background:rgba(201,168,76,.2);border-radius:2px;}
.kvt-q-item{display:flex;align-items:center;gap:14px;padding:12px 20px;cursor:pointer;transition:background .2s;border-left:3px solid transparent;}
.kvt-q-item:hover{background:rgba(255,255,255,.04);}
.kvt-q-item.active{background:rgba(201,168,76,.07);border-left-color:#C9A84C;}
.kvt-q-thumb{width:50px;height:74px;border-radius:10px;overflow:hidden;flex-shrink:0;position:relative;border:1px solid rgba(255,255,255,.07);display:flex;align-items:center;justify-content:center;transition:border-color .2s;}
.kvt-q-item.active .kvt-q-thumb{border-color:rgba(201,168,76,.4);}
.kvt-q-bg{position:absolute;inset:0;background:linear-gradient(155deg,#3A0847 0%,#5E0E73 60%,rgba(201,168,76,.25) 100%);}
.kvt-q-init{position:relative;z-index:1;font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:rgba(255,255,255,.75);}
.kvt-q-item.active .kvt-q-init{color:#E8D5A0;}
.kvt-q-eq-wrap{position:absolute;inset:0;background:rgba(13,0,24,.65);display:flex;align-items:center;justify-content:center;border-radius:9px;z-index:2;}
.kvt-q-eq{display:flex;align-items:flex-end;gap:2.5px;height:18px;}
.kvt-q-bar{width:3px;background:#C9A84C;border-radius:2px;animation:kvt-eqBar 1s ease-in-out infinite;}
.kvt-q-bar:nth-child(2){animation-delay:.18s;}.kvt-q-bar:nth-child(3){animation-delay:.36s;}
.kvt-q-info{flex:1;min-width:0;}
.kvt-q-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:3px;}
.kvt-q-item.active .kvt-q-name{color:#E8D5A0;}
.kvt-q-event{font-size:11px;color:rgba(255,255,255,.35);}
.kvt-q-num{font-size:11px;color:rgba(255,255,255,.2);flex-shrink:0;font-family:'Playfair Display',serif;}
.kvt-q-item.active .kvt-q-num{color:#C9A84C;font-weight:700;}
.kvt-queue-nav{padding:16px 20px;border-top:1px solid rgba(255,255,255,.06);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.kvt-nav-label{font-size:11px;color:rgba(255,255,255,.25);letter-spacing:1px;text-transform:uppercase;}
.kvt-nav-arrows{display:flex;gap:8px;}
.kvt-nav-btn{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.55);font-size:17px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
.kvt-nav-btn:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
.kvt-strip{padding:28px clamp(20px,5vw,60px) 56px;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;border-top:1px solid rgba(255,255,255,.05);position:relative;z-index:2;}
.kvt-ratings{display:flex;align-items:center;gap:28px;flex-wrap:wrap;}
.kvt-r-item{text-align:center;}
.kvt-r-num{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#C9A84C;line-height:1;}
.kvt-r-label{font-size:10px;color:rgba(255,255,255,.28);text-transform:uppercase;letter-spacing:1px;margin-top:4px;}
.kvt-r-sep{width:1px;height:36px;background:rgba(255,255,255,.06);}
.kvt-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#1A0030;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;flex-shrink:0;transition:transform .25s,opacity .25s;}
.kvt-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kvt-shine 3.5s ease infinite;pointer-events:none;}
.kvt-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#1A0030;}

/* ── Written Reviews ── */
.kt-sec{padding:100px 0 88px;background:#1A0030;position:relative;overflow:hidden;font-family:'DM Sans',sans-serif;}
.kt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 55% at 15% 5%,rgba(94,14,115,.32) 0%,transparent 65%),radial-gradient(ellipse 55% 45% at 85% 95%,rgba(201,168,76,.09) 0%,transparent 65%);pointer-events:none;}
.kt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:200px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:10px;}
.kt-h{font-family:'Playfair Display',serif;font-size:clamp(30px,4.5vw,52px);font-weight:700;line-height:1.15;color:#fff;margin:0;}
.kt-h span{color:#C9A84C;}
.kt-sub{color:rgba(255,255,255,.5);font-size:14px;line-height:1.75;margin:12px auto 0;max-width:500px;}
.kt-stats{display:flex;align-items:center;justify-content:center;gap:40px;margin-top:40px;flex-wrap:wrap;}
.kt-stat{text-align:center;}
.kt-sn{font-family:'Playfair Display',serif;font-size:34px;font-weight:700;color:#C9A84C;line-height:1;}
.kt-sl{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:1.5px;text-transform:uppercase;margin-top:5px;}
.kt-ssep{width:1px;height:44px;background:rgba(255,255,255,.08);}
.kt-feat{border-radius:28px;overflow:hidden;width:100%;height:100%;background:rgba(255,255,255,.04);border:1px solid rgba(201,168,76,.22);position:relative;}
.kt-feat::before{content:'';display:block;width:100%;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-feat-in{padding:30px 28px 26px;}
.kt-big-q{font-family:'Playfair Display',serif;font-size:130px;font-weight:900;line-height:.8;color:rgba(201,168,76,.055);position:absolute;top:20px;right:16px;user-select:none;pointer-events:none;}
.kt-fi-wrap{position:relative;width:100%;height:240px;overflow:hidden;border-radius:18px;margin-bottom:22px;}
.kt-fi{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
.kt-feat:hover .kt-fi{transform:scale(1.04);}
.kt-fi-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
.kt-fi-badge{position:absolute;bottom:14px;left:14px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;}
.kt-review{font-size:15px;color:rgba(255,255,255,.82);line-height:1.8;font-style:italic;margin:0 0 22px;}
.kt-div{height:1px;margin-bottom:18px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent);}
.kt-author{display:flex;align-items:center;gap:14px;}
.kt-avatar{width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2.5px solid rgba(201,168,76,.45);}
.kt-aname{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:#fff;}
.kt-aloc{font-size:11px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:.5px;margin-top:2px;}
.kt-v{margin-left:auto;flex-shrink:0;width:30px;height:30px;border-radius:50%;background:linear-gradient(135deg,#5E0E73,#C9A84C);display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;font-weight:700;}
.kt-prev{background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.08);border-radius:20px;overflow:hidden;cursor:pointer;transition:transform .3s;display:flex;flex-direction:column;flex:1;}
.kt-prev:hover{transform:translateY(-5px);background:rgba(255,255,255,.06);border-color:rgba(201,168,76,.28);}
.kt-pi{width:100%;height:155px;object-fit:cover;display:block;transition:transform .4s;filter:brightness(.8);}
.kt-prev:hover .kt-pi{transform:scale(1.04);filter:brightness(1);}
.kt-pb{padding:15px 17px;flex:1;display:flex;flex-direction:column;}
.kt-pt{font-size:12px;color:rgba(255,255,255,.55);line-height:1.65;font-style:italic;margin:8px 0 10px;flex:1;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
.kt-pn{font-size:13px;font-weight:700;color:rgba(255,255,255,.85);font-family:'Playfair Display',serif;}
.kt-pl{font-size:10px;color:rgba(255,255,255,.3);margin-top:2px;}
.kt-pr{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;color:#C9A84C;letter-spacing:1px;text-transform:uppercase;padding:4px 12px;border:1px solid rgba(201,168,76,.25);border-radius:50px;background:transparent;width:fit-content;transition:background .2s;}
.kt-prev:hover .kt-pr{background:rgba(201,168,76,.12);border-color:rgba(201,168,76,.5);}
.kt-nav{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:36px;}
.kt-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.15);border:none;cursor:pointer;transition:width .35s,background .35s;}
.kt-dot.on{width:34px;border-radius:4px;background:linear-gradient(90deg,#5E0E73,#C9A84C);}
.kt-arr{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:rgba(255,255,255,.6);font-size:20px;cursor:pointer;transition:transform .2s,background .2s;display:flex;align-items:center;justify-content:center;}
.kt-arr:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
.kt-plat{display:flex;justify-content:center;align-items:center;gap:32px;flex-wrap:wrap;margin-top:60px;padding:26px 44px;background:rgba(255,255,255,.025);border:1px solid rgba(255,255,255,.055);border-radius:22px;}
.kt-plat-item{text-align:center;}
.kt-plat-name{font-size:10px;color:rgba(255,255,255,.3);letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;}
.kt-plat-row{display:flex;align-items:center;gap:7px;}
.kt-plat-sc{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#fff;}
.kt-plat-cnt{font-size:10px;color:rgba(255,255,255,.25);margin-top:3px;}
.kt-psep{width:1px;height:40px;background:rgba(255,255,255,.07);}
.kt-cta{text-align:center;margin-top:60px;padding:52px 40px;background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5));border:1px solid rgba(201,168,76,.1);border-radius:28px;position:relative;overflow:hidden;}
.kt-cta::before{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:120px;height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-cta-h{font-family:'Playfair Display',serif;font-size:clamp(22px,3vw,32px);font-weight:700;color:#fff;margin:0 0 8px;}
.kt-cta-h span{color:#C9A84C;}
.kt-cta-sub{font-size:14px;color:rgba(255,255,255,.4);margin-bottom:28px;}
.kt-cta-row{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
.kt-btn-bk{background:linear-gradient(135deg,#5E0E73,#6E1A85);color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-block;transition:transform .25s,opacity .25s;}
.kt-btn-bk:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
.kt-btn-wa{background:#25D366;color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;transition:transform .25s,opacity .25s;}
.kt-btn-wa:hover{transform:translateY(-2px);opacity:.9;color:#fff;}

/* ── Responsive ── */
@media(max-width:1024px){
  .kvt-stage{grid-template-columns:1fr 280px;}
  .kvt-header,.kvt-strip{padding-left:32px;padding-right:32px;}
  .kvt-pane{padding-left:40px;}
  .svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}
}
/* ══ MOBILE HERO — video-first, full-screen ══════════════════════ */
@media(max-width:768px){

  /* Hero: stack video on top, text below — video is the star */
  .kp-hero{min-height:100svh;align-items:flex-start;overflow-x:clip;}
  .kp-hero-cnt{padding:0!important;width:100%;overflow:hidden;}

  /* Neutralize Bootstrap row negative margins that cause left-clip */
  .kp-hero .row{flex-direction:column-reverse!important;gap:0!important;margin-left:0!important;margin-right:0!important;}

  /* VIDEO COL — full width, tall */
  .kp-hero .col-lg-6:last-child{
    padding:0!important;
    width:100%!important;
    max-width:100%!important;
    flex:none!important;
  }
  .kp-hero-vid-wrap{
    width:100%!important;
    max-height:none!important;
    height:72svh!important;
    border-radius:0!important;
    border:none!important;
    border-bottom:2px solid rgba(201,168,76,.3)!important;
    aspect-ratio:unset!important;
  }

  /* TEXT COL — compact strip below video */
  .kp-hero .col-lg-6:first-child{
    width:100%!important;
    max-width:100%!important;
    flex:none!important;
    padding:20px 20px 24px!important;
    box-sizing:border-box!important;
  }
  .kp-hero-badge{font-size:10px;padding:6px 14px;margin-bottom:10px;}
  .kp-hero-title{font-size:clamp(24px,6.5vw,34px)!important;margin-bottom:10px;line-height:1.1;}
  .kp-hero-sub{display:none!important;}
  .kp-trust-row{display:none!important;}
  .kp-hero-float{display:none!important;}

  /* Buttons — side by side, compact */
  .kp-hero .col-lg-6:first-child>div[style]{flex-wrap:nowrap!important;gap:10px!important;}
  .kp-hero-cnt .cc-btn-gold{flex:1;justify-content:center;padding:12px 14px!important;font-size:13px!important;}
  .kp-hero-cnt .cc-btn-outline{flex:1;justify-content:center;padding:11px 14px!important;font-size:13px!important;}

  /* Section spacing */
  .kp-sec{padding:52px 0;}
  .kp-sec-sm{padding:28px 0;}

  /* Themes */
  .theme-card{width:200px;}.theme-img{height:240px;}

  /* Enquiry form */
  .enq-wrap .row{flex-direction:column;}
  .enq-left{order:2;padding:26px 22px;}
  .enq-right{order:1;padding:26px 22px;}

  /* Reels section */
  .kr-sec{padding:70px 0 80px;}
  .kr-header{margin-bottom:36px;}
  .kr-title{font-size:clamp(28px,7vw,38px);}

  /* Video testimonials */
  .kvt-stage{grid-template-columns:1fr;grid-template-rows:auto auto;}
  .kvt-pane{padding:32px 20px;min-height:480px;}
  .kvt-reel{width:min(250px,74%);}
  .kvt-queue{border-left:none;border-top:1px solid rgba(255,255,255,.06);max-height:none;}
  .kvt-queue-header{padding:14px 20px 10px;}
  .kvt-queue-list{display:flex;flex-direction:row;overflow-x:auto;overflow-y:hidden;padding:10px 16px 14px;gap:10px;-webkit-overflow-scrolling:touch;}
  .kvt-queue-list::-webkit-scrollbar{display:none;}
  .kvt-queue-nav{padding:12px 20px;}
  .kvt-q-item{flex-direction:column;align-items:center;text-align:center;min-width:84px;border-left:none;border-bottom:3px solid transparent;padding:8px;border-radius:12px;}
  .kvt-q-item.active{border-bottom-color:#C9A84C;border-left-color:transparent;}
  .kvt-q-thumb{width:50px;height:76px;}
  .kvt-q-num{display:none;}
  .kvt-header{padding:40px 20px 32px;}
  .kvt-header::after{left:20px;right:20px;}
  .kvt-strip{padding:20px 20px 36px;flex-direction:column;align-items:flex-start;}
  .kvt-r-sep{display:none;}

  /* Written reviews */
  .kt-sec{padding:64px 0 56px;}
  .kt-fi-wrap{height:200px;}
  .kt-ssep{display:none;}
  .kt-plat{gap:20px;padding:20px 24px;}
  .kt-psep{display:none;}
}

/* ══ 640px — phones ══════════════════════════════════════════════ */
@media(max-width:640px){
  .kp-hero-vid-wrap{height:75svh!important;}
  .kp-hero .col-lg-6:first-child{padding:16px 16px 20px!important;}
  .kp-hero-title{font-size:clamp(22px,6.5vw,28px)!important;}

  .kp-sec{padding:44px 0;}
  .container{padding-left:16px;padding-right:16px;}
  .cc-h{font-size:clamp(22px,6.5vw,30px);}
  .cc-btn,.cc-btn-gold,.cc-btn-outline,.wa-btn{min-height:46px;font-size:13px;}
  .theme-card{width:170px;}.theme-img{height:210px;}
  .svc-grid{grid-template-columns:1fr 1fr;gap:10px;}
  .svc-img-wrap{height:130px;}
  .kr-card{height:420px;}.kr-info h3{font-size:15px;}.kr-nav-btn{width:40px;height:40px;font-size:17px;}
  .enq-left,.enq-right{padding:18px 14px;}
  .enq-input{padding:11px 13px;font-size:13px;}
  .kp-faq-q{font-size:13px;padding:12px 16px;}
  .kp-faq-a{font-size:12px;padding:0 16px 12px;}
  .kvt-h{font-size:clamp(24px,7vw,32px);}
  .kt-feat-in{padding:20px 18px;}
  .kt-fi-wrap{height:170px;}
  .kt-review{font-size:13px;}
  .kt-cta{padding:32px 18px;}
  .kt-plat{padding:18px 16px;gap:16px;}

  /* Reel cards on small phones */
  .kvt-reel{width:min(220px,80%);}
}

/* ══ 400px — small/older phones ═════════════════════════════════ */
@media(max-width:400px){
  .kp-hero-vid-wrap{height:78svh!important;}
  .kp-hero-title{font-size:clamp(20px,6.5vw,24px)!important;}
  .cc-h{font-size:clamp(20px,7vw,26px);}
  .svc-grid{grid-template-columns:1fr;}
  .theme-card{width:150px;}
}

@media(hover:none) and (pointer:coarse){
  .theme-card:hover,.svc-card:hover,.act-card:hover,.kr-card:hover,.kt-prev:hover,.gal-bento-item:hover{transform:none!important;}
  .svc-card:hover::before,.act-card:hover::before,.gal-bento-item:hover::before{opacity:0!important;}
  .svc-card:hover .svc-img,.theme-card:hover .theme-img,.gal-bento-item:hover img{transform:none!important;}
  .svc-card:hover .svc-glow,.gal-bento-item:hover .gal-bento-ovl{opacity:0!important;}
  .kp-hero-float{animation:none!important;display:none!important;}
  .kp-ticker-track{animation-duration:40s!important;}
}
`;
/* ─── Static data ────────────────────────────────────────────────── */


/* ── Static data ── */
// const BD_THEMES=[
//   {name:"Cosmic Adventure",bookings:"412",tags:["Space","Adventure"],img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80",emoji:"🚀"},
//   {name:"Enchanted Forest",bookings:"356",tags:["Magic","Fantasy"],img:"https://images.unsplash.com/photo-1448375240586-882707db888b?w=600&q=80",emoji:"🌲"},
//   {name:"Tropical Paradise",bookings:"289",tags:["Tropical","Beach"],img:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=600&q=80",emoji:"🌴"},
//   {name:"Movie Night",bookings:"445",tags:["Cinema","Fun"],img:"https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=600&q=80",emoji:"🎬"},
//   {name:"Carnival Fiesta",bookings:"523",tags:["Party","Festive"],img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",emoji:"🎪"},
//   {name:"Retro Throwback",bookings:"267",tags:["Retro","Classic"],img:"https://images.unsplash.com/photo-1509805735646-2f72b3272a7d?q=80",emoji:"🕹️"},
// ];
const BD_THEMES = [
  // { name:"Royal Maharaja",    bookings:"312 bookings", tags:["Ethnic","Grand","Gold"],      img:theme1 },
  { name:"Joy Theatre",   bookings:"189 bookings", tags:["Dark","Stars","Neon"],        img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.22_PM_1_pldwyn.jpg" },
  // { name:"Joy Theatre", bookings:"276 bookings", tags:["Cute","Soft","Kids"],         img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.19_PM_1_y3dlud.jpg" },
  { name:"Royal Theatre",  bookings:"234 bookings", tags:["Nature","Lush","Boho"],       img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.24_PM_1_lwwaae.jpg" },
  { name:"Amora Theatre",    bookings:"158 bookings", tags:["Rustic","Flowers","Outdoor"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.27_PM_1_rswxuu.jpg" },
  { name:"Iris Theatre",  bookings:"198 bookings", tags:["1920s","Art Deco","Elegant"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.25_PM_4_diawmo.jpg" },
  {name:"Galaxy Theatre", bookings:"221 bookings", tags:["Beach","Bright","Relaxed"],    img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.25_PM_3_vrlsy1.jpg" },
  {name:"Bloom Theatre", bookings:"305 bookings", tags:["Fantasy","Whimsical","Grand"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.26_PM_3_mm0ugp.jpg" },
  {name:"Joy Theatre", bookings:"142 bookings", tags:["Boho","Eclectic","Colorful"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.26_PM_2_dztn3a.jpg" },
  {name:"Couple Cove Theatre", bookings:"167 bookings", tags:["Dark","Dramatic","Elegant"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.27_PM_xwu00r.jpg" },
  {name:"Lilac Theatre", bookings:"189 bookings", tags:["Colorful","Fun","Whimsical"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.29_PM_ta4p58.jpg" },
  {name:"Radiant Theatre", bookings:"173 bookings", tags:["Rustic","Cozy","Warm"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.30_PM_uzcfwp.jpg" },
  {name:"Modern Minimalist", bookings:"154 bookings", tags:["Sleek","Clean","Contemporary"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.29_PM_1_fgtfve.jpg" },
  {name:"Lyra", bookings:"198 bookings", tags:["Glamorous","Classic","Red Carpet"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.28_PM_mhltwy.jpg" },
  {name:"Carnival Den", bookings:"210 bookings", tags:["Carnival","Fun","Colorful"], img:"https://api.carnivalcastle.com/uploads/theatreImg/1765449525498-WhatsApp%20Image%202025-12-10%20at%205.56.04%20PM.jpeg" },
  {name:"Vibe Theatre", bookings:"195 bookings", tags:["Vibrant","Energetic","Trendy"], img:"https://api.carnivalcastle.com/uploads/theatreImg/1765450701857-WhatsApp%20Image%202025-12-11%20at%204.20.31%20PM%20(1).jpeg" },
];

const BD_ACTIVITIES=[
  {name:"Professional DJ",dur:"Full event",age:"All ages",img:"https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&q=80"},
  {name:"Photo Booth",dur:"Full event",age:"All ages",img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80"},
  {name:"Games & Activities",dur:"2 hours",age:"Customized",img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80"},
  {name:"Character Appearance",dur:"45 mins",age:"All ages",img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80"},
];
const BD_SERVICE_CARDS=[
  {label:"Themed Decor",img:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",desc:"Full themed decor — balloons, backdrops, props and custom installations."},
  {label:"Custom Cakes",img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",desc:"Personalized birthday cakes designed and crafted by our in-house bakers."},
  {label:"Food & Snacks",img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80",desc:"Kid-friendly and adult menus with vegetarian & non-veg catering options."},
  {label:"Photography",img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80",desc:"Professional candid photography & 4K videography — memories for life."},
];
const BD_REELS=[
  {views:"412K",title:"Fun Party",tag:"Carnival",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779221257/Celebrate_your_event_carnival_castle__Contact-_8341428342_9059382797Experience_the_most_unique_qjnpzy.mp4"},
  {views:"445K",title:"Cake Smash",tag:"Cute",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779734776/Experience_the_Best_and_unique_celebration_Place_in_Kondapur_Gachibowli_Hyderabad_Carnival_C_1_rmmctg.mp4"},
  {views:"289K",title:"DJ Night",tag:"Music",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779735470/Carnival_Castle_Hyderabad_s_Favorite_Celebration_Place_Make_every_moment_unforgettable_at_Carn_1_ocu5mc.mp4"},
  {views:"356K",title:"Family Celebration",tag:"Family",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779735474/Carnival_Castle_Hyderabad_s_Favorite_Celebration_Place_Make_every_moment_unforgettable_at_Carn_2_du1u6q.mp4"},
  {views:"523K",title:"Themed Birthday",tag:"Adventure",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779735707/Celebrate_your_celebrations_carnival_castle_hyderabad_and_make_your_celebration_more_memorable_pcxthz.mp4"},
  {views:"267K",title:"Grand Celebration",tag:"Premium",video:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779736076/Tired_of_the_same_old_birthday_plans_Ditch_the_crowded_restaurants_noisy_cafes_Surprise_your_x4qt0v.mp4"},
];
// const BD_VID_TESTI=[
//   {src:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",name:"Sakshi Reddy",event:"Enchanted Forest",loc:"Banjara Hills",quote:"The decorations were beautiful, the games were so fun, and everyone had an amazing time!",rating:5},
//   {src:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",name:"Rahul Sharma",event:"Movie Night",loc:"Jubilee Hills",quote:"The Movie Night theme was absolutely perfect! Professional setup, great DJ, awesome activities.",rating:5},
//   {src:"https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",name:"Priya Kumar",event:"Carnival Fiesta",loc:"Madhapur",quote:"Carnival Castle created the perfect vibe with amazing decor, great food, and fantastic entertainment.",rating:5},
//   {src:"/assets/videos/video4.mp4",name:"Arjun Mehta",event:"Royal Birthday",loc:"Kondapur",quote:"Booked the Royal Birthday package for my 30th and it was beyond all expectations.",rating:5},
//   {src:"/assets/videos/video5.mp4",name:"Deepika Rao",event:"Cosmic Adventure",loc:"Gachibowli",quote:"Every kid was completely blown away by the Cosmic Adventure setup. Out of this world!",rating:5},
// ];
const BD_VID_TESTI = [
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name: "Aisha & Rahul",
    event: "Anniversary Night",
    loc: "Banjara Hills",
    quote: "It was absolutely cinematic — every detail felt made just for us.",
    rating: 5
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
    name: "Karan Mehta",
    event: "Birthday Surprise",
    loc: "Jubilee Hills",
    quote: "She was completely speechless. The entire vibe was flawless.",
    rating: 5
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
    name: "Rohit & Priya",
    event: "Love Proposal",
    loc: "Kondapur",
    quote: "She said YES! The candles, the roses, the slideshow — perfect.",
    rating: 5
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name: "Sruthi Varma",
    event: "Bride To Be",
    loc: "Madhapur",
    quote: "Every single detail was taken care of. We're already planning our next event!",
    rating: 5
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
    name: "Divya Nair",
    event: "Mom To Be",
    loc: "Gachibowli",
    quote: "The team went above and beyond. My sister was in happy tears!",
    rating: 5
  }
];
const BD_REVIEWS=[
  {name:"Sakshi Reddy",location:"Banjara Hills",rating:5,occasion:"Enchanted Forest Theme",text:"The Enchanted Forest celebration was magical! The decorations were beautiful, the games were so fun, and everyone had an amazing time.",image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80",avatar:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80"},
  {name:"Rahul Sharma",location:"Jubilee Hills",rating:5,occasion:"Movie Night Theme",text:"The Movie Night theme was absolutely perfect! Professional setup, great DJ, awesome activities — the videographer captured everything beautifully.",image:"https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=500&q=80",avatar:"https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80"},
  {name:"Priya Kumar",location:"Madhapur",rating:5,occasion:"Carnival Fiesta",text:"Our celebration was incredible! Carnival Castle created the perfect vibe with amazing decor, great food, and fantastic entertainment.",image:"https://images.unsplash.com/photo-1544441452-326ff5a947fd?q=80",avatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80"},
  {name:"Arjun Mehta",location:"Kondapur",rating:5,occasion:"Royal Birthday",text:"Booked the Royal Birthday package for my 30th and it was beyond expectations. The DJ, the cake, and the whole ambiance was absolutely stunning.",image:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=500&q=80",avatar:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80"},
  {name:"Deepika Rao",location:"Gachibowli",rating:5,occasion:"Cosmic Adventure",text:"Cosmic Adventure theme for my son's 10th birthday was out of this world! Every kid was completely blown away by the setup.",image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80",avatar:"https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80"},
  {name:"Kiran Patel",location:"Kukatpally",rating:5,occasion:"Tropical Paradise",text:"Tropical Paradise theme was perfect for my daughter's sweet 16. The photo booth, the music, the food — every single detail was perfect.",image:"https://images.unsplash.com/photo-1519915212116-7cfef71f1d3e?w=500&q=80",avatar:"https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80"},
];
const BD_GALLERY=[
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796413/___._-_radhe_vastraz_hcwhii.webp",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796411/___._-_radhe_vastraz_2_tmxlox.webp",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796409/___._-_radhe_vastraz_3_gx6jc4.webp",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796409/Growing_through_what_I_go_through_.._birthdaybash_fyp%E3%82%B7%E3%82%9Aviral%E3%82%B7fyp%E3%82%B7%E3%82%9A_explorepage_aprilbirthdays_vrzgvr.jpg",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796408/Growing_through_what_I_go_through_.._birthdaybash_fyp%E3%82%B7%E3%82%9Aviral%E3%82%B7fyp%E3%82%B7%E3%82%9A_explorepage_aprilbirthdays_2_sgs7hp.jpg",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796409/Growing_through_what_I_go_through_.._birthdaybash_fyp%E3%82%B7%E3%82%9Aviral%E3%82%B7fyp%E3%82%B7%E3%82%9A_explorepage_aprilbirthdays_1_jndovf.jpg",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796408/Celebrate_your_special_day_in_a_unique_way_at_Carnival_Castle_Private_Theatres_Hyderabad_s_fav_1_rvkzzu.webp",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796408/Perhaps_the_last_The_picture_says_it_all_...Swipe_to_see_one_of_the_best_gift_...Deep_gratit_hldukh.webp",
  "https://res.cloudinary.com/dt3jzl980/image/upload/v1779796408/Perhaps_the_last_The_picture_says_it_all_...Swipe_to_see_one_of_the_best_gift_...Deep_gratit_1_l22tuf.webp"
];
const BD_FAQ=[
  {q:"Can I customize the celebration?",a:"Yes! Our team can work with you on customized themes, decorations, food, and entertainment options tailored to your vision."},
  {q:"How far in advance should I book?",a:"We recommend booking 2–3 weeks prior for better theme and slot availability, especially for weekends."},
  {q:"Can we customize the menu?",a:"Absolutely! Our team can work with you on customized food options and accommodate all dietary requirements."},
  {q:"Do you provide entertainment?",a:"Yes! We offer DJs, games, activities, character appearances, and more depending on the package selected."},
  {q:"Is photography included in all packages?",a:"Photography is included in all packages. Video coverage is available in Birthday Bash and Royal Birthday packages."},
];

/* ── Helpers ── */
function Stars({rating=5,size=13}){return <div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:size,color:n<=rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>;}
const scrollTo=id=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});

/* ── Isolated memo components ── */
const HeroVideo = memo(() => {
  const r = useRef(null);
  useEffect(() => {
    if (r.current) {
      r.current.muted = true;
      r.current.play().catch(() => {});
    }
  }, []);
  return (
    <div className="kp-hero-vid-wrap">
      <video 
        ref={r} 
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} 
        src="https://res.cloudinary.com/dt3jzl980/video/upload/v1779221257/Celebrate_your_event_carnival_castle__Contact-_8341428342_9059382797Experience_the_most_unique_qjnpzy.mp4" 
        muted 
        autoPlay 
        loop 
        playsInline 
        preload="none"
      />
      <div className="kp-hero-vid-ovl" />
      <div className="kp-hero-vid-badge">
        <div className="kp-hero-vid-pulse" />
        <span className="kp-hero-vid-label">🎉 Real Birthday Celebrations — Watch the Magic</span>
      </div>
    </div>
  );
});

const ThemeCarousel=memo(({navigate})=>{
  const [idx,setIdx]=useState(0);
  useEffect(()=>{const t=setInterval(()=>setIdx(i=>(i+1)%BD_THEMES.length),3500);return()=>clearInterval(t);},[]);
  return(
    <section className="kp-sec" style={{background:C.dark,overflow:"hidden"}}>
      <div className="container">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:44,flexWrap:"wrap",gap:20}}>
          <div><span className="cc-tag cc-tag-light">✦ 20+ Dream Themes ✦</span><h2 className="cc-h cc-h-white">Your Birthday, Your <span className="gold">Perfect Theme</span></h2></div>
          <div style={{display:"flex",gap:10}}>
            <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i-1+BD_THEMES.length)%BD_THEMES.length)}>‹</button>
            <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i+1)%BD_THEMES.length)}>›</button>
          </div>
        </div>
        <div style={{overflow:"hidden"}}>
          <div style={{display:"flex",gap:18,transition:"transform .7s cubic-bezier(.25,1,.5,1)",transform:`translateX(calc(-${idx*(280+18)}px))`}}>
            {[...BD_THEMES,...BD_THEMES].map((t,i)=>(
              <div key={i} className="theme-card" onClick={()=>navigate("/locations")}>
                <div className="kp-emoji-badge">{t.emoji}</div>
                <img src={t.img} alt={t.name} className="theme-img" loading="lazy"/>
                <div className="theme-ovl">
                  <div className="theme-name">{t.name}</div>
                  {/* <div className="theme-booked">🔥 {t.bookings} booked</div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>{t.tags.map((tg,j)=><span key={j} className="theme-tag">{tg}</span>)}</div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:26}}>
          {BD_THEMES.map((_,i)=><button key={i} onClick={()=>setIdx(i)} style={{width:i===idx?26:8,height:8,borderRadius:8,background:i===idx?C.gold:"rgba(255,255,255,.2)",border:"none",cursor:"pointer",transition:"all .4s"}}/>)}
        </div>
      </div>
    </section>
  );
});

const ReelsSection=memo(()=>{
  const [idx,setIdx]=useState(0);
  const [hovered,setHovered]=useState(false);
  const [vis,setVis]=useState(4);
  const tRef=useRef(null);
  useEffect(()=>{const u=()=>{const w=window.innerWidth;setVis(w<540?1:w<768?2:w<1100?3:4);};u();window.addEventListener("resize",u);return()=>window.removeEventListener("resize",u);},[]);
  const max=BD_REELS.length-vis;
  const start=useCallback(()=>{clearInterval(tRef.current);tRef.current=setInterval(()=>setIdx(i=>i>=max?0:i+1),3000);},[max]);
  useEffect(()=>{if(!hovered)start();else clearInterval(tRef.current);return()=>clearInterval(tRef.current);},[hovered,start]);
  const IGIcon=()=><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>;
  return(
    <section className="kr-sec">
      <div className="kr-orb" style={{width:460,height:460,background:"radial-gradient(circle,rgba(94,14,115,.28) 0%,transparent 70%)",top:-80,left:-80}}/>
      <div className="kr-orb" style={{width:320,height:320,background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)",bottom:-60,right:-40}}/>
      <div className="kr-container">
        <div className="kr-header">
          <div>
            <div className="kr-eyebrow"><div className="kr-eyebrow-line"/>Birthday Reels<div className="kr-eyebrow-line"/></div>
            <h2 className="kr-title">Watch the <em>Celebrations</em><br/>Come Alive</h2>
            <p className="kr-sub">Real birthdays. Real energy. Unforgettable moments from real celebrations.</p>
          </div>
          <div className="kr-nav">
            <button className="kr-nav-btn" onClick={()=>{setIdx(i=>Math.max(0,i-1));start();}}>‹</button>
            <button className="kr-nav-btn" onClick={()=>{setIdx(i=>i>=max?0:i+1);start();}}>›</button>
          </div>
        </div>
        <div className="kr-wrap" onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)}>
          <div className="kr-track" style={{transform:`translateX(${-(idx*280)}px)`}}>
            {BD_REELS.map((r,i)=>(
              <div key={i} className="kr-card">
                <video className="kr-video" src={r.video} autoPlay muted loop playsInline preload="none"/>
                <div className="kr-ovl"/>
                <div className="kr-views">👁 {r.views}</div>
                <div className="kr-play">▶</div>
                <div className="kr-info"><div className="kr-tag-pill">{r.tag}</div><h3>{r.title}</h3></div>
              </div>
            ))}
          </div>
        </div>
        <div className="kr-dots">
          {Array.from({length:BD_REELS.length-vis+1}).map((_,i)=>(
            <button key={i} className={`kr-dot${i===idx?" active":""}`} style={{width:i===idx?28:8}} onClick={()=>{setIdx(i);start();}}/>
          ))}
        </div>
        <div className="kr-cta">
          <a href="https://www.instagram.com/carnivalcastle.in" target="_blank" rel="noopener noreferrer" className="kr-btn-ig"><IGIcon/> Follow @carnivalcastle</a>
          <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kr-btn-gold">🎈 Book Your Birthday</a>
        </div>
      </div>
    </section>
  );
});

const VideoTestimonials=memo(()=>{
  const [ai,setAi]=useState(0);
  const [playing,setPlaying]=useState(false);
  const [progress,setProgress]=useState(0);
  const [trans,setTrans]=useState(false);
  const [showCtrl,setShowCtrl]=useState(false);
  const vRef=useRef(null),sRef=useRef(null),aRef=useRef(null),cRef=useRef(null);
  const cur=BD_VID_TESTI[ai];
  useEffect(()=>{const el=sRef.current;if(!el)return;const o=new IntersectionObserver(([e])=>{if(!e.isIntersecting){vRef.current?.pause();setPlaying(false);}},{threshold:.25});o.observe(el);return()=>o.disconnect();},[]);
  useEffect(()=>{const v=vRef.current;if(!v)return;v.pause();v.currentTime=0;v.muted=false;setPlaying(false);setProgress(0);},[ai]);
  useEffect(()=>{const v=vRef.current;if(!v)return;const t=()=>{if(v.duration)setProgress((v.currentTime/v.duration)*100);};const e=()=>{setPlaying(false);setProgress(0);};v.addEventListener("timeupdate",t);v.addEventListener("ended",e);return()=>{v.removeEventListener("timeupdate",t);v.removeEventListener("ended",e);};},[ai]);
  const sc=()=>{setShowCtrl(true);clearTimeout(cRef.current);cRef.current=setTimeout(()=>setShowCtrl(false),2500);};
  const isTouchDevice=()=>window.matchMedia("(hover:none) and (pointer:coarse)").matches;
  const onEnter=()=>{if(isTouchDevice())return;sc();const v=vRef.current;if(v&&!playing){v.muted=false;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
  const onLeave=()=>{if(isTouchDevice())return;setShowCtrl(false);clearTimeout(cRef.current);if(vRef.current&&playing){vRef.current.pause();setPlaying(false);}};
  const toggleVideo=()=>{const v=vRef.current;if(!v)return;if(playing){v.pause();v.muted=false;setPlaying(false);}else{v.muted=false;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
  const onReelClick=()=>{sc();toggleVideo();};
  const tog=e=>{e.stopPropagation();toggleVideo();};
  const goTo=useCallback(i=>{if(i===ai||trans)return;setTrans(true);setTimeout(()=>{setAi(i);setTrans(false);},300);},[ai,trans]);
  useEffect(()=>{if(!playing){aRef.current=setInterval(()=>setAi(i=>(i+1)%BD_VID_TESTI.length),5000);}else{clearInterval(aRef.current);}return()=>clearInterval(aRef.current);},[playing]);
  return(
    <section className="kvt-sec" ref={sRef}>
      <div className="kvt-header">
        <div><div className="kvt-eyebrow"><div className="kvt-eyebrow-line"/>Guest Stories<div className="kvt-eyebrow-line"/></div><h2 className="kvt-h">Real Guests,<br/><em>Real Joy</em></h2></div>
        <div className="kvt-counter"><span>{String(ai+1).padStart(2,"0")}</span>{" / "+String(BD_VID_TESTI.length).padStart(2,"0")}</div>
      </div>
      <div className="kvt-stage">
        <div className={`kvt-transition${trans?" show":""}`}/>
        <div className="kvt-pane">
          <div className={`kvt-glow${playing?" active":""}`}/>
          <div className={`kvt-reel${playing?" playing":""}`} onMouseEnter={onEnter} onMouseLeave={onLeave} onMouseMove={sc} onClick={onReelClick}>
            <div className="kvt-notch"/>
            <div className="kvt-prog"><div className="kvt-prog-fill" style={{width:`${progress}%`}}/></div>
            <video key={ai} ref={vRef} className="kvt-video" src={cur.src} muted={false} playsInline preload="metadata"/>
            <div className="kvt-ovl"/>
            {!playing&&<div className="kvt-pulse-ring"/>}
            {!playing&&(
              <div className="kvt-play-area">
                <button className="kvt-play-btn show" onClick={tog}><svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></button>
              </div>
            )}
            <div className="kvt-info" key={ai}>
              <div className="kvt-stars">{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:13,color:n<=cur.rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>
              <div className="kvt-identity">
                <div className="kvt-avatar">{cur.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</div>
                <div><div className="kvt-name">{cur.name}</div></div>
              </div>
            </div>
          </div>
        </div>
        <div className="kvt-queue">
          <div className="kvt-queue-header"><div className="kvt-queue-title">Up Next</div></div>
          <div className="kvt-queue-list">
            {BD_VID_TESTI.map((t,i)=>(
              <div key={i} className={`kvt-q-item${i===ai?" active":""}`} onClick={()=>goTo(i)}>
                <div className="kvt-q-thumb"><div className="kvt-q-bg"/><span className="kvt-q-init">{t.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</span>
                  {i===ai&&playing&&<div className="kvt-q-eq-wrap"><div className="kvt-q-eq"><div className="kvt-q-bar"/><div className="kvt-q-bar"/><div className="kvt-q-bar"/></div></div>}
                </div>
                <div className="kvt-q-info"><div className="kvt-q-name">{t.name}</div><div className="kvt-q-event">{t.event} · {t.loc}</div></div>
                <div className="kvt-q-num">{String(i+1).padStart(2,"0")}</div>
              </div>
            ))}
          </div>
          <div className="kvt-queue-nav">
            <span className="kvt-nav-label">Navigate</span>
            <div className="kvt-nav-arrows">
              <button className="kvt-nav-btn" onClick={()=>goTo((ai-1+BD_VID_TESTI.length)%BD_VID_TESTI.length)}>‹</button>
              <button className="kvt-nav-btn" onClick={()=>goTo((ai+1)%BD_VID_TESTI.length)}>›</button>
            </div>
          </div>
        </div>
      </div>
      <div className="kvt-strip">
        <div className="kvt-ratings">
          {[{num:"4.9★",label:"Google"},{num:"4.8★",label:"Facebook"},{num:"4000+",label:"Parties"},{num:"99%",label:"Happy Guests"}].map((item,i,arr)=>(
            <React.Fragment key={i}>{i>0&&<div className="kvt-r-sep"/>}<div className="kvt-r-item"><div className="kvt-r-num">{item.num}</div><div className="kvt-r-label">{item.label}</div></div></React.Fragment>
          ))}
        </div>
        <button onClick={()=>scrollTo("enquiry")} className="kvt-btn-gold">🎈 Book Your Birthday</button>
      </div>
    </section>
  );
});

const WrittenReviews=memo(()=>{
  const [ai,setAi]=useState(0);
  const aRef=useRef(null);
  const start=()=>{clearInterval(aRef.current);aRef.current=setInterval(()=>setAi(i=>(i+1)%BD_REVIEWS.length),4800);};
  useEffect(()=>{start();return()=>clearInterval(aRef.current);},[]);
  const goTo=i=>{setAi((i+BD_REVIEWS.length)%BD_REVIEWS.length);clearInterval(aRef.current);start();};
  const cur=BD_REVIEWS[ai];
  const prev=BD_REVIEWS[(ai-1+BD_REVIEWS.length)%BD_REVIEWS.length];
  const next=BD_REVIEWS[(ai+1)%BD_REVIEWS.length];
  const avg=(BD_REVIEWS.reduce((s,r)=>s+r.rating,0)/BD_REVIEWS.length).toFixed(1);
  return(
    <section className="kt-sec">
      <div className="container" style={{position:"relative",zIndex:1}}>
        <div className="text-center">
          <span className="kt-tag">✦ Guest Stories ✦</span>
          <h2 className="kt-h">Real Parties,<br/><span>Real Happy Guests</span></h2>
          <p className="kt-sub">Hear from our guests — their joy, their stories, their most memorable birthday moments.</p>
        </div>
        <div className="kt-stats">
          <div className="kt-stat"><div className="kt-sn">{avg}</div><div style={{display:"flex",justifyContent:"center",gap:2,margin:"5px 0 4px"}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div><div className="kt-sl">Average Rating</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">4000+</div><div className="kt-sl">Celebrations</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">99%</div><div className="kt-sl">Would Return</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">4.9</div><div className="kt-sl">Google Rating</div></div>
        </div>
        <div style={{marginTop:56}}>
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7" style={{display:"flex"}}>
              <div className="kt-feat">
                <div className="kt-big-q">"</div>
                <div className="kt-feat-in">
                  <div className="kt-fi-wrap"><img key={ai} src={cur.image} alt={cur.name} className="kt-fi" loading="lazy"/><div className="kt-fi-ovl"/><div className="kt-fi-badge">🎉 {cur.occasion}</div></div>
                  <div style={{marginBottom:14}}><Stars rating={cur.rating} size={15}/></div>
                  <p className="kt-review">"{cur.text}"</p>
                  <div className="kt-div"/>
                  <div className="kt-author">
                    <img src={cur.avatar} alt={cur.name} className="kt-avatar" loading="lazy"/>
                    <div><div className="kt-aname">{cur.name}</div><div className="kt-aloc">{cur.location}</div></div>
                    <div className="kt-v">✓</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5" style={{display:"flex",flexDirection:"column",gap:16}}>
              {[prev,next].map((rv,i)=>(
                <div key={i} className="kt-prev" onClick={()=>goTo(i===0?(ai-1+BD_REVIEWS.length)%BD_REVIEWS.length:(ai+1)%BD_REVIEWS.length)}>
                  <img src={rv.image} alt={rv.name} className="kt-pi" loading="lazy"/>
                  <div className="kt-pb"><Stars rating={rv.rating} size={11}/><p className="kt-pt">"{rv.text}"</p><div className="kt-pn">{rv.name}</div><div className="kt-pl">{rv.location}</div><span className="kt-pr">Read Full →</span></div>
                </div>
              ))}
            </div>
          </div>
          <div className="kt-nav">
            <button className="kt-arr" onClick={()=>goTo(ai-1)}>‹</button>
            {BD_REVIEWS.map((_,i)=><button key={i} className={`kt-dot${i===ai?" on":""}`} onClick={()=>goTo(i)}/>)}
            <button className="kt-arr" onClick={()=>goTo(ai+1)}>›</button>
          </div>
        </div>
        <div className="kt-plat">
          {[{name:"Google",score:"4.9",count:"200+ reviews"},{name:"Facebook",score:"4.8",count:"150+ reviews"},{name:"JustDial",score:"4.7",count:"80+ reviews"},{name:"Instagram",score:"5.0",count:"50k+ followers"}].map((p,i)=>(
            <React.Fragment key={i}>{i>0&&<div className="kt-psep"/>}
              <div className="kt-plat-item"><div className="kt-plat-name">{p.name}</div><div className="kt-plat-row"><span className="kt-plat-sc">{p.score}</span><div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div></div><div className="kt-plat-cnt">{p.count}</div></div>
            </React.Fragment>
          ))}
        </div>
        <div className="kt-cta">
          <h3 className="kt-cta-h">Ready to Make It <span>Unforgettable?</span></h3>
          <p className="kt-cta-sub">Join 4000+ happy guests who celebrated their most special birthday moments with us.</p>
          <div className="kt-cta-row">
            <button onClick={()=>scrollTo("enquiry")} className="kt-btn-bk">🎈 Book My Birthday</button>
            <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kt-btn-wa"><i className="bi bi-whatsapp"/> Chat With Us</a>
          </div>
        </div>
      </div>
    </section>
  );
});

const ScrollRevealWatcher=memo(()=>{
  useEffect(()=>{
    const o=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting)x.target.classList.add("in");}),{threshold:.08});
    const run=()=>document.querySelectorAll(".rv:not(.in)").forEach(el=>o.observe(el));
    run();const t=setTimeout(run,600);
    return()=>{o.disconnect();clearTimeout(t);};
  },[]);
  return null;
});

function GalleryEntranceObserver(){
  useEffect(()=>{
    const items=document.querySelectorAll(".gal-bento-item");
    const o=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){const i=Array.from(items).indexOf(e.target);e.target.style.transitionDelay=`${i*.08}s`;e.target.classList.add("in");o.unobserve(e.target);}});},{threshold:.1});
    items.forEach(el=>o.observe(el));return()=>o.disconnect();
  },[]);
  return null;
}

/* ── Main Page ── */
export default function BirthdayCelebrationPage(){
  const [loading,setLoading]=useState(true);
  const [faq,setFaq]=useState(null);
  const [showPopup,setShowPopup]=useState(false);
  const [popupImg,setPopupImg]=useState("");
  const [galIdx,setGalIdx]=useState(0);
  const [form,setForm]=useState({name:"",email:"",mobileNumber:"",age:"",theme:"",date:"",guests:""});
  const galRef=useRef(null);
  const navigate=useNavigate();

  useEffect(()=>{setTimeout(()=>setLoading(false),400);},[]);
  const onChange=useCallback(e=>setForm(f=>({...f,[e.target.name]:e.target.value})),[]);
  const onSubmit=useCallback(e=>{e.preventDefault();toast.success("🎉 Awesome! We'll call you within 2 hours to plan the perfect birthday!");setForm({name:"",email:"",mobileNumber:"",age:"",theme:"",date:"",guests:""});},[]);
  const galItem=useCallback(src=><img src={src} alt="" style={{width:"100%",display:"block",borderRadius:14}}/>,[]);
  const galThumb=useCallback(src=><img src={src} alt="" style={{width:58,height:58,objectFit:"cover",display:"block",borderRadius:8}}/>,[]);

  if(loading)return(
    <div style={{background:C.dark,height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:18}}>
      <div style={{width:68,height:68,border:`4px solid ${C.primaryPale}`,borderTop:`4px solid ${C.gold}`,borderRadius:"50%",animation:"_spin 1s linear infinite"}}/>
      <p style={{color:C.gold,fontWeight:600,letterSpacing:2,fontSize:14}}>Loading Magic…</p>
      <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return(
    <>
      <style>{GLOBAL_CSS}</style>
      <Helmet>
        <title>Carnival Castle | Unforgettable Birthday Celebrations in Hyderabad</title>
        <meta name="description" content="Themed birthday celebrations — Cosmic, Carnival, Movie Night & 20+ themes. Premium packages from ₹7,999."/>
      </Helmet>
      <ScrollRevealWatcher/>
      <div className="kp-root">
        <Header/>
        <div className="kp-ticker"><div className="kp-ticker-track">
          {[...Array(4)].map((_,k)=>["🎂 20+ Stunning Themes","⭐ 4000+ Celebrations","🎈 Professional Photography","🎵 DJ & Live Music","⚡ Book in 2 Minutes","🎉 Custom Cakes Available"].map((item,i)=><span key={`${k}-${i}`} className="kp-ticker-item">{item}</span>))}
        </div></div>

        {/* Hero */}
       <section className="kp-hero">
  <div className="kp-hero-orb" style={{width:500,height:500,background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`,top:-100,right:-80}}/>
  <div className="kp-hero-orb" style={{width:300,height:300,background:"radial-gradient(circle,rgba(245,158,11,.16) 0%,transparent 70%)",bottom:80,left:-60}}/>
  <div className="container kp-hero-cnt">
    <div className="row align-items-center g-5">
      <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both"}}>
        <div className="kp-hero-badge">🎉 Hyderabad's #1 Birthday Venue</div>
        <h1 className="kp-hero-title pf">Celebrate Your <span>Big Day</span><br/>in Unforgettable Style</h1>
        <p className="kp-hero-sub">From cosmic adventures to carnival fiestas — 20+ incredible themes, professional setups, and memories you'll relive for years to come.</p>
        <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
          <button onClick={()=>scrollTo("enquiry")} className="cc-btn-gold">🎈 Explore Packages</button>
          <button onClick={()=>scrollTo("enquiry")} className="cc-btn-outline" style={{borderColor:"rgba(255,255,255,.4)",color:"#fff"}}>📞 Callback</button>
        </div>
        <div className="kp-trust-row">
          {[["50k+","Celebrations"],["4.9★","Rating"],["15+","Themes"]].map(([n,l])=>(
            <div key={l} className="kp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
          ))}
        </div>
      </div>
      <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both"}}>
        <div style={{position:"relative"}}>
          <HeroVideo/>
          {/* <div className="kp-hero-float d-none d-md-block" style={{bottom:80,left:-28,animationDelay:"0s"}}>
            <div style={{fontSize:10,color:"#888",marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>Just Booked!</div>
            <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>🎪</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>Carnival Fiesta</div><div style={{fontSize:11,color:C.primary}}>Rahul's 25th Birthday</div></div></div>
          </div> */}
          <div className="kp-hero-float d-none d-md-block" style={{top:32,right:-28,animationDelay:"1.5s"}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>⭐</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>4.9 / 5.0</div><div style={{fontSize:11,color:"#888"}}>50000+ Celebrations</div></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        <ReelsSection/>
        <VideoTestimonials/>
        <ThemeCarousel navigate={navigate}/>

        {/* Services */}
        <section className="kp-sec" style={{background:"#fff",overflow:"hidden"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Party Services ✦</span>
              <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Birthday</h2>
              <p className="cc-sub">Decor, cakes, food, photography — every detail handled so you can enjoy every moment.</p>
            </div>
            <div className="kp-divider"><div className="kp-dl"/><div className="kp-dg"/><div className="kp-dl"/></div>
            <div className="svc-grid rv">
              {BD_SERVICE_CARDS.map((s,i)=>(
                <div key={i} className="svc-card">
                  <div className="svc-img-wrap"><img src={s.img} alt={s.label} className="svc-img" loading="lazy"/><div className="svc-glow"/><div className="svc-num">0{i+1}</div><div className="svc-pill">{["✨ Custom","🎂 Bespoke","🍽️ Fresh","📸 Pro"][i]}</div></div>
                  <div className="svc-body"><div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div><div className="svc-title pf">{s.label}</div><span className="svc-line"/><p className="svc-desc">{s.desc}</p></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Activities */}
        {/* <section className="kp-sec" style={{background:C.cream}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Fun Experiences ✦</span>
              <h2 className="cc-h">Keep the Energy <span>Going All Night</span></h2>
            </div>
            <div className="row g-4">
              {BD_ACTIVITIES.map((act,i)=>(
                <div key={i} className={`col-md-3 col-6 rv d${i+1}`}>
                  <div className="act-card">
                    <div style={{overflow:"hidden",height:185}}><img src={act.img} alt={act.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} loading="lazy"/></div>
                    <div style={{padding:"14px"}}><h3 style={{fontSize:15,fontWeight:700,marginBottom:5,color:C.dark}}>{act.name}</h3><div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888"}}><span>⏱️ {act.dur}</span><span>🎂 {act.age}</span></div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* <WrittenReviews/> */}
     
<TestimonialsSection/>

        {/* Gallery */}
        {/* <section className="kp-sec" style={{background:C.primaryPale,overflow:"hidden"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:50}}>
              <span className="cc-tag">✦ Birthday Gallery ✦</span>
              <h2 className="cc-h">Real Memories from <span>Real Celebrations</span></h2>
              <p className="cc-sub">Captured highlights from birthdays we've had the pleasure of making unforgettable.</p>
            </div>
            <div className="gal-bento rv">
              {BD_GALLERY.map((img,i)=>(
                <div key={i} className={`gal-bento-item gbi-${i+1}`} onClick={()=>{setGalIdx(i);galRef.current?.show();}}>
                  <img src={img} alt={`Celebration ${i+1}`} loading="lazy"/><div className="gal-bento-ovl">🔍</div>
                </div>
              ))}
            </div>
            <Galleria ref={galRef} value={BD_GALLERY} numVisible={5} activeIndex={galIdx} onItemChange={e=>setGalIdx(e.index)} circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb}/>
            <div style={{display:"flex",gap:14,justifyContent:"center",marginTop:34,flexWrap:"wrap"}}>
              <a href="/locations" className="cc-btn">Book Your Birthday →</a>
              <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/> Chat With Us</a>
            </div>
          </div>
          <GalleryEntranceObserver/>
        </section> */}
        {/* Gallery */}
<section className="kp-sec" style={{background:C.primaryPale,overflow:"hidden"}}>
  <div className="container">
    <div className="text-center rv" style={{marginBottom:50}}>
      <span className="cc-tag">✦ Birthday Gallery ✦</span>
      <h2 className="cc-h">Real Memories from <span>Real Celebrations</span></h2>
      <p className="cc-sub">Captured highlights from birthdays we've had the pleasure of making unforgettable.</p>
    </div>
    <div className="gal-bento rv">
      {BD_GALLERY.map((img,i)=>(
        <div key={i} className="gal-bento-item" onClick={()=>{setGalIdx(i);galRef.current?.show();}}>
          <img src={img} alt={`Celebration ${i+1}`} loading="lazy"/>
          <div className="gal-bento-ovl">🔍</div>
        </div>
      ))}
    </div>
    <Galleria ref={galRef} value={BD_GALLERY} numVisible={5} activeIndex={galIdx} onItemChange={e=>setGalIdx(e.index)} circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb}/>
    <div style={{display:"flex",gap:14,justifyContent:"center",marginTop:34,flexWrap:"wrap"}}>
      <button onClick={()=>scrollTo("enquiry")} className="cc-btn-gold">🎈 Book Your Birthday →</button>
      <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/> Chat With Us</a>
    </div>
  </div>
  <GalleryEntranceObserver/>
</section>

        <CouponSection/>

        {/* Enquiry */}
        <section id="enquiry" className="kp-sec" style={{background:C.beige}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Book Your Birthday ✦</span>
              <h2 className="cc-h">Plan the Celebration <span>of Your Dreams</span></h2>
              <p className="cc-sub">Fill in the details and our birthday specialist will call you within 2 hours.</p>
            </div>
            <div className="enq-wrap rv" style={{maxWidth:980,margin:"0 auto"}}>
              <div className="row g-0">
                <div className="col-lg-4">
                  <div className="enq-left h-100">
                    <div>
                      <h3 className="pf" style={{color:"#fff",fontSize:23,fontWeight:700,marginBottom:8}}>Let's Create <span style={{color:C.goldLight}}>Magic</span> Together</h3>
                      <p style={{color:"rgba(255,255,255,.58)",fontSize:13,lineHeight:1.7,marginBottom:24}}>Share your birthday details and we'll craft an unforgettable celebration experience.</p>
                    </div>
                    <div>
                      {[{icon:"⚡",label:"2-Hour Callback",val:"We call within 2 hours"},{icon:"🎨",label:"Free Theme Consult",val:"Expert advice included"},{icon:"💰",label:"Price Match",val:"Best price guaranteed"},{icon:"💬",label:"WhatsApp Us",val:"+91 8374777834",href:"https://wa.me/918374777834"}].map((it,i)=>(
                        <div key={i} className="enq-contact-info"><div className="enq-ci-icon">{it.icon}</div><div><div className="enq-ci-label">{it.label}</div>{it.href?<a href={it.href} style={{color:"#fff",fontWeight:500,fontSize:13,textDecoration:"none"}}>{it.val}</a>:<span style={{color:"#fff",fontWeight:500,fontSize:13}}>{it.val}</span>}</div></div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="enq-right">
                    <h3 className="pf" style={{fontSize:21,fontWeight:700,color:C.dark,marginBottom:4}}>Book Your <span style={{color:C.primary}}>Birthday!</span></h3>
                    <p style={{color:"#aaa",fontSize:13,marginBottom:22}}>Free callback within 2 hours • No obligation</p>
                    <form onSubmit={onSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6"><label className="enq-label">Your Name *</label><input type="text" name="name" className="enq-input" placeholder="e.g. Rahul Sharma" value={form.name} onChange={onChange} required/></div>
                        <div className="col-md-6"><label className="enq-label">Phone Number *</label><input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={onChange} required/></div>
                        <div className="col-md-6"><label className="enq-label">Email Address</label><input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={onChange}/></div>
                        <div className="col-md-6"><label className="enq-label">Birthday Person's Age</label><input type="text" name="age" className="enq-input" placeholder="e.g. Turning 25" value={form.age} onChange={onChange}/></div>
                        <div className="col-md-6"><label className="enq-label">Preferred Theme *</label><select name="theme" className="enq-input" value={form.theme} onChange={onChange} required><option value="">Choose a theme…</option>{BD_THEMES.map((t,i)=><option key={i} value={t.name}>{t.emoji} {t.name}</option>)}</select></div>
                        <div className="col-md-6"><label className="enq-label">Party Date *</label><input type="date" name="date" className="enq-input" value={form.date} onChange={onChange} required/></div>
                        <div className="col-12"><label className="enq-label">Number of Guests *</label><select name="guests" className="enq-input" value={form.guests} onChange={onChange} required><option value="">How many guests are coming?</option><option>Up to 15 guests</option><option>16–30 guests</option><option>31–50 guests</option><option>50+ guests</option></select></div>
                        <div className="col-12" style={{marginTop:4}}>
                          <button type="submit" className="cc-btn-gold" style={{width:"100%",justifyContent:"center",padding:"15px",fontSize:15}}>🎉 Request a Free Callback 🎉</button>
                          <p style={{textAlign:"center",fontSize:11,color:"#aaa",marginTop:10}}>No spam. We'll call to discuss your birthday and that's it.</p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="kp-sec" style={{background:"#fff"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ FAQ ✦</span>
              <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
            </div>
            <div className="row justify-content-center"><div className="col-lg-8">
              {BD_FAQ.map((q,i)=>(
                <div key={i} className={`kp-faq-item${faq===i?" open":""}`} onClick={()=>setFaq(faq===i?null:i)}>
                  <div className="kp-faq-q"><span>{q.q}</span><div className="kp-faq-arrow">▾</div></div>
                  {faq===i&&<div className="kp-faq-a">{q.a}</div>}
                </div>
              ))}
            </div></div>
          </div>
        </section>

        {/* CTA */}
        <section className="kp-cta-sec kp-sec-sm">
          <div className="container text-center" style={{position:"relative",zIndex:1}}>
            <span style={{fontSize:50}}>🎂</span>
            <h2 className="pf" style={{fontSize:"clamp(24px,4vw,42px)",color:"#fff",fontWeight:900,marginTop:12,marginBottom:12}}>
              Ready to Make It <span style={{background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Unforgettable?</span>
            </h2>
            <p style={{color:"rgba(255,255,255,.63)",fontSize:15,marginBottom:26,maxWidth:460,margin:"0 auto 26px"}}>Book your birthday celebration today. We handle everything so you just celebrate.</p>
            <button className="cc-btn-gold" style={{fontSize:15,padding:"15px 40px"}} onClick={()=>scrollTo("enquiry")}>🎈 Book Your Birthday Now</button>
            <p style={{color:"rgba(255,255,255,.32)",fontSize:12,marginTop:12}}>Join 4000+ happy guests who celebrated with us</p>
          </div>
        </section>

        <Footer/>
        <ToastContainer position="top-center" autoClose={4000} theme="dark"/>
        <PopupModal show={showPopup} handleClose={()=>setShowPopup(false)} image={popupImg}/>
      </div>
    </>
  );
}